<template>
  <div>
    <!-- <el-button @click="addList" plain type="primary" style="margin-bottom: 16px" v-show="!disabled" size="small">增行</el-button> -->
    <div style="display: flex;justify-content: space-between;align-items: center; margin-bottom: 16px">
      <div>
        <el-button plain type="primary" size="small" v-if="!disabled && ofoFlowWork.isMultiple == '0'" @click="selectMore(false)">多选</el-button>
        <el-button plain type="primary" size="small" v-if="ofoFlowWork.thingtype && !disabled && ofoFlowWork.isMultiple == '0'" @click="selectThingMore(false)">明细多选</el-button>
        <el-button size="small" type="info" plain @click="copyFromAdd" v-if="(ofoFlowWork.beforework || ofoFlowWork.cfbeforework) && !disabled">复制从</el-button>
        <el-button size="small" type="success" plain @click="getCopyCheckWorkList" v-if="(ofoFlowWork.beforecopy == '4') && !disabled">活动核销</el-button>
        <el-button plain type="danger" size="small" v-if="!disabled" @click="deleteMore" :disabled="!selectedId.length && !selectedIdThing.length">删除已选</el-button>
        <template v-if="!disabled && ofoFlowWork.kindtype && !ofoFlowWork.kindtype.includes(',')">
          <el-button size="small" type="warning" icon="el-icon-download" @click="importBtn">导入</el-button>
        </template>
        <el-button plain size="small" type="success" @click="changeExpand1" v-if="ofoFlowWork.isCalBom == '0' || ofoFlowWork.thingtype">{{isExpand1 ? '一键收起' : '一键展开'}}</el-button>
        <el-checkbox v-if="!disabled" style="margin-left:10px" v-model="isRepeat">可重复资源</el-checkbox>
        <el-checkbox v-if="!disabled && ofoFlowWork.isCalcBom === '0'" @change="changeShowBomStock" style="margin-left:5px" v-model="isShowBomStock">BOM物料库存</el-checkbox>
        <i v-if="isShowBomStock && ofoFlowWork.isCalcBom === '0'" @click="getProductsStock" style="cursor: pointer;color: cornflowerblue;margin-left: 5px" class="el-icon-refresh"></i>
      </div>
      <div>
        <el-switch v-model="isTax" inactive-text="含税" v-show="!disabled && (ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5')" ></el-switch>
        <el-dropdown :hide-on-click="false" trigger="click" ref="dropdown">
          <span class="el-dropdown-link">
            <!-- <i class="el-icon-thumb el-icon--right" style="font-size:14px;" v-if="disabled">资源行显示</i> -->
            <el-tooltip class="item" effect="dark" content="资源行显示" placement="top-start">
              <el-button type="text" icon="el-icon-menu" v-if="disabled"></el-button>
            </el-tooltip>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) in checkResShow" :key="index">
              <el-checkbox v-model="item.value" @change="changeResShow">{{item.label}}</el-checkbox>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 新增时可编辑的表格 -->
    <template v-if="!disabled">
      <el-table
        style="width: 100%"
        :data="productsList"
        :header-cell-style="{background:'#F9F9FB',color:'#606266','text-align': 'center'}"
        @selection-change="handleRowChange"
        @row-click="handleRowSelect"
        ref="multipleTable"
        key="table1"
        border
        :row-key="getRowKey"
        :default-expand-all="isExpand1"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :summary-method="getSummaries"
        show-summary>
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="expand" v-if="ofoFlowWork.thingtype">
          <template slot-scope="props">
            <el-table
              v-if="thingsList.filter(item => item.uuid ? item.uuid === props.row.uuid : item.ofrresourceId == props.row.ofrresourceId ).length"
              :data="thingsList.filter(item => item.uuid ? item.uuid === props.row.uuid : item.ofrresourceId == props.row.ofrresourceId )"
              :header-cell-style="{background:'#F9F9FB',color:'#606266','text-align': 'center'}" @selection-change="handleRowChangeThing"
              :key="'table2' + props.$index"
              border
              style="margin-left:100px;width: calc(100% - 100px)"
              :summary-method="getSummaries"
              show-summary
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                type="index"
                label="行号"
                width="50">
              </el-table-column>
              <!-- 位置 -->
              <el-table-column
                prop="cbowhId"
                :label="cbowhName(1)"
                width="115"
                v-if="ofoFlowWork.chooseOwh == '0'">
                <template slot="header">
                  <a class="vatgroup" @click="changeVatgroup(true, 'all', 'cbowhId', '', {}, props.row.ofrresourceId)">{{cbowhName(1)}}
                    <i class="el-icon-edit-outline"></i>
                  </a>
                </template>
                <template slot-scope="scope">
                  <a class="vatgroup" @click="changeVatgroup(true, 'single', 'cbowhId', scope.row.cbowhId, scope.row)">
                    {{scope.row.cbowhName}}
                  </a>

                </template>
              </el-table-column>
              <!-- 位置2 -->
              <el-table-column
                prop="cbowhId"
                :label="cbowhName(2)"
                width="115"
                v-if="ofoFlowWork.stockaccttype == '7'">
                <template slot="header">
                  <a class="vatgroup" @click="changeVatgroup(true, 'all', 'cbowhTo', '', {}, props.row.ofrresourceId)">{{cbowhName(2)}}
                    <i class="el-icon-edit-outline"></i>
                  </a>
                </template>
                <template slot-scope="scope">
                  <a class="vatgroup" @click="changeVatgroup(true, 'single', 'cbowhTo', scope.row.cbowhTo, scope.row)">
                    {{scope.row.cbowhToName}}
                  </a>

                </template>
              </el-table-column>
              <!-- 货物或应税劳务、服务名称 -->
              <el-table-column
                prop="ofrresourceId"
                :label="ofoFlowWork.thingtypeName + '（明细）'"
                min-width="220">
                <template slot="header">
                  {{ofoFlowWork.thingtypeName + '（明细）'}}
                  <!-- <el-button type="text" @click="addThing" v-if="!disabled && isAdd == '0'" icon="el-icon-circle-plus-outline"></el-button> -->
                </template>
                <template slot-scope="scope">
                  <a class="vatgroup" v-if="ofoFlowWork.isMultiple == '0'" @click="selectThingMore(true, scope.row, scope.$index)">
                    {{scope.row.ofrthingName}}
                  </a>
                  <a class="vatgroup" v-else>
                    {{scope.row.ofrthingName}}
                  </a>
                </template>
              </el-table-column>
              <!-- 自定义 -->
              <el-table-column
                prop="workConfigList4"
                min-width="160"
                v-for="(item, index) in workConfig.workConfigList4"
                :key="item.ofoFlowWorkConfigId"
                :label="item.name">
                <template slot="header">
                  <el-popover
                    placement="right"
                    width="160"
                    trigger="click"
                    :ref="`popover${item.ofoFlowWorkConfigId}`">
                    <el-input size="mini" v-model="configValue" clearable class="right-input" v-if="item.showType == '1'">
                      <template slot="append">%</template>
                    </el-input>
                    <el-select
                      v-model="configValue"
                      filterable
                      clearable
                      style="width:100%"
                      v-if="item.showType == '2'"
                      size="mini"
                    >
                      <el-option
                        v-for="(val, id) in JSON.parse(item.options)"
                        :key="id"
                        :label="val.dictLabel"
                        :value="val.dictValue + ''"
                      ></el-option>
                    </el-select>
                    <el-input size="mini" v-model="configValue" clearable v-if="item.showType == '3'"></el-input>
                    <el-date-picker
                      v-if="item.showType == '4'"
                      v-model="configValue"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                      size="mini">
                    </el-date-picker>
                    <!-- <el-input size="mini" v-model="configValue" clearable v-else></el-input> -->
                    <el-input
                      v-model="configValue"
                      clearable
                      v-if="item.showType == '5'"
                      class="right-input"
                      size="mini"
                      @blur="configValue = comdify(configValue)"
                      @focus="configValue = delComdify(configValue)"
                    >
                    </el-input>
                    <div style="text-align: right; margin-top: 10px">
                      <el-button type="primary" size="mini" @click="submitConfigValue(item, index, 'workConfigList4')">确 定</el-button>
                    </div>
                    <a slot="reference" class="vatgroup" @click="configValue = ''">{{item.name}}</a>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <!-- <el-input
                    v-model="scope.row.workConfigList4[index].configValue"
                    clearable
                  ></el-input> -->
                  <el-input
                    v-model="scope.row.workConfigList4[index].configValue"
                    clearable
                    class="right-input"
                    v-if="scope.row.workConfigList4[index] && scope.row.workConfigList4[index].showType == '1'"
                  >
                    <template slot="append">%</template>
                  </el-input>
                  <el-select
                    v-model="scope.row.workConfigList4[index].configValue"
                    filterable
                    clearable
                    style="width:100%"
                    v-if="scope.row.workConfigList4[index] && scope.row.workConfigList4[index].showType == '2'"
                  >
                    <el-option
                      v-for="(val, id) in JSON.parse(scope.row.workConfigList4[index].options)"
                      :key="id"
                      :label="val.dictLabel"
                      :value="val.dictValue + ''"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.workConfigList4[index].configValue"
                    clearable
                    v-if="scope.row.workConfigList4[index] && scope.row.workConfigList4[index].showType == '3'"
                  >
                  </el-input>
                  <el-date-picker
                    v-if="scope.row.workConfigList4[index] && scope.row.workConfigList4[index].showType == '4'"
                    v-model="scope.row.workConfigList4[index].configValue"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    style="width: 100%">
                  </el-date-picker>
                  <el-input
                    v-model="scope.row.workConfigList4[index].configValue"
                    clearable
                    v-if="scope.row.workConfigList4[index] && scope.row.workConfigList4[index].showType == '5'"
                    class="right-input"
                    @input="scope.row.workConfigList4[index].configValue=scope.row.workConfigList4[index].configValue.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')"
                    @blur="configComdify(scope.row.workConfigList4[index].configValue, index, scope.$index)"
                    @focus="configDelComdify(scope.row.workConfigList4[index].configValue, index, scope.$index)"
                  >
                  </el-input>
                </template>
              </el-table-column>
              <!-- 包装核算 -->
              <template v-if="params.bzhs === '0' && ofoFlowWork.bzhs === '0'">
                <el-table-column
                  prop="bzsl"
                  label="包装数量"
                  min-width="150">
                  <template slot-scope="scope">
                    <el-input size="mini" v-model="scope.row.bzsl" @input="handleBzslInput(scope.row)" clearable class="right-input"/>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="bzdw"
                  label="包装单位"
                  min-width="120">
                  <template slot-scope="scope">
                    <el-input size="mini" v-model="scope.row.bzdw" clearable class="right-input"/>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="bzxs"
                  label="包装系数"
                  min-width="120">
                  <template slot-scope="scope">
                    <el-input size="mini" v-model="scope.row.bzxs" clearable @input="handleBzxsInput(scope.row)" class="right-input"/>
                  </template>
                </el-table-column>
              </template>
              <!-- 起始数量 -->
              <el-table-column
                prop="beginValue"
                label="起始数量"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '8'">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.beginValue" clearable @blur="handleCount1(scope.row)" class="right-input"/>
                </template>
              </el-table-column>

              <!-- 终止数量 -->
              <el-table-column
                prop="endValue"
                label="终止数量"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '8'">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.endValue" clearable @blur="handleCount2(scope.row)" class="right-input"/>
                </template>
              </el-table-column>
              <!-- 数量期间 -->
              <el-table-column
                prop="quantity"
                label="数量"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '8'">
                <template slot-scope="scope">{{scope.row.quantity}}
                </template>
              </el-table-column>
              <el-table-column
                prop="beginValue"
                label="系统库存"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '11'">
                <template slot-scope="scope">
                  <el-input size="mini" readonly v-model="scope.row.beginValue" clearable @blur="handleCount1(scope.row)" class="right-input"/>
                </template>
              </el-table-column>

              <!-- 终止数量 -->
              <el-table-column
                prop="endValue"
                label="实际库存"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '11'">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.endValue" clearable @blur="handleCount2(scope.row)" class="right-input"/>
                </template>
              </el-table-column>
              <!-- 数量期间 -->
              <el-table-column
                prop="quantity"
                label="盈亏数量"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '11'">
                <template slot-scope="scope">{{scope.row.quantity}}
                </template>
              </el-table-column>
              <!-- 数量 -->
              <el-table-column
                prop="workConfigList1"
                min-width="150"
                v-for="(item, index) in workConfig.workConfigList1"
                :key="item.ofoFlowWorkConfigId"
                :label="item.name"
                v-if="ofoFlowWork.costmanagetype != '7' && ofoFlowWork.costmanagetype != '10' && ofoFlowWork.costmanagetype != '11' && ofoFlowWork.costmanagetype != '8' && ofoFlowWork.costmanagetype != '4'">
                <template slot="header">
                  <el-popover
                    placement="right"
                    width="150"
                    trigger="click"
                    :ref="`popover${item.ofoFlowWorkConfigId}`">
                    <el-input size="mini" v-model="configValue" clearable class="right-input" v-if="item.showType != '2'">
                      <template slot="append" v-if="item.showType == '1'">%</template>
                    </el-input>
                    <el-select
                      v-model="configValue"
                      filterable
                      clearable
                      style="width:100%"
                      v-if="item.showType == '2'"
                    >
                      <el-option
                        v-for="(val, id) in JSON.parse(item.options)"
                        :key="id"
                        :label="val.dictLabel"
                        :value="val.dictValue + ''"
                      ></el-option>
                    </el-select>
                    <div style="text-align: right; margin-top: 10px">
                      <el-button type="primary" size="mini" @click="submitConfigValue(item, index, 'workConfigList1')">确 定</el-button>
                    </div>
                    <a slot="reference" class="vatgroup" @click="configValue = ''">{{item.name}}</a>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input size="mini"
                    v-model="scope.row.workConfigList1[index].configValue"
                    clearable
                    class="right-input"
                    @input="computeSl(scope.row, index, 'workConfigList1')"
                    v-if="scope.row.workConfigList1[index] && scope.row.workConfigList1[index].showType != '2'"
                  >
                    <template slot="append" v-if="scope.row.workConfigList1[index].showType == '1'">%</template>
                  </el-input>
                  <el-select size="mini"
                    v-model="scope.row.workConfigList1[index].configValue"
                    filterable
                    clearable
                    style="width:100%"
                    v-if="scope.row.workConfigList1[index] && scope.row.workConfigList1[index].showType == '2'"
                  >
                    <el-option
                      v-for="(val, id) in JSON.parse(scope.row.workConfigList1[index].options)"
                      :key="id"
                      :label="val.dictLabel"
                      :value="val.dictValue + ''"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="quantity"
                label="数量"
                min-width="150"
                align="right"
                header-align="center"
                v-if="ofoFlowWork.costmanagetype != '7' && ofoFlowWork.costmanagetype != '10' && ofoFlowWork.costmanagetype != '11' && ofoFlowWork.costmanagetype != '8' && ofoFlowWork.costmanagetype != '4'">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.quantity" @input="compute1(scope.row)" clearable class="right-input"/>
                </template>
              </el-table-column>
              <!-- 开始时间 -->
              <el-table-column
                prop="beginValue"
                label="开始时间"
                width="250"
                v-if="ofoFlowWork.costmanagetype == '7' || ofoFlowWork.costmanagetype == '10'">
                <template slot-scope="scope">
                  <el-date-picker size="mini"
                    v-model="scope.row.beginValue"
                    type="datetime"
                    placeholder="选择开始时间"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    @change="handleChangeSj1(scope.row)">
                  </el-date-picker>
                </template>
              </el-table-column>
              <!-- 结束时间 -->
              <el-table-column
                prop="endValue"
                label="结束时间"
                width="250"
                v-if="ofoFlowWork.costmanagetype == '7' || ofoFlowWork.costmanagetype == '10'">
                <template slot-scope="scope">
                  <el-date-picker size="mini"
                    v-model="scope.row.endValue"
                    type="datetime"
                    placeholder="选择结束时间"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    @change="handleChangeSj2(scope.row)">
                  </el-date-picker>
                </template>
              </el-table-column>
              <!-- 时间期间 -->
              <el-table-column
                prop="quantity"
                label="时间(天)"
                width="150"
                v-if="ofoFlowWork.costmanagetype == '10'">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.quantity" clearable class="right-input"/>
                </template>
              </el-table-column>
              <el-table-column
                prop="quantity"
                label="时间期间"
                width="150"
                v-if="ofoFlowWork.costmanagetype == '7'">
                <template slot-scope="scope">{{scope.row.quantity | filter_handleTimeRange}}
                </template>
              </el-table-column>
              <!-- 单价 -->
              <el-table-column
                prop="workConfigList2"
                min-width="150"
                v-for="(item, index) in workConfig.workConfigList2"
                :key="item.ofoFlowWorkConfigId"
                :label="item.name"
                v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5'">
                <template slot="header">
                  <el-popover
                    placement="right"
                    width="150"
                    trigger="click"
                    :ref="`popover${item.ofoFlowWorkConfigId}`">
                    <el-input size="mini" v-model="configValue" clearable class="right-input" v-if="item.showType != '2'">
                      <template slot="append" v-if="item.showType == '1'">%</template>
                    </el-input>
                    <el-select
                      v-model="configValue"
                      filterable
                      clearable
                      style="width:100%"
                      v-if="item.showType == '2'"
                    >
                      <el-option
                        v-for="(val, id) in JSON.parse(item.options)"
                        :key="id"
                        :label="val.dictLabel"
                        :value="val.dictValue + ''"
                      ></el-option>
                    </el-select>
                    <div style="text-align: right; margin-top: 10px">
                      <el-button type="primary" size="mini" @click="submitConfigValue(item, index, 'workConfigList2')">确 定</el-button>
                    </div>
                    <a slot="reference" class="vatgroup" @click="configValue = ''">{{item.name}}</a>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.workConfigList2[index].configValue" clearable class="right-input" @input="computeSl(scope.row, index, 'workConfigList2')" v-if="scope.row.workConfigList2[index] && scope.row.workConfigList2[index].showType != '2'">
                    <template slot="append" v-if="scope.row.workConfigList2[index].showType == '1'">%</template>
                  </el-input>
                  <el-select size="mini"
                    v-model="scope.row.workConfigList2[index].configValue"
                    filterable
                    clearable
                    style="width:100%"
                    v-if="scope.row.workConfigList2[index] && scope.row.workConfigList2[index].showType == '2'"
                  >
                    <el-option
                      v-for="(val, id) in JSON.parse(scope.row.workConfigList2[index].options)"
                      :key="id"
                      :label="val.dictLabel"
                      :value="val.dictValue + ''"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="price"
                :label="isTax ? '单价（含税）' : '单价（不含税）'"
                min-width="150"
                v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5' || ofoFlowWork.costmanagetype == '11'">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.price" @input="compute2(scope.row)" :readonly="ofoFlowWork.costmanagetype === '11'" class="right-input" clearable @blur="compute22(scope.row)" @focus="compute222(scope.row)"/>
                </template>
              </el-table-column>
              <!-- 金额 -->
              <el-table-column
                prop="workConfigList3"
                min-width="150"
                v-for="(item, index) in workConfig.workConfigList3"
                :key="item.ofoFlowWorkConfigId"
                :label="item.name"
                v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '4' || ofoFlowWork.costmanagetype == '5'">
                <template slot="header">
                  <el-popover
                    placement="right"
                    width="150"
                    trigger="click"
                    :ref="`popover${item.ofoFlowWorkConfigId}`">
                    <el-input size="mini" v-model="configValue" clearable class="right-input" v-if="item.showType != '2'">
                      <template slot="append" v-if="item.showType == '1'">%</template>
                    </el-input>
                    <el-select
                      v-model="configValue"
                      filterable
                      clearable
                      style="width:100%"
                      v-if="item.showType == '2'"
                    >
                      <el-option
                        v-for="(val, id) in JSON.parse(item.options)"
                        :key="id"
                        :label="val.dictLabel"
                        :value="val.dictValue + ''"
                      ></el-option>
                    </el-select>
                    <div style="text-align: right; margin-top: 10px">
                      <el-button type="primary" size="mini" @click="submitConfigValue(item, index, 'workConfigList3')">确 定</el-button>
                    </div>
                    <a slot="reference" class="vatgroup" @click="configValue = ''">{{item.name}}</a>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.workConfigList3[index].configValue" clearable class="right-input" @input="computeSl(scope.row, index, 'workConfigList3')" v-if="scope.row.workConfigList3[index] && scope.row.workConfigList3[index].showType != '2'">
                    <template slot="append" v-if="scope.row.workConfigList3[index].showType == '1'">%</template>
                  </el-input>
                  <el-select size="mini"
                    v-model="scope.row.workConfigList3[index].configValue"
                    filterable
                    clearable
                    style="width:100%"
                    v-if="scope.row.workConfigList3[index] && scope.row.workConfigList3[index].showType == '2'"
                  >
                    <el-option
                      v-for="(val, id) in JSON.parse(scope.row.workConfigList3[index].options)"
                      :key="id"
                      :label="val.dictLabel"
                      :value="val.dictValue + ''"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="total"
                :label="isTax ? '金额（含税）' : '金额（不含税）'"
                min-width="150"
                align="right"
                header-align="center"
                v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5' || ofoFlowWork.costmanagetype == '11'">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.total" clearable @input="compute3(scope.row)" class="right-input" @blur="compute33(scope.row)" @focus="compute333(scope.row)"/>
                </template>
              </el-table-column>
              <!-- 费用金额 -->
              <el-table-column
                prop="total"
                label="费用金额"
                min-width="200"
                align="right"
                header-align="center"
                v-if="ofoFlowWork.costmanagetype == '4'">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.total" clearable class="right-input" @blur="compute33(scope.row)" @focus="compute333(scope.row)"/>
                </template>
              </el-table-column>
              <!-- 税率 -->
              <el-table-column
                prop="vatgroup"
                label="税率"
                min-width="80"
                v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
                <template slot="header">
                  <a class="vatgroup" @click="changeVatgroup(true, 'all', 'vatgroup', '', {}, props.row.ofrresourceId)">税率
                    <i class="el-icon-edit-outline"></i>
                  </a>
                </template>
                <template slot-scope="scope">
                  <a class="vatgroup" @click="changeVatgroup(true, 'single', 'vatgroup', scope.row.vatgroup, scope.row)">
                    <DictTag :options="dropDown.invoiceVat" :value="scope.row.vatgroup"/>
                  </a>

                </template>
                <!-- <template slot-scope="scope">
                  <el-select v-model="scope.row.vatgroup" @change="compute4(scope.row)">
                    <el-option
                    v-for="item in dropDown.invoiceVat"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                    :key="item.dictValue"
                    ></el-option>
                  </el-select>
                </template> -->
              </el-table-column>
              <!-- 税额 -->
              <el-table-column
                prop="totalVat"
                label="税额"
                min-width="100"
                align="right"
                v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.totalVat" disabled class="right-input"/>
                </template> -->
              </el-table-column>
              <!-- 票种 -->
              <el-table-column
                prop="invoicetype"
                label="票种"
                min-width="190"
                v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
                <template slot="header">
                  <a class="vatgroup" @click="changeVatgroup(true, 'all', 'invoicetype', '', {}, props.row.ofrresourceId)">票种
                    <i class="el-icon-edit-outline"></i>
                  </a>
                </template>
                <template slot-scope="scope">
                  <a class="vatgroup" @click="changeVatgroup(true, 'single', 'invoicetype', scope.row.invoicetype, scope.row)">
                    <DictTag :options="dropDown.invoiceType" :value="scope.row.invoicetype"/>
                  </a>
                </template>
                <!-- <template slot-scope="scope">
                  <el-select v-model="scope.row.invoicetype" clearable>
                    <el-option
                    v-for="item in dropDown.invoiceType"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                    :key="item.dictValue"
                    ></el-option>
                  </el-select>
                </template> -->
              </el-table-column>
              <!-- 成本单价 -->
              <el-table-column
                prop="cost"
                :label="isTax ? '成本单价（含税）' : '成本单价（不含税）'"
                min-width="150"
                v-if="ofoFlowWork.costmanagetype == '2'">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.cost" @input="compute5(scope.row)" class="right-input" clearable @blur="compute55(scope.row)" @focus="compute555(scope.row)"/>
                </template>
              </el-table-column>
              <!-- 成本金额 -->
              <el-table-column
                prop="costTotal"
                :label="isTax ? '成本金额（含税）' : '成本金额（不含税）'"
                min-width="150"
                v-if="ofoFlowWork.costmanagetype == '2'">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.costTotal" @input="compute6(scope.row)" clearable class="right-input" @blur="compute66(scope.row)" @focus="compute666(scope.row)"/>
                </template>
              </el-table-column>
              <!-- 成本税额 -->
              <el-table-column
                prop="costTotalVat"
                label="成本税额"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '2'">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.costTotalVat" disabled class="right-input"/>
                </template>
              </el-table-column>
              <!-- 备注 -->
              <el-table-column
                prop="remark"
                label="备注"
                min-width="150">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.remark" />
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="60"
                >
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="handleDeleteThing(scope.row, scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
          type="index"
          label="行号"
          width="50">
        </el-table-column>
        <!-- 位置 -->
        <el-table-column
          type=""
          prop="cbowhId"
          :label="cbowhName(1)"
          width="115"
          v-if="ofoFlowWork.chooseOwh == '0'">
          <template slot="header">
            <a class="vatgroup" @click="changeVatgroup(false, 'all', 'cbowhId')">{{cbowhName(1)}}
              <i class="el-icon-edit-outline"></i>
            </a>
          </template>
          <template slot-scope="scope">
            <a class="vatgroup" @click="changeVatgroup(false, 'single', 'cbowhId', scope.row.cbowhId, scope.row)">
              {{scope.row.cbowhName}}
            </a>

          </template>
        </el-table-column>
        <!-- 位置2 -->
        <el-table-column
          type=""
          prop="cbowhId"
          :label="cbowhName(2)"
          width="115"
          v-if="ofoFlowWork.stockaccttype == '7'">
          <template slot="header">
            <a class="vatgroup" @click="changeVatgroup(false, 'all', 'cbowhTo')">{{cbowhName(2)}}
              <i class="el-icon-edit-outline"></i>
            </a>
          </template>
          <template slot-scope="scope">
            <a class="vatgroup" @click="changeVatgroup(false, 'single', 'cbowhTo', scope.row.cbowhTo, scope.row)">
              {{scope.row.cbowhToName}}
            </a>

          </template>
        </el-table-column>
        <!-- 货物或应税劳务、服务名称 -->
        <el-table-column
          prop="ofrresourceName"
          :label="ofoFlowWork.kindtypeName"
          min-width="220">
          <template slot="header">
            {{ofoFlowWork.kindtypeName}}
            <el-button type="text" @click="addResource" v-if="!disabled && isAdd == '0'" icon="el-icon-circle-plus-outline"></el-button>
          </template>
          <template slot-scope="scope">
            <template v-if="ofoFlowWork.isMultiple == '0'">
              <a class="vatgroup" @click="selectMore(true, scope.row, scope.$index)" :style="{color: scope.row.isMultiRes > 1 ? '#e6a23c' : (scope.row.isMultiRes == 0 ? 'red' : '#000')}" v-if="scope.row.bomId < 0">
                {{scope.row.ofrresourceName}}
              </a>
              <a v-else @click="changeBom(scope.row)">{{scope.row.ofrresourceName}}</a>
            </template>
            <template v-else>{{scope.row.ofrresourceName}}</template>
          </template>
        </el-table-column>
        <el-table-column v-if="isShowBomStock" prop="stock" label="库存"></el-table-column>
        <template v-if="ofoFlowWork.costmanagetype != '9' && ofoFlowWork.ggdw === '0'">
          <el-table-column property="ggxh" prop="ggxh" label="规格型号" width="250" show-overflow-tooltip ></el-table-column>
          <el-table-column property="jldw" prop="jldw" label="单位"></el-table-column>
        </template>

        <template v-if="ofoFlowWork.costmanagetype == '9'">
          <el-table-column v-for="item in resDimeList" :key="item.cbdId" :label="item.dimeName" width="200" v-if="item.workshow">
            <template slot-scope="scope">
              <uniseriate-form :formList="[scope.row.dimensionList.find(val => val.cbdId == item.cbdId)]" :form="false" />
            </template>
          </el-table-column>
          <el-table-column  label="检验结论" width="150">
            <template slot-scope="scope">
              <el-select size="mini"
                v-model="scope.row.beginValue"
                style="width: 100%"
                clearable>
                <el-option label="符合规定" value="0"></el-option>
                <el-option label="不符合规定" value="1"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </template>
        <!-- 自定义 -->
        <el-table-column
          prop="workConfigList4"
          min-width="160"
          v-for="(item, index) in workConfig.workConfigList4"
          :key="index"
          :label="item.name"
          v-if="!ofoFlowWork.thingtype">
          <template slot="header">
            <el-popover
              placement="right"
              width="160"
              trigger="click"
              :ref="`popover${item.ofoFlowWorkConfigId}`">
              <el-input size="mini" v-model="configValue" clearable class="right-input" v-if="item.showType == '1'">
                <template slot="append">%</template>
              </el-input>
              <el-select
                v-model="configValue"
                filterable
                clearable
                style="width:100%"
                v-if="item.showType == '2'"
                size="mini"
              >
                <el-option
                  v-for="(val, id) in JSON.parse(item.options)"
                  :key="id"
                  :label="val.dictLabel"
                  :value="val.dictValue + ''"
                ></el-option>
              </el-select>
              <el-input size="mini" v-model="configValue" clearable v-if="item.showType == '3'"></el-input>
              <el-date-picker
                v-if="item.showType == '4'"
                v-model="configValue"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                size="mini">
              </el-date-picker>
              <!-- <el-input size="mini" v-model="configValue" clearable v-else></el-input> -->
              <el-input
                v-model="configValue"
                clearable
                v-if="item.showType == '5'"
                class="right-input"
                size="mini"
                @blur="configValue = comdify(configValue)"
                @focus="configValue = delComdify(configValue)"
              >
              </el-input>
              <div style="text-align: right; margin-top: 10px">
                <el-button type="primary" size="mini" @click="submitConfigValue(item, index, 'workConfigList4')">确 定</el-button>
              </div>
              <a slot="reference" class="vatgroup" @click="configValue = ''">{{item.name}}</a>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <!-- <el-input
              v-model="scope.row.workConfigList4[index].configValue"
              clearable
            ></el-input> -->
            <el-input size="mini"
              v-model="scope.row.workConfigList4[index].configValue"
              clearable
              class="right-input"
              v-if="scope.row.workConfigList4[index] && scope.row.workConfigList4[index].showType == '1'"
            >
              <template slot="append">%</template>
            </el-input>
            <el-select size="mini"
              v-model="scope.row.workConfigList4[index].configValue"
              filterable
              clearable
              style="width:100%"
              v-if="scope.row.workConfigList4[index] && scope.row.workConfigList4[index].showType == '2'"
            >
              <el-option
                v-for="(val, id) in JSON.parse(scope.row.workConfigList4[index].options)"
                :key="id"
                :label="val.dictLabel"
                :value="val.dictValue + ''"
              ></el-option>
            </el-select>
            <el-input size="mini"
              v-model="scope.row.workConfigList4[index].configValue"
              clearable
              v-if="scope.row.workConfigList4[index] && scope.row.workConfigList4[index].showType == '3'"
            >
            </el-input>
            <el-date-picker size="mini"
              v-if="scope.row.workConfigList4[index] && scope.row.workConfigList4[index].showType == '4'"
              v-model="scope.row.workConfigList4[index].configValue"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 100%">
            </el-date-picker>
            <el-input size="mini"
              v-model="scope.row.workConfigList4[index].configValue"
              clearable
              v-if="scope.row.workConfigList4[index] && scope.row.workConfigList4[index].showType == '5'"
              class="right-input"
              @input="scope.row.workConfigList4[index].configValue=scope.row.workConfigList4[index].configValue.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')"
              @blur="configComdify(scope.row.workConfigList4[index].configValue, index, scope.$index)"
              @focus="configDelComdify(scope.row.workConfigList4[index].configValue, index, scope.$index)"
            >
            </el-input>
          </template>
        </el-table-column>
        <!-- 包装核算 -->
        <template v-if="params.bzhs === '0' && ofoFlowWork.bzhs === '0'">
          <el-table-column
            prop="bzsl"
            label="包装数量"
            min-width="150">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.bzsl" @input="handleBzslInput(scope.row)" clearable class="right-input"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="bzdw"
            label="包装单位"
            min-width="120">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.bzdw" clearable class="right-input"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="bzxs"
            label="包装系数"
            min-width="120">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.bzxs" clearable @input="handleBzxsInput(scope.row)" class="right-input"/>
            </template>
          </el-table-column>
        </template>
        <!-- 起始数量 -->
        <el-table-column
          prop="beginValue"
          label="起始数量"
          min-width="100"
          v-if="ofoFlowWork.costmanagetype == '8'">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.beginValue" clearable @blur="handleCount1(scope.row)" class="right-input"/>
          </template>
        </el-table-column>

        <!-- 终止数量 -->
        <el-table-column
          prop="endValue"
          label="终止数量"
          min-width="100"
          v-if="ofoFlowWork.costmanagetype == '8'">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.endValue" clearable @blur="handleCount2(scope.row)" class="right-input"/>
          </template>
        </el-table-column>
        <!-- 数量期间 -->
        <el-table-column
          prop="quantity"
          label="数量"
          min-width="100"
          v-if="ofoFlowWork.costmanagetype == '8'">
          <template slot-scope="scope">{{scope.row.quantity}}
          </template>
        </el-table-column>
        <el-table-column
          prop="beginValue"
          label="系统库存"
          min-width="100"
          v-if="ofoFlowWork.costmanagetype == '11'">
          <template slot-scope="scope">
            <el-input size="mini" readonly v-model="scope.row.beginValue" clearable @blur="handleCount1(scope.row)" class="right-input"/>
          </template>
        </el-table-column>

        <!-- 终止数量 -->
        <el-table-column
          prop="endValue"
          label="实际库存"
          min-width="100"
          v-if="ofoFlowWork.costmanagetype == '11'">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.endValue" clearable @blur="handleCount2(scope.row)" class="right-input"/>
          </template>
        </el-table-column>
        <!-- 数量期间 -->
        <el-table-column
          prop="quantity"
          label="盈亏数量"
          min-width="100"
          v-if="ofoFlowWork.costmanagetype == '11'">
          <template slot-scope="scope">{{scope.row.quantity}}
          </template>
        </el-table-column>
        <el-table-column
          prop="workConfigList1"
          min-width="150"
          v-for="(item, index) in workConfig.workConfigList1"
          :key="index"
          :label="item.name"
          v-if="ofoFlowWork.costmanagetype != '7' && ofoFlowWork.costmanagetype != '10' && ofoFlowWork.costmanagetype != '8' && ofoFlowWork.costmanagetype != '11' && ofoFlowWork.costmanagetype != '4' && !ofoFlowWork.thingtype">
          <template slot="header">
            <el-popover
              placement="right"
              width="150"
              trigger="click"
              :ref="`popover${item.ofoFlowWorkConfigId}`">
              <el-input size="mini" v-model="configValue" clearable class="right-input" v-if="item.showType != '2'">
                <template slot="append" v-if="item.showType == '1'">%</template>
              </el-input>
              <el-select
                v-model="configValue"
                filterable
                clearable
                style="width:100%"
                v-if="item.showType == '2'"
              >
                <el-option
                  v-for="(val, id) in JSON.parse(item.options)"
                  :key="id"
                  :label="val.dictLabel"
                  :value="val.dictValue + ''"
                ></el-option>
              </el-select>
              <div style="text-align: right; margin-top: 10px">
                <el-button type="primary" size="mini" @click="submitConfigValue(item, index, 'workConfigList1')">确 定</el-button>
              </div>
              <a slot="reference" class="vatgroup" @click="configValue = ''">{{item.name}}</a>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <el-input size="mini"
              v-model="scope.row.workConfigList1[index].configValue"
              clearable
              class="right-input"
              @input="computeSl(scope.row, index, 'workConfigList1')"
              v-if="scope.row.workConfigList1[index] && scope.row.workConfigList1[index].showType != '2'"
            >
              <template slot="append" v-if="scope.row.workConfigList1[index].showType == '1'">%</template>
            </el-input>
            <el-select size="mini"
              v-model="scope.row.workConfigList1[index].configValue"
              filterable
              clearable
              style="width:100%"
              v-if="scope.row.workConfigList1[index] && scope.row.workConfigList1[index].showType == '2'"
            >
              <el-option
                v-for="(val, id) in JSON.parse(scope.row.workConfigList1[index].options)"
                :key="id"
                :label="val.dictLabel"
                :value="val.dictValue + ''"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- 数量 -->
        <el-table-column
          prop="quantity"
          label="数量"
          min-width="150"
          align="right"
          header-align="center"
          v-if="ofoFlowWork.costmanagetype != '7' && ofoFlowWork.costmanagetype != '10' && ofoFlowWork.costmanagetype != '8' && ofoFlowWork.costmanagetype != '11' && ofoFlowWork.costmanagetype != '4'">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.quantity" :class="scope.row.quantityChange ? 'input-change' : ''" :style="{border: scope.row.quantityChange ? '1px solid #00bcd4':''}" @input="compute1(scope.row)" @focus="scope.row.quantityFocus = true" @blur="scope.row.quantityFocus = false" clearable class="right-input"/>
            <div v-if="ofoFlowWork.isCalcBom == '0' && scope.row.bomId < 0" style="display:flex; justify-content: flex-end;margin-right:10px;color:#ababab">合计：{{bomQuantity(scope.row)}}</div>
          </template>
        </el-table-column>
        <!-- 开始时间 -->
        <el-table-column
          prop="beginValue"
          label="开始时间"
          width="250"
          v-if="ofoFlowWork.costmanagetype == '7' || ofoFlowWork.costmanagetype == '10'">
          <template slot-scope="scope">
            <el-date-picker size="mini"
              v-model="scope.row.beginValue"
              type="datetime"
              placeholder="选择开始时间"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              @change="handleChangeSj1(scope.row)">
            </el-date-picker>
          </template>
        </el-table-column>
        <!-- 结束时间 -->
        <el-table-column
          prop="endValue"
          label="结束时间"
          width="250"
          v-if="ofoFlowWork.costmanagetype == '7' || ofoFlowWork.costmanagetype == '10'">
          <template slot-scope="scope">
            <el-date-picker size="mini"
              v-model="scope.row.endValue"
              type="datetime"
              placeholder="选择结束时间"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              @change="handleChangeSj2(scope.row)">
            </el-date-picker>
          </template>
        </el-table-column>
        <!-- 时间期间 -->
        <el-table-column
          prop="quantity"
          label="时间(天)"
          width="150"
          v-if="ofoFlowWork.costmanagetype == '10'">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.quantity" clearable class="right-input"/>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="时间期间"
          width="150"
          v-if="ofoFlowWork.costmanagetype == '7'">
          <template slot-scope="scope">{{scope.row.quantity | filter_handleTimeRange}}
          </template>
        </el-table-column>
        <!-- 单价 -->
        <el-table-column
          prop="workConfigList2"
          min-width="150"
          v-for="(item, index) in workConfig.workConfigList2"
          :key="item.ofoFlowWorkConfigId"
          :label="item.name"
          v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !ofoFlowWork.thingtype && workConfig.workConfigList2.length">
          <template slot="header">
            <el-popover
              placement="right"
              width="150"
              trigger="click"
              :ref="`popover${item.ofoFlowWorkConfigId}`">
              <el-input size="mini" v-model="configValue" clearable class="right-input" v-if="item.showType != '2'">
                <template slot="append" v-if="item.showType == '1'">%</template>
              </el-input>
              <el-select
                v-model="configValue"
                filterable
                clearable
                style="width:100%"
                v-if="item.showType == '2'"
              >
                <el-option
                  v-for="(val, id) in JSON.parse(item.options)"
                  :key="id"
                  :label="val.dictLabel"
                  :value="val.dictValue + ''"
                ></el-option>
              </el-select>
              <div style="text-align: right; margin-top: 10px">
                <el-button type="primary" size="mini" @click="submitConfigValue(item, index, 'workConfigList2')">确 定</el-button>
              </div>
              <a slot="reference" class="vatgroup" @click="configValue = ''">{{item.name}}</a>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.workConfigList2[index].configValue" clearable class="right-input" @input="computeSl(scope.row, index, 'workConfigList2')" v-if="scope.row.workConfigList2[index] && scope.row.workConfigList2[index].showType != '2'">
              <template slot="append" v-if="scope.row.workConfigList2[index].showType == '1'">%</template>
            </el-input>
            <el-select size="mini"
              v-model="scope.row.workConfigList2[index].configValue"
              filterable
              clearable
              style="width:100%"
              v-if="scope.row.workConfigList2[index] && scope.row.workConfigList2[index].showType == '2'"
            >
              <el-option
                v-for="(val, id) in JSON.parse(scope.row.workConfigList2[index].options)"
                :key="id"
                :label="val.dictLabel"
                :value="val.dictValue + ''"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          :label="isTax ? '单价（含税）' : '单价（不含税）'"
          min-width="150"
          v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5' || ofoFlowWork.costmanagetype == '11'">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.price" @input="compute2(scope.row)" :readonly="ofoFlowWork.costmanagetype === '11'" class="right-input" clearable @blur="compute22(scope.row)" @focus="compute222(scope.row)"/>
          </template>
        </el-table-column>
        <!-- 金额 -->
        <el-table-column
          prop="workConfigList3"
          min-width="150"
          v-for="(item, index) in workConfig.workConfigList3"
          :key="item.ofoFlowWorkConfigId"
          :label="item.name"
          v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '4' || ofoFlowWork.costmanagetype == '5') && !ofoFlowWork.thingtype">
          <template slot="header">
            <el-popover
              placement="right"
              width="150"
              trigger="click"
              :ref="`popover${item.ofoFlowWorkConfigId}`">
              <el-input size="mini" v-model="configValue" clearable class="right-input" v-if="item.showType != '2'">
                <template slot="append" v-if="item.showType == '1'">%</template>
              </el-input>
              <el-select
                v-model="configValue"
                filterable
                clearable
                style="width:100%"
                v-if="item.showType == '2'"
              >
                <el-option
                  v-for="(val, id) in JSON.parse(item.options)"
                  :key="id"
                  :label="val.dictLabel"
                  :value="val.dictValue + ''"
                ></el-option>
              </el-select>
              <div style="text-align: right; margin-top: 10px">
                <el-button type="primary" size="mini" @click="submitConfigValue(item, index, 'workConfigList3')">确 定</el-button>
              </div>
              <a slot="reference" class="vatgroup" @click="configValue = ''">{{item.name}}</a>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.workConfigList3[index].configValue" clearable class="right-input" @input="computeSl(scope.row, index, 'workConfigList3')" v-if="scope.row.workConfigList3[index] && scope.row.workConfigList3[index].showType != '2'">
              <template slot="append" v-if="scope.row.workConfigList3[index].showType == '1'">%</template>
            </el-input>
            <el-select
              v-model="scope.row.workConfigList3[index].configValue"
              filterable
              clearable
              style="width:100%"
              v-if="scope.row.workConfigList3[index] && scope.row.workConfigList3[index].showType == '2'"
            >
              <el-option
                v-for="(val, id) in JSON.parse(scope.row.workConfigList3[index].options)"
                :key="id"
                :label="val.dictLabel"
                :value="val.dictValue + ''"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="total"
          :label="isTax ? '金额（含税）' : '金额（不含税）'"
          min-width="150"
          align="right"
          header-align="center"
          v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5' || ofoFlowWork.costmanagetype == '11'">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.total" clearable @input="compute3(scope.row)" class="right-input" @blur="compute33(scope.row)" @focus="compute333(scope.row)"/>
          </template>
        </el-table-column>
        <!-- 费用金额 -->
        <el-table-column
          prop="total"
          label="费用金额"
          min-width="200"
          align="right"
          header-align="center"
          v-if="ofoFlowWork.costmanagetype == '4'">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.total" clearable class="right-input" @blur="compute33(scope.row)" @focus="compute333(scope.row)"/>
          </template>
        </el-table-column>
        <!-- 税率 -->
        <el-table-column
          prop="vatgroup"
          label="税率"
          min-width="100"
          v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
          <template slot="header">
            <a class="vatgroup" @click="changeVatgroup(false, 'all', 'vatgroup')">税率
              <i class="el-icon-edit-outline"></i>
            </a>
          </template>
          <template slot-scope="scope">
            <a class="vatgroup" @click="changeVatgroup(false, 'single', 'vatgroup', scope.row.vatgroup, scope.row)">
              <DictTag :options="dropDown.invoiceVat" :value="scope.row.vatgroup"/>
            </a>
          </template>
        </el-table-column>
        <!-- 税额 -->
        <el-table-column
          prop="totalVat"
          label="税额"
          min-width="100"
          v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
          <!-- <template slot-scope="scope">
            <el-input v-model="scope.row.totalVat" disabled class="right-input"/>
          </template> -->
        </el-table-column>
        <!-- 票种 -->
        <el-table-column
          prop="invoicetype"
          label="票种"
          width="190"
          v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
          <template slot="header">
            <a class="vatgroup" @click="changeVatgroup(false, 'all', 'invoicetype')">票种
              <i class="el-icon-edit-outline"></i>
            </a>
          </template>
          <template slot-scope="scope">
            <a class="vatgroup" @click="changeVatgroup(false, 'single', 'invoicetype', scope.row.invoicetype, scope.row)">
              <DictTag :options="dropDown.invoiceType" :value="scope.row.invoicetype"/>
            </a>
          </template>
        </el-table-column>
        <!-- 成本单价 -->
        <el-table-column
          prop="cost"
          :label="isTax ? '成本单价（含税）' : '成本单价（不含税）'"
          min-width="150"
          v-if="ofoFlowWork.costmanagetype == '2'">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.cost" @input="compute5(scope.row)" class="right-input" @blur="compute55(scope.row)" @focus="compute555(scope.row)"/>
          </template>
        </el-table-column>
        <!-- 成本金额 -->
        <el-table-column
          prop="costTotal"
          :label="isTax ? '成本金额（含税）' : '成本金额（不含税）'"
          min-width="150"
          v-if="ofoFlowWork.costmanagetype == '2'">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.costTotal" @input="compute6(scope.row)" clearable class="right-input" @blur="compute66(scope.row)" @focus="compute666(scope.row)"/>
          </template>
        </el-table-column>
        <!-- 成本税额 -->
        <el-table-column
          prop="costTotalVat"
          label="成本税额"
          min-width="100"
          v-if="ofoFlowWork.costmanagetype == '2'">
          <!-- <template slot-scope="scope">
            <el-input v-model="scope.row.costTotalVat" disabled clearable class="right-input"/>
          </template> -->
        </el-table-column>
        <!-- 备注 -->
        <el-table-column
          prop="remark"
          label="备注"
          min-width="150">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.remark" />
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :width="((ofoFlowWork.isCalcBom == '0' && !ofoFlowWork.thingtype) || (ofoFlowWork.isCalcBom !== '0' && ofoFlowWork.thingtype)) ? '90' : '60'"
          fixed="right"
          align="right"
          >
        <!-- <el-table-column
          label="操作"
          :width="'60'"
          fixed="right"
          align="right"
          > -->
          <template slot-scope="scope">
            <el-button v-if="ofoFlowWork.isCalcBom == '0' && !ofoFlowWork.thingtype" type="text" size="small" @click="handleAddBom(scope.row, scope.$index)">新增</el-button>
            <el-button v-if="ofoFlowWork.isCalcBom !== '0' && ofoFlowWork.thingtype" type="text" size="small" @click="addThing(scope.row)">新增</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <table style="width: 100%" v-if="ofoFlowWork.costmanagetype == '4'">
        <tr style="height: 30px">
          <td style="width: 150px">合计</td>
          <td style="text-align:right">金额：{{ptotalNovat | comdify}}</td>
        </tr>
      </table>
      <table style="width: 100%" v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5'">
        <tr style="height: 30px">
          <td style="width: 150px">合计</td>
          <td style="text-align:right">金额：{{ptotalNovat | comdify}}</td>
          <td style="text-align:right">税额：{{ptotalVat | comdify}}</td>
          <td style="text-align:right">价税合计: {{ptotal | comdify}}</td>
        </tr>
        <!-- <tr>
          <td style="width: 150px"></td>
          <td>价税合计: {{ptotal1 | comdify}}</td>
        </tr> -->
      </table>
      <table style="width: 100%; margin-top:10px;border-top: 1px solid #eeeeee" v-if="ofoFlowWork.costmanagetype == '2'">
        <tr style="height: 30px">
          <td style="width: 150px">成本合计</td>
          <td style="text-align:right">成本金额：{{ctotalNovat | comdify}}</td>
          <td style="text-align:right">成本税额：{{ctotalVat | comdify}}</td>
          <td style="text-align:right">成本价税合计: {{ctotal | comdify}}</td>
        </tr>
        <!-- <tr>
          <td style="width: 150px"></td>
          <td style="text-align:right">成本价税合计: {{ctotal1 | comdify}}</td>
        </tr> -->
      </table>
    </template>

    <!-- 查看时不可编辑的表格 -->
    <!-- ofoFlowWork.isCalcBom == '0' ? '#b4b4b4' :  -->
    <template v-if="disabled">
      <el-table
        :data="productsList"
        :header-cell-style="{background: '#F9F9FB',color:'#606266','text-align': 'center'}"
        :key="Math.random()"
        border
        row-key="ofoWorkResourceId"
        :default-expand-all="isExpand1"
        ref="noEditTable"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :row-style="tableTreeRowStyle"
        :summary-method="getSummaries"
        show-summary>
        <!-- <el-table-column
          label="1111"
          width="50">
          111
        </el-table-column> -->

        <el-table-column type="expand" v-if="ofoFlowWork.thingtype">
          <template slot-scope="props">
            <el-table
              v-if="thingsList.filter(item => item.uuid ? item.uuid === props.row.uuid : item.ofrresourceId == props.row.ofrresourceId).length"
              :data="thingsList.filter(item => item.uuid ? item.uuid === props.row.uuid : item.ofrresourceId == props.row.ofrresourceId)"
              :header-cell-style="{background:'#F9F9FB',color:'#606266','text-align': 'center'}"
              key="table2"
              ref="noEditTable2"
              row-key="ofoWorkThingId"
              border
              style="margin-left:50px"
              :summary-method="getSummaries"
              show-summary>
              <el-table-column
                type="index"
                label="行号"
                width="50">
              </el-table-column>
              <!-- 位置 -->
              <el-table-column
                prop="cbowhName"
                :label="cbowhName(1)"
                width="115"
                v-if="ofoFlowWork.chooseOwh == '0'">
              </el-table-column>
              <!-- 位置2 -->
              <el-table-column
                prop="cbowhToName"
                :label="cbowhName(2)"
                width="115"
                v-if="ofoFlowWork.stockaccttype == '7'">
              </el-table-column>
              <!-- 货物或应税劳务、服务名称 -->
              <el-table-column
                :label="ofoFlowWork.thingtypeName + '（明细）'"
                min-width="200"
                prop="ofrresourceName">
                <template slot-scope="scope">
                  <a class="link" @click="handleThingView(scope.row)">{{scope.row.ofrresourceName + ' - ' + scope.row.ofrthingName}}</a>
                </template>
              </el-table-column>
              <!-- 自定义 -->
              <el-table-column
                :prop="'customize' + item.ofoFlowWorkConfigId"
                min-width="150"
                align="center"
                v-for="(item, index) in workConfig.workConfigList4"
                :key="item.ofoFlowWorkConfigId"
                :label="item.name">
                <template slot-scope="scope">
                  <DictTag :options="JSON.parse(scope.row.workConfigList4[index].options)" :value="scope.row.workConfigList4[index].configValue" v-if="scope.row.workConfigList4[index].showType == '2'"/>
                  <template v-else-if="scope.row.workConfigList4[index].showType == '1'">
                    {{scope.row.workConfigList4[index].configValue}}
                    <span v-if="scope.row.workConfigList4[index].showType == '1' && scope.row.workConfigList4[index].configValue">%</span>
                  </template>
                  <!-- <template v-else-if="scope.row.workConfigList4[index].showType == '5'">
                    {{scope.row.workConfigList4[index].configValue}}
                  </template> -->
                  <template v-else>
                    {{scope.row.workConfigList4[index].configValue}}
                  </template>
                </template>
              </el-table-column>
              <!-- 包装核算 -->
              <template v-if="params.bzhs === '0' && ofoFlowWork.bzhs === '0'">
                <el-table-column
                  prop="bzsl"
                  label="包装数量"
                  min-width="150">
                </el-table-column>
                <el-table-column
                  prop="bzdw"
                  label="包装单位"
                  min-width="120">
                </el-table-column>
                <el-table-column
                  prop="bzxs"
                  label="包装系数"
                  min-width="120">
                </el-table-column>
              </template>
              <!-- <el-table-column v-for="(item, index) in obussDimeList" :key="index" :label="item.dimeName" :prop="item.dimeValue">
                <template slot-scope="scope">
                  <span>{{scope.row.obussDimeList[index].dimeValue}}</span>
                </template>
              </el-table-column> -->
              <!-- 起始数量 -->
              <el-table-column
                prop="beginValue"
                label="起始数量"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '8'">
              </el-table-column>
              <!-- 终止数量 -->
              <el-table-column
                prop="endValue"
                label="终止数量"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '8'">
              </el-table-column>
              <!-- 数量期间 -->
              <el-table-column
                prop="quantity"
                label="数量"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '8'">
                <template slot-scope="scope">{{scope.row.quantity}}
                </template>
              </el-table-column>
              <el-table-column
                prop="beginValue"
                label="系统库存"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '11'">
              </el-table-column>
              <!-- 终止数量 -->
              <el-table-column
                prop="endValue"
                label="实际库存"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '11'">
              </el-table-column>
              <!-- 数量期间 -->
              <el-table-column
                prop="quantity"
                label="盈亏数量"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '11'">
                <template slot-scope="scope">{{scope.row.quantity}}
                </template>
              </el-table-column>
              <!-- 数量 -->
              <el-table-column
                :prop="'quantity' + item.ofoFlowWorkConfigId"
                min-width="150"
                align="right"
                v-for="(item, index) in workConfig.workConfigList1"
                :key="item.ofoFlowWorkConfigId"
                :label="item.name"
                v-if="ofoFlowWork.costmanagetype != '7' && ofoFlowWork.costmanagetype != '10' && ofoFlowWork.costmanagetype != '8' && ofoFlowWork.costmanagetype != '11' && ofoFlowWork.costmanagetype != '4'">
                <template slot-scope="scope">
                  <DictTag :options="JSON.parse(scope.row.workConfigList1[index].options)" :value="scope.row.workConfigList1[index].configValue" v-if="scope.row.workConfigList1[index].showType == '2'"/>
                  <div v-else>
                    {{scope.row.workConfigList1[index].configValue}}
                    <span v-if="scope.row.workConfigList1[index].showType == '1' && scope.row.workConfigList1[index].configValue">%</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="quantity"
                label="数量"
                min-width="150"
                align="right"
                header-align="center"
                v-if="ofoFlowWork.costmanagetype != '7' && ofoFlowWork.costmanagetype != '10' && ofoFlowWork.costmanagetype != '8' && ofoFlowWork.costmanagetype != '11'">
                <!-- <template slot-scope="scope">{{comdifyPrams1(scope.row.quantity)}}</template> -->
              </el-table-column>
              <el-table-column
                prop="quantityKz"
                label="(控制)数量"
                min-width="150"
                align="right"
                v-if="limit.quantity && limit.quantity.limitRate">
                <template slot-scope="scope">
                  {{scope.row.ofoFlowWorkLimitShow.quantity}}
                </template>
              </el-table-column>
              <el-table-column
                prop="quantityQz"
                label="(前置)数量"
                min-width="150"
                align="right"
                v-if="limit.quantity">
                <template slot-scope="scope">
                  {{scope.row.ofoFlowWorkLimitShow.preQuantity}}
                </template>
              </el-table-column>
              <!-- 开始时间 -->
              <el-table-column
                prop="beginValue"
                label="开始时间"
                width="250"
                align="center"
                v-if="ofoFlowWork.costmanagetype == '7' || ofoFlowWork.costmanagetype == '10'">
              </el-table-column>
              <!-- 结束时间 -->
              <el-table-column
                prop="endValue"
                label="结束时间"
                width="250"
                align="center"
                v-if="ofoFlowWork.costmanagetype == '7' || ofoFlowWork.costmanagetype == '10'">
              </el-table-column>
              <el-table-column
                prop="quantity"
                label="时间(天)"
                width="150"
                v-if="ofoFlowWork.costmanagetype == '10'">
              </el-table-column>
              <!-- 时间期间 -->
              <el-table-column
                prop="quantity"
                label="时间期间"
                width="150"
                v-if="ofoFlowWork.costmanagetype == '7'">
                <template slot-scope="scope">{{scope.row.quantity | filter_handleTimeRange}}
                </template>
              </el-table-column>
              <!-- 单价 -->
              <el-table-column
                :prop="'price' + item.ofoFlowWorkConfigId"
                min-width="150"
                align="right"
                v-for="(item, index) in workConfig.workConfigList2"
                :key="item.ofoFlowWorkConfigId"
                :label="item.name"
                v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5'">
                <template slot-scope="scope">
                  <DictTag :options="JSON.parse(scope.row.workConfigList2[index].options)" :value="scope.row.workConfigList2[index].configValue" v-if="scope.row.workConfigList2[index].showType == '2'"/>
                  <div v-else>
                    {{scope.row.workConfigList2[index].configValue | comdify('no')}}
                    <span v-if="scope.row.workConfigList2[index].showType == '1' && scope.row.workConfigList2[index].configValue">%</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="price"
                align="right"
                min-width="150"
                label="单价（含税）"
                v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5' || ofoFlowWork.costmanagetype == '11' || handleDutys(ofoFlowWork.dutys, 'priceType')">
                <template slot-scope="scope">{{comdifyPrams(scope.row.price)}}</template>
              </el-table-column>
              <el-table-column
                prop="priceKz"
                label="(控制)单价"
                min-width="150"
                align="right"
                v-if="limit.price && limit.price.limitRate">
                <template slot-scope="scope">
                  {{scope.row.ofoFlowWorkLimitShow.price | comdify}}
                </template>
              </el-table-column>
              <el-table-column
                prop="priceQz"
                label="(前置)单价"
                min-width="150"
                align="right"
                v-if="limit.price">
                <template slot-scope="scope">
                  {{scope.row.ofoFlowWorkLimitShow.prePrice | comdify}}
                </template>
              </el-table-column>
              <!-- 金额 -->
              <el-table-column
                :prop="'total' + item.ofoFlowWorkConfigId"
                min-width="150"
                align="right"
                v-for="(item, index) in workConfig.workConfigList3"
                :key="item.ofoFlowWorkConfigId"
                :label="item.name"
                v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '4' || ofoFlowWork.costmanagetype == '5'">
                <template slot-scope="scope">
                  <DictTag :options="JSON.parse(scope.row.workConfigList3[index].options)" :value="scope.row.workConfigList3[index].configValue" v-if="scope.row.workConfigList3[index].showType == '2'"/>
                  <div v-else>
                    {{scope.row.workConfigList3[index].configValue | comdify('no')}}
                    <span v-if="scope.row.workConfigList3[index].showType == '1' && scope.row.workConfigList3[index].configValue">%</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="total"
                align="right"
                min-width="150"
                header-align="center"
                label="金额（含税）"
                v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5' || ofoFlowWork.costmanagetype == '11' || handleDutys(ofoFlowWork.dutys, 'priceType')">
                <template slot-scope="scope">{{scope.row.total | comdify}}</template>
              </el-table-column>
              <el-table-column
                prop="lineTotalKz"
                label="(控制)金额"
                min-width="150"
                align="right"
                v-if="limit.lineTotal && limit.price.limitRate">
                <template slot-scope="scope">
                  {{scope.row.ofoFlowWorkLimitShow.lineTotal | comdify}}
                </template>
              </el-table-column>
              <el-table-column
                prop="lineTotalQz"
                label="(前置)金额"
                min-width="150"
                align="right"
                v-if="limit.lineTotal">
                <template slot-scope="scope">
                  {{scope.row.ofoFlowWorkLimitShow.preLineTotal | comdify}}
                </template>
              </el-table-column>
              <!-- 费用金额 -->
              <el-table-column
                prop="total"
                label="费用金额"
                min-width="200"
                align="right"
                header-align="center"
                v-if="ofoFlowWork.costmanagetype == '4'">
                <template slot-scope="scope">{{scope.row.price | comdify}}</template>
              </el-table-column>
              <!-- 税率 -->
              <el-table-column
                prop="vatgroup"
                label="税率"
                align="center"
                min-width="100"
                v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
                <template slot-scope="scope">
                  <DictTag :options="dropDown.invoiceVat" :value="scope.row.vatgroup"/>
                </template>
              </el-table-column>
              <!-- 税额 -->
              <el-table-column
                prop="totalVat"
                label="税额"
                align="right"
                min-width="100"
                v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
                <template slot-scope="scope">{{scope.row.totalVat | comdify}}</template>
              </el-table-column>
              <!-- 票种 -->
              <el-table-column
                prop="invoicetype"
                label="票种"
                align="center"
                min-width="200"
                v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
                <template slot-scope="scope">
                  <DictTag :options="dropDown.invoiceType" :value="scope.row.invoicetype"/>
                </template>
              </el-table-column>
              <!-- 成本单价 -->
              <el-table-column
                prop="cost"
                align="right"
                min-width="150"
                label="成本单价（含税）"
                v-if="ofoFlowWork.costmanagetype == '2'">
                <template slot-scope="scope">{{comdifyPrams(scope.row.cost)}}</template>
              </el-table-column>
              <!-- 成本金额 -->
              <el-table-column
                prop="costTotal"
                align="right"
                min-width="150"
                label="成本金额（含税）"
                v-if="ofoFlowWork.costmanagetype == '2'">
                <template slot-scope="scope">{{scope.row.costTotal | comdify}}</template>
              </el-table-column>
              <!-- 成本税额 -->
              <el-table-column
                prop="costTotalVat"
                label="成本税额"
                align="right"
                min-width="100"
                v-if="ofoFlowWork.costmanagetype == '2'">
                <template slot-scope="scope">{{scope.row.costTotalVat | comdify}}</template>
              </el-table-column>
              <!-- 备注 -->
              <el-table-column
                prop="remark"
                label="备注"
                min-width="150">
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
          type="index"
          label="行号"
          width="50">
        </el-table-column>
        <!-- 位置 -->
        <el-table-column
          prop="cbowhName"
          :label="cbowhName(1)"
          width="115"
          type=""
          v-if="ofoFlowWork.chooseOwh == '0' && (allShow || confirmResShow.includes('cbowhName'))">
        </el-table-column>
        <!-- 位置2 -->
        <el-table-column
          prop="cbowhToName"
          :label="cbowhName(2)"
          width="115"
          v-if="ofoFlowWork.stockaccttype == '7' && (allShow || confirmResShow.includes('cbowhToName'))">
        </el-table-column>
        <!-- 货物或应税劳务、服务名称 -->
        <el-table-column
          prop="ofrresourceName"
          :label="ofoFlowWork.kindtypeName"
          min-width="200"
          v-if="(allShow || confirmResShow.includes('ofrresourceName'))">
          <template slot-scope="scope">
            <a class="link" @click="handleResourceView(scope.row)">{{scope.row.ofrresourceName}}</a>
          </template>
        </el-table-column>

        <template v-if="ofoFlowWork.costmanagetype != '9' && ofoFlowWork.ggdw === '0'">
          <el-table-column property="ggxh" prop="ggxh" width="250" show-overflow-tooltip label="规格型号" v-if="(allShow || confirmResShow.includes('ggxh'))"></el-table-column>
          <el-table-column property="jldw" prop="jldw" label="单位" v-if="(allShow || confirmResShow.includes('jldw'))"></el-table-column>
        </template>
        <template v-if="ofoFlowWork.costmanagetype == '9'">
          <el-table-column v-for="item in resDimeList" :key="item.cbdId" :label="item.dimeName" width="200" v-if="item.workshow == '0' && (allShow || confirmResShow.includes('dimension' + item.cbdId))" :prop="'dimension' + item.cbdId">
            <template slot-scope="scope">
              {{scope.row.dimensionList.find(val => val.cbdId == item.cbdId)?.dimeText}}
            </template>
          </el-table-column>
          <el-table-column :prop="jyjl" label="检验结论" width="150" v-if="allShow || confirmResShow.includes('jyjl')">
            <template slot-scope="scope">
              {{scope.row.beginValue == '0' ? '符合规定' : (scope.row.beginValue == '1' ? '不符合规定' : '')}}
            </template>
          </el-table-column>
        </template>
        <!-- 自定义 -->
        <el-table-column
          :prop="'customize' + item.ofoFlowWorkConfigId"
          min-width="150"
          align="center"
          v-for="(item, index) in workConfig.workConfigList4"
          :key="index"
          :label="item.name"
          v-if="!ofoFlowWork.thingtype && (allShow || confirmResShow.includes('customize' + item.ofoFlowWorkConfigId))">
          <template slot-scope="scope">
            <DictTag :options="JSON.parse(scope.row.workConfigList4[index].options)" :value="scope.row.workConfigList4[index].configValue" v-if="scope.row.workConfigList4[index].showType == '2'"/>
            <template v-else-if="scope.row.workConfigList4[index].showType == '1'">
              {{scope.row.workConfigList4[index].configValue}}
              <span v-if="scope.row.workConfigList4[index].showType == '1' && scope.row.workConfigList4[index].configValue">%</span>
            </template>
            <!-- <template v-else-if="scope.row.workConfigList4[index].showType == '5'">
              {{scope.row.workConfigList4[index].configValue}}
            </template> -->
            <template v-else>
              {{scope.row.workConfigList4[index].configValue}}
            </template>
          </template>
        </el-table-column>

        <!-- 包装核算 -->
        <template v-if="params.bzhs === '0' && ofoFlowWork.bzhs === '0'">
          <el-table-column
            prop="bzsl"
            label="包装数量"
            min-width="150">
          </el-table-column>
          <el-table-column
            prop="bzdw"
            label="包装单位"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="bzxs"
            label="包装系数"
            min-width="120">
          </el-table-column>
        </template>

        <!-- <el-table-column v-for="(item, index) in obussDimeList" :key="index" :label="item.dimeName" :prop="item.dimeValue">
          <template slot-scope="scope">
            <span>{{scope.row.obussDimeList[index].dimeValue}}</span>
          </template>
        </el-table-column> -->
        <!-- 数量模式 -->
        <template v-if="ofoFlowWork.costmanagetype == '8'">
          <!-- 起始数量 -->
          <el-table-column
            prop="beginValue"
            label="起始数量"
            min-width="100"
            v-if="(allShow || confirmResShow.includes('beginValue'))">
          </el-table-column>
          <!-- 终止数量 -->
          <el-table-column
            prop="endValue"
            label="终止数量"
            min-width="100"
            v-if="(allShow || confirmResShow.includes('endValue'))">
          </el-table-column>
        </template>
        <template v-if="ofoFlowWork.costmanagetype == '11'">
          <!-- 起始数量 -->
          <el-table-column
            prop="beginValue"
            label="系统库存"
            min-width="100"
            v-if="(allShow || confirmResShow.includes('beginValue'))">
          </el-table-column>
          <!-- 终止数量 -->
          <el-table-column
            prop="endValue"
            label="实际库存"
            min-width="100"
            v-if="(allShow || confirmResShow.includes('endValue'))">
          </el-table-column>
        </template>
        <!-- 数量 -->
        <el-table-column
          :prop="'quantity' + item.ofoFlowWorkConfigId"
          min-width="150"
          align="right"
          v-for="(item, index) in workConfig.workConfigList1"
          :key="item.ofoFlowWorkConfigId"
          :label="item.name"
          v-if="ofoFlowWork.costmanagetype != '7' && ofoFlowWork.costmanagetype != '10' && ofoFlowWork.costmanagetype != '8' && ofoFlowWork.costmanagetype != '11' && ofoFlowWork.costmanagetype != '4' && !ofoFlowWork.thingtype && (allShow || confirmResShow.includes('quantity' + item.ofoFlowWorkConfigId))">
          <template slot-scope="scope">
            <DictTag :options="JSON.parse(scope.row.workConfigList1[index].options)" :value="scope.row.workConfigList1[index].configValue" v-if="scope.row.workConfigList1[index].showType == '2'"/>
            <div v-else>
              {{scope.row.workConfigList1[index].configValue}}
              <span v-if="scope.row.workConfigList1[index].showType == '1' && scope.row.workConfigList1[index].configValue">%</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="数量"
          min-width="150"
          align="right"
          header-align="center"
          v-if="ofoFlowWork.costmanagetype != '7' && ofoFlowWork.costmanagetype != '10' && ofoFlowWork.costmanagetype != '11' && ofoFlowWork.costmanagetype != '4' && (allShow || confirmResShow.includes('quantity'))">
          <!-- <template slot-scope="scope">{{comdifyPrams1(scope.row.quantity)}}</template> -->
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="盈亏数量"
          min-width="150"
          align="right"
          header-align="center"
          v-if="ofoFlowWork.costmanagetype == '11' && (allShow || confirmResShow.includes('quantity'))">
          <!-- <template slot-scope="scope">{{comdifyPrams1(scope.row.quantity)}}</template> -->
        </el-table-column>
        <el-table-column
          prop="quantityKz"
          label="(控制)数量"
          min-width="150"
          align="right"
          v-if="limit.quantity && !ofoFlowWork.thingtype && limit.quantity.limitRate && (allShow || confirmResShow.includes('quantityKz'))">
          <template slot-scope="scope">
            {{scope.row.ofoFlowWorkLimitShow.quantity}}
          </template>
        </el-table-column>
        <el-table-column
          prop="quantityQz"
          label="(前置)数量"
          min-width="150"
          align="right"
          v-if="limit.quantity && !ofoFlowWork.thingtype && (allShow || confirmResShow.includes('quantityQz'))">
          <template slot-scope="scope">
            {{scope.row.ofoFlowWorkLimitShow.preQuantity}}
          </template>
        </el-table-column>
        <!-- 时间期间 -->
        <template v-if="ofoFlowWork.costmanagetype == '7' || ofoFlowWork.costmanagetype == '10'">
          <!-- 开始时间 -->
          <el-table-column
            prop="beginValue"
            label="开始时间"
            width="250"
            align="center"
            v-if="(allShow || confirmResShow.includes('beginValue'))">
          </el-table-column>
          <!-- 结束时间 -->
          <el-table-column
            prop="endValue"
            label="结束时间"
            width="250"
            align="center"
            v-if="(allShow || confirmResShow.includes('endValue'))">
          </el-table-column>
          <el-table-column
            prop="quantity"
            label="时间(天)"
            width="150"
            align="center"
            v-if="(ofoFlowWork.costmanagetype == '10' && (allShow || confirmResShow.includes('quantity')))">
          </el-table-column>
          <!-- 时间期间 -->
          <el-table-column
            prop="quantity"
            label="时间期间1"
            width="150"
            v-if="(ofoFlowWork.costmanagetype == '7' && (allShow || confirmResShow.includes('quantity')))">
            <template slot-scope="scope">{{scope.row.quantity | filter_handleTimeRange}}
            </template>
          </el-table-column>
        </template>

        <!-- 单价 -->
        <el-table-column
          :prop="'price' + item.ofoFlowWorkConfigId"
          min-width="150"
          align="right"
          v-for="(item, index) in workConfig.workConfigList2"
          :key="item.ofoFlowWorkConfigId"
          :label="item.name"
          v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !ofoFlowWork.thingtype && (allShow || confirmResShow.includes('price' + item.ofoFlowWorkConfigId))">
          <template slot-scope="scope">
            <DictTag :options="JSON.parse(scope.row.workConfigList2[index].options)" :value="scope.row.workConfigList2[index].configValue" v-if="scope.row.workConfigList2[index].showType == '2'"/>
            <div v-else>
              {{scope.row.workConfigList2[index].configValue | comdify('no')}}
              <span v-if="scope.row.workConfigList2[index].showType == '1' && scope.row.workConfigList2[index].configValue">%</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          label="单价（含税）"
          min-width="150"
          align="right"
          v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5' || ofoFlowWork.costmanagetype == '11' || handleDutys(ofoFlowWork.dutys,'priceType')) && (allShow || confirmResShow.includes('price'))">
          <template slot-scope="scope">{{comdifyPrams(scope.row.price)}}</template>
        </el-table-column>
        <el-table-column
          prop="priceKz"
          label="(控制)单价"
          min-width="150"
          align="right"
          v-if="limit.price && !ofoFlowWork.thingtype && limit.price.limitRate && (allShow || confirmResShow.includes('priceKz'))">
          <template slot-scope="scope">
            {{scope.row.ofoFlowWorkLimitShow.price | comdify}}
          </template>
        </el-table-column>
        <el-table-column
          prop="priceQz"
          label="(前置)单价"
          min-width="150"
          align="right"
          v-if="limit.price && !ofoFlowWork.thingtype && (allShow || confirmResShow.includes('priceQz'))">
          <template slot-scope="scope">
            {{scope.row.ofoFlowWorkLimitShow.prePrice | comdify}}
          </template>
        </el-table-column>
        <!-- 金额 -->
        <el-table-column
          :prop="'total' + item.ofoFlowWorkConfigId"
          min-width="150"
          align="right"
          v-for="(item, index) in workConfig.workConfigList3"
          :key="item.ofoFlowWorkConfigId"
          :label="item.name"
          v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '4' || ofoFlowWork.costmanagetype == '5') && !ofoFlowWork.thingtype && (allShow || confirmResShow.includes('total' + item.ofoFlowWorkConfigId))">
          <template slot-scope="scope">
            <DictTag :options="JSON.parse(scope.row.workConfigList3[index].options)" :value="scope.row.workConfigList3[index].configValue" v-if="scope.row.workConfigList3[index].showType == '2'"/>
            <div v-else>
              {{scope.row.workConfigList3[index].configValue | comdify('no')}}
              <span v-if="scope.row.workConfigList3[index].showType == '1' && scope.row.workConfigList3[index].configValue">%</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="total"
          label="金额（含税）"
          min-width="150"
          align="right"
          header-align="center"
          v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5' || ofoFlowWork.costmanagetype == '11' || handleDutys(ofoFlowWork.dutys,'priceType')) && (allShow || confirmResShow.includes('total'))">
          <template slot-scope="scope">{{scope.row.total | comdify}}</template>
        </el-table-column>
        <el-table-column
          prop="lineTotalKz"
          label="(控制)金额"
          min-width="150"
          align="right"
          v-if="limit.lineTotal && !ofoFlowWork.thingtype && limit.price.limitRate && (allShow || confirmResShow.includes('lineTotalKz'))">
          <template slot-scope="scope">
            {{scope.row.ofoFlowWorkLimitShow.lineTotal | comdify}}
          </template>
        </el-table-column>
        <el-table-column
          prop="lineTotalQz"
          label="(前置)金额"
          min-width="150"
          align="right"
          v-if="limit.lineTotal && !ofoFlowWork.thingtype && (allShow || confirmResShow.includes('lineTotalQz'))">
          <template slot-scope="scope">
            {{scope.row.ofoFlowWorkLimitShow.preLineTotal | comdify}}
          </template>
        </el-table-column>
        <!-- 费用金额 -->
        <el-table-column
          prop="total"
          label="费用金额"
          min-width="200"
          align="right"
          header-align="center"
          v-if="ofoFlowWork.costmanagetype == '4' && (allShow || confirmResShow.includes('total'))">
          <template slot-scope="scope">{{scope.row.total | comdify}}</template>
        </el-table-column>
        <template v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
          <!-- 税率 -->
          <el-table-column
            prop="vatgroup"
            label="税率"
            align="center"
            min-width="100"
            v-if="(allShow || confirmResShow.includes('vatgroup'))">
            <template slot-scope="scope">
              <DictTag :options="dropDown.invoiceVat" :value="scope.row.vatgroup"/>
            </template>
          </el-table-column>
          <!-- 税额 -->
          <el-table-column
            prop="totalVat"
            label="税额"
            align="right"
            min-width="100"
            v-if="(allShow || confirmResShow.includes('totalVat'))">
            <template slot-scope="scope">{{scope.row.totalVat | comdify}}</template>
          </el-table-column>
          <!-- 票种 -->
          <el-table-column
            prop="invoicetype"
            label="票种"
            align="center"
            min-width="200"
            v-if="(allShow || confirmResShow.includes('invoicetype'))">
            <template slot-scope="scope">
              <DictTag :options="dropDown.invoiceType" :value="scope.row.invoicetype"/>
            </template>
          </el-table-column>
        </template>
        <!-- 成本 -->
        <template v-if="ofoFlowWork.costmanagetype == '2'">
          <!-- 成本单价 -->
          <el-table-column
            prop="cost"
            align="right"
            min-width="150"
            label="成本单价（含税）"
            v-if="(allShow || confirmResShow.includes('cost'))">
            <template slot-scope="scope">{{comdifyPrams(scope.row.cost)}}</template>
          </el-table-column>
          <!-- 成本金额 -->
          <el-table-column
            prop="costTotal"
            align="right"
            min-width="150"
            label="成本金额（含税）"
            v-if="(allShow || confirmResShow.includes('costTotal'))">
            <template slot-scope="scope">{{scope.row.costTotal | comdify}}</template>
          </el-table-column>
          <!-- 成本税额 -->
          <el-table-column
            prop="costTotalVat"
            label="成本税额"
            align="right"
            min-width="100"
            v-if="(allShow || confirmResShow.includes('costTotalVat'))">
            <template slot-scope="scope">{{scope.row.costTotalVat | comdify}}</template>
          </el-table-column>
        </template>

        <!-- 备注 -->
        <el-table-column
          prop="remark"
          label="备注"
          min-width="150"
          v-if="(allShow || confirmResShow.includes('remark'))">
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="disabled"
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[50, 100, 200]"
        :page-size="pageSize"
        layout="->, prev, pager, next, sizes, jumper, total"
        :total="total"
        style="margin: 16px 0"
      >
      </el-pagination>
      <div v-if="ofoFlowWork.thingtype" style="text-align: right;margin-top: 5px">明细共{{this.thingsList.length}}条</div>
      <table style="width: 100%" v-if="ofoFlowWork.costmanagetype == '4'">
        <tr style="height: 30px">
          <td style="width: 150px">合计</td>
          <td style="text-align:right">金额：{{ptotal1 | comdify}}</td>
        </tr>
      </table>
      <div class="container">
        <div class="amount-grid" v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5'">
          <div class="label">金额：</div>
          <div class="value">{{ptotalNovat1 | comdify}}</div>

          <div class="label">税额：</div>
          <div class="value">{{ptotalVat1 | comdify}}</div>

          <div class="label">价税合计：</div>
          <div class="value">{{ptotal1 | comdify}}</div>
        </div>
      </div>

<!--      <table style="width: 100%" v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5'">
        <tr>
          <td style="text-align:right">金额：{{ptotalNovat1 | comdify}}</td>
        </tr>
        <tr>
          <td style="text-align:right">税额：{{ptotalVat1 | comdify}}</td>
        </tr>
        <tr style="height: 30px">
          <td style="text-align:right">价税合计: {{ptotal1 | comdify}}</td>
        </tr>
        &lt;!&ndash; <tr>
          <td style="width: 150px"></td>
          <td>价税合计: {{ptotal1 | comdify}}</td>
        </tr> &ndash;&gt;
      </table>-->
      <table style="width: 100%" v-if="limit.total && !ofoFlowWork.thingtype && limit.total.limitRate">
        <tr style="height: 30px">
          <td style="width: 150px">控制合计</td>
          <td style="text-align:right">{{resLimit | comdify}}</td>
        </tr>
      </table>
      <table style="width: 100%" v-if="limit.total && !ofoFlowWork.thingtype">
        <tr style="height: 30px">
          <td style="width: 150px">前置合计</td>
          <td style="text-align:right">{{resPreLimit | comdify}}</td>
        </tr>
      </table>
      <table style="width: 100%; margin-top:10px;border-top: 1px solid #eeeeee" v-if="ofoFlowWork.costmanagetype == '2'">
        <tr style="height: 30px">
          <td style="width: 150px">成本合计</td>
          <td style="text-align:right">成本金额：{{ctotalNovat1 | comdify}}</td>
          <td style="text-align:right">成本税额：{{ctotalVat1 | comdify}}</td>
          <td style="text-align:right">成本价税合计: {{ctotal1 | comdify}}</td>
        </tr>
        <!-- <tr>
          <td style="width: 150px"></td>
          <td style="text-align:right">成本价税合计: {{ctotal1 | comdify}}</td>
        </tr> -->
      </table>
    </template>
    <!-- 复制从列表对话框 -->
    <el-dialog v-dialog-drag
      :title="`从 ${ofoFlowWork.beforeworkName} 复制到 ${ofoFlowWork.name}`"
      :visible.sync="dialogCopyFromVisible"
      width="70%"
      append-to-body
      top="59px">
      <div slot="title">
        {{`从 ${ofoFlowWork.beforeworkName} 复制到 ${ofoFlowWork.name}`}}
        <el-button plain size="mini" style="margin-left:16px" @click="changeExpand">{{isExpand ? '一键收起' : '一键展开'}}</el-button>
        <el-button plain size="mini"  style="margin-left:16px" @click="isFilter = !isFilter" >{{isFilter ? '过滤数量0' : '取消过滤'}}</el-button>
      </div>
      <el-form size="small" style="height: 50px;display: table-cell" :inline="true"  label-width="100px">
        <el-form-item label="单据名称" prop="workNameQuery">
          <el-input
            v-model="workNameQuery"
            placeholder="请输入单据名称"
            clearable
            @keyup.enter.native="copyFromAdd"
          />
        </el-form-item>
        <el-form-item label="单据编号" prop="workCodeQuery">
          <el-input
            v-model="workCodeQuery"
            placeholder="请输入单据编号"
            clearable
            @keyup.enter.native="copyFromAdd"
          />
        </el-form-item>
        <el-form-item label="资源" prop="ofrResourceNameQuery">
          <el-input
            v-model="ofrResourceNameQuery"
            placeholder="请输入资源名称"
            clearable
            @keyup.enter.native="copyFromAdd"
          />
        </el-form-item>
        <el-form-item label="交易方" prop="dealNameQuery">
          <el-input
            v-model="dealNameQuery"
            placeholder="请输入交易方"
            clearable
            @keyup.enter.native="copyFromAdd"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="copyFromAdd">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <span style="font-size: 12px;line-height: 45px;color: red;">不支持BOM单</span>
        </el-form-item>
      </el-form>
      <el-table
        :data="copyFromList"
        height="calc(100vh - 260px)"
        style="width: 100%;overflow: auto"
        :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
        v-loading="loading"
        :row-class-name="tableRowClassName"
        ref="tables"
        @cell-click="cellClick"
        @select="selectFather"
        @select-all="selectAllFather"
        @expand-change="expandChange"
        row-key="ofoWorkId"
      >
      <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              :data="props.row.ofoWorkResourceList"
              @select="(selection,row)=>selectChild(selection, row, props.$index)"
              @select-all="selectAllChild($event,props.$index)"
              :ref="'tableCopyFrom' + props.$index"
              @row-click="(row,column,e)=>handleCopyFromRowClick(row,column,e,props.$index)"
              :row-key="getRowKeyCopyFrom"
              :row-class-name="tableRowClassName2"
              style="width:97%; float:right"
              default-expand-all
              :summary-method="getSummaries"
              show-summary
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            >
              <el-table-column
                type="selection"
                width="80"
                :reserve-selection="true">
              </el-table-column>
              <el-table-column
                prop="ofrresourceName"
                label="产品名称">
              </el-table-column>
              <el-table-column
                prop="cbowhName"
                label="位置">
              </el-table-column>
              <el-table-column
                prop="ggxh" width="220" show-overflow-tooltip
                label="规格型号">
              </el-table-column>
              <el-table-column
                prop="jldw"
                label="单位" width="80">
              </el-table-column>
              <el-table-column
                v-if="props.row.ofoWorkResourceList[0].configValueList && props.row.ofoWorkResourceList[0].configValueList.length > 0"
                v-for="itemconfig in props.row.ofoWorkResourceList[0].configValueList" :key="itemconfig.ofoFlowWorkConfigId" :label="itemconfig.name"
              >
                <template slot-scope="configscope">
                  <span>{{configscope.row.configValueList.find(o => o.ofoFlowWorkConfigId === itemconfig.ofoFlowWorkConfigId)?.configValue}}</span>
                </template>
              </el-table-column>
              <template v-if="!ofoFlowWork.beforeworkConfig || ofoFlowWork.beforeworkConfig.indexOf('1') != -1">
                <!-- 数量 -->
                <el-table-column
                  prop="quantity"
                  align="right"
                  label="数量">
                </el-table-column>
                <!-- 剩余数量 -->
                <el-table-column
                  prop="openqty"
                  align="right"
                  label="剩余数量">
                  <template slot-scope="scope">
                    <strong style="font-size:18px">{{scope.row.openqty}}</strong>
                  </template>
                </el-table-column>
              </template>
              <template v-if="!ofoFlowWork.beforeworkConfig || ofoFlowWork.beforeworkConfig.indexOf('3') != -1">
                <!-- 金额 -->
                <el-table-column
                  prop="total"
                  align="right"
                  label="金额（含税）">
                  <template slot-scope="scope">{{scope.row.total | comdify}}</template>
                </el-table-column>
                <!-- 剩余金额 -->
                <el-table-column
                  prop="opentotal"
                  align="right"
                  label="剩余金额">
                  <template slot-scope="scope">
                    <strong style="font-size:18px">{{scope.row.opentotal | comdify}}</strong>
                  </template>
                </el-table-column>
              </template>
              <template v-if="ofoFlowWork.beforeworkConfig && ofoFlowWork.beforeworkConfig.indexOf('5') != -1">
                <!-- 库存 -->
                <el-table-column
                  prop="owh"
                  align="right"
                  label="库存" min-width="180">
                  <template slot-scope="scope">
                    <el-row :key="item.owhName" v-for="item in scope.row.ofrOwhResourceList">
                      <el-col :span="24">{{item.owhName}}：</el-col>
                      <el-col :span="24">{{item.resourceQuantity}}</el-col>
                    </el-row>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称">
        </el-table-column>
        <!-- 数量 -->
        <el-table-column
          prop="code"
          label="编号">
        </el-table-column>
        <!-- 金额 -->
        <!-- <el-table-column
          prop="total"
          align="right"
          label="金额（含税）">
          <template slot-scope="scope">{{scope.row.ptotal | comdify}}</template>
        </el-table-column> -->
        <!-- 活动日期 -->
        <el-table-column
          prop="total"
          align="center"
          label="日期">
          <template slot-scope="scope">{{scope.row.workDate | filter_handleDate}}</template>
        </el-table-column>
        <!-- 交易方 -->
        <el-table-column
          prop="dealName"
          label="交易方"
         >
        </el-table-column>
        <!-- 备注 -->
        <el-table-column
          prop="remarks"
          label="备注">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer" style="display:flex;justify-content:space-between">
        <div>
          <el-checkbox v-model="isCheckRemark">带入备注</el-checkbox>
          <el-checkbox @change="changeIsName" v-model="isName">带入名称</el-checkbox>
          <el-checkbox v-model="isWorkDate">带入日期</el-checkbox>
          <el-checkbox v-model="isPart">带入{{ params.deptName || '部门' }} {{ ofoFlowWork.falias || '单据负责人' }}</el-checkbox>
          <el-checkbox v-model="isRemarks">带入注释</el-checkbox>
          <!-- <el-checkbox v-model="isSameRes">是否只带同一资源类型</el-checkbox> -->
        </div>
        <div>
          <el-button @click="dialogCopyFromVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmCopyFrom">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <!-- 多选 -->
    <el-dialog :title="ofoFlowWork.kindtypeName" :visible.sync="dialogTableVisible" append-to-body top="59px" width="80%">
      <div slot="title">
        <el-select size="mini" style="width:180px" v-model="cbRestypeId" placeholder="请选择资源类型" @change="changeCbResourceType">
          <el-option value="-1" label="全部"></el-option>
          <el-option v-for="(item, index) in cbResourceTypeList" :key="index" :label="item.restypeName" :value="item.cbRestypeId"></el-option>
        </el-select>
        <el-input size="small" style="width:300px;margin-left:16px" v-model="codeSearch" placeholder="输入资源编号搜索" @keydown.enter.native="multipleChooseSearch" clearable/>
        <el-input size="small" style="width:300px;margin-left:16px" v-model="search" placeholder="输入名称搜索" @keydown.enter.native="multipleChooseSearch" clearable/>
        <el-input size="small" style="width:300px;margin-left:16px" v-model="search2" placeholder="输入规格型号搜索" @keydown.enter.native="multipleChooseSearch" clearable/>
        <el-button style="margin-left: 10px;" type="primary" size="mini" @click="multipleChooseSearch">搜索</el-button>
        <el-button style="margin-left: 10px;" type="primary" size="mini" @click="resetSearch">重置</el-button>
      </div>
      <div class="mutiple-contain" style="height:100%">
        <!-- <div class="mutiple-left" ref="querytree"> -->
        <div class="mutiple-left" v-if="cbussDimeTree.length">
          <!-- <el-select size="mini" style="width:180px;margin-bottom:8px" v-model="cbRestypeId" placeholder="请选择下一步活动类型" @change="changeCbResourceType" clearable>
            <el-option v-for="(item, index) in cbResourceTypeList" :key="index" :label="item.restypeName" :value="item.cbRestypeId"></el-option>
          </el-select>  -->
          <el-collapse v-model="activeNames" @change="handleChange1" style="width: 180px;">
            <el-collapse-item :title="item.label" :name="index + 1" v-for="(item, index) in cbussDimeTree" :key="index">
              <el-tree
                :data="item.children"
                :props="defaultProps"
                @node-click="handleNodeClick1($event, index)"
                default-expand-all
                :ref="'tree' + (index + 1)"
                :expand-on-click-node="false"
                highlight-current
                node-key="value">
              </el-tree>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="mutiple-right">
          <el-table
            :data="currentPageData"
            @selection-change="handleMultipleSelectionChange"
            ref="tableMultiple"
            @row-click="handleMultipleRowClick"
            :row-key="getRowKeyMultiple"
            :height="'calc(100vh - 260px)'"
            :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
          >
            <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
            <el-table-column property="resourceNumber" label="资源编号"></el-table-column>
            <el-table-column property="resourceName" label="名称" min-width="150"></el-table-column>
            <el-table-column property="ggxh" label="规格型号"></el-table-column>
            <el-table-column property="jldw" label="单位"></el-table-column>
            <el-table-column width="240" v-if="ofoFlowWork.isShowResourceStock == '0'">
              <template slot="header">
                <div style="display:flex;justify-content:space-between">
                  <div>位置</div>
                  <div>库存</div>
                </div>
              </template>
              <template slot-scope="scope">
                <el-table
                  v-if="scope.row.ofrOwhResourceList.length"
                  :data="scope.row.ofrOwhResourceList"
                  :show-header="false"
                >

                  <el-table-column property="owhName" width="120"></el-table-column>
                  <el-table-column property="resourceQuantity" width="100" align="right" header-align="center"></el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column property="resourceQuantity" label="总库存" width="100" align="right" header-align="center" v-if="ofoFlowWork.isShowResourceStock == '0'">
              <template slot-scope="scope">
                {{calcStock(scope.row.ofrOwhResourceList, 'resourceQuantity')}}
              </template>
            </el-table-column>
            <el-table-column property="availableQuantityList" label="可用数量" width="100" align="right" header-align="center">
              <template slot-scope="scope">
                {{handleCalc(scope.row.availableQuantityList)}}
              </template>
            </el-table-column>
            <el-table-column property="rprice" label="销售价" width="150" align="right" v-if="!ofoFlowWork.kindtype.includes(',')">
              <template slot-scope="scope">
                {{comdifyPrams(scope.row.rprice)}}
              </template>
            </el-table-column>
            <el-table-column property="cprice" label="成本价" width="150" align="right" v-if="!ofoFlowWork.kindtype.includes(',')">
              <template slot-scope="scope">
                {{comdifyPrams(scope.row.cprice)}}
              </template>
            </el-table-column>
            <!-- <el-table-column
              align="right"
              fixed="right"
              width="150">
              <template slot="header">
                <el-input
                  v-model="search"
                  size="small"
                  placeholder="输入名称搜索"
                  clearable/>
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination
            @size-change="handleSizeChangeMultiple"
            @current-change="handleCurrentChangeMultiple"
            :current-page="multiplePageNum"
            :page-sizes="[10, 20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="goodsList.length"
            style="text-align: right; margin-top: 20px;">
          </el-pagination>
        </div>
      </div>


      <div slot="footer" class="dialog-footer" style="display:flex;justify-content:space-between">
        <div>
          已选{{goods.length}}行
          <el-checkbox v-model="isCheckQuantity">是否带入可用数量</el-checkbox>
          <el-checkbox v-model="isCheckPrice">是否带入价格</el-checkbox>
        </div>
        <div>
          <el-button @click="dialogTableVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmMultiple">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 明细多选 -->
    <el-dialog v-dialog-drag    :title="ofoFlowWork.thingtypeName + '（明细）'" :visible.sync="dialogTableVisible2" append-to-body top="59px" width="80%" class="res-dialog">
      <div slot="title">
        {{ofoFlowWork.thingtypeName + '（明细）'}}
        <el-button type="text" @click="addThing" v-if="!disabled && isAdd == '0'" icon="el-icon-circle-plus-outline" style="padding: 0"></el-button>
      </div>
      <el-input size="small" style="width:300px;margin-bottom:10px" v-model="search2" placeholder="输入规格型号搜索" @change="searchChangeThing" clearable @keydown.enter.native="searchChangeThing"/>
      <el-table
        :data="currentPageThing"
        @selection-change="handleSelectionChange"
        ref="tableMultiple2"
        @row-click="handleRowClick"
        row-key="ofrThingId"
        :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
        :height="tableHeight"
      >
        <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
        <el-table-column property="ofrThingId" label="编号" width="100"></el-table-column>
        <!-- <el-table-column property="name" label="名称">
          <template slot-scope="scope"> {{scope.row.resourceName + ' - ' + scope.row.name}}</template>
        </el-table-column> -->
        <el-table-column property="resourceName" label="资源名称"></el-table-column>
        <el-table-column property="name" label="明细名称"></el-table-column>
        <el-table-column property="ggxh" label="规格型号"></el-table-column>
        <el-table-column property="jldw" label="单位"></el-table-column>
        <el-table-column width="240" v-if="ofoFlowWork.isShowThingStock == '0'">
          <template slot="header">
            <div style="display:flex;justify-content:space-between">
              <div>位置</div>
              <div>库存</div>
            </div>
          </template>
          <template slot-scope="scope">
            <el-table
              v-if="scope.row.ofrOwhThingList.length"
              :data="scope.row.ofrOwhThingList"
              :show-header="false"
            >

              <el-table-column property="owhName" width="120"></el-table-column>
              <el-table-column property="thingQuantity" width="100" align="right" header-align="center"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column property="thingQuantity" label="总库存" width="100" align="right" header-align="center" v-if="ofoFlowWork.isShowThingStock == '0'">
          <template slot-scope="scope">
            {{calcStock(scope.row.ofrOwhThingList, 'thingQuantity')}}
          </template>
        </el-table-column>
        <el-table-column
          align="right"
          width="150">
          <template slot="header">
            <el-input
              v-model="search3"
              size="small"
              placeholder="输入名称搜索"
              clearable
              @input="searchChangeThing"
              @keyup.enter.native="searchChangeThing"/>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChangeThing"
        @current-change="handleCurrentChangeThing"
        :current-page="pageThing.pageNum"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pageThing.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageThing.total"
        style="text-align: right; margin-top: 20px;">
      </el-pagination>
      <div slot="footer" class="dialog-footer" style="display:flex;justify-content:space-between">
        <div>已选{{goods2.length}}行</div>
        <div>
          <el-button @click="dialogTableVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="confirm()">确 定</el-button>
        </div>

      </div>
    </el-dialog>
    <!-- 新增内容 -->
    <el-dialog v-dialog-drag
      :title="'新增内容'"
      :visible.sync="dialogThingVisible"
      append-to-body
      top="59px" >
      <el-form
        :model="thingForm"
        :rules="rulesThing"
        ref="thingForm"
        class="demo-ruleForm"
        label-position="right"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="资源类型" prop="cbRestypeId">
              <el-select v-model="thingForm.cbRestypeId" filterable style="width: 100%" placeholder="请选择资源类型" @change="getCbussDimeList1">
                <el-option
                  v-for="(item, index) in cbResourceTypeList2"
                  :key="index"
                  :label="item.restypeName"
                  :value="item.cbRestypeId"
                  v-if="item.isAdd == '0'"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="选择资源" prop="ofrResourceId">
              <el-select v-model="thingForm.ofrResourceId" filterable style="width: 97%" placeholder="请选择资源">
                <el-option
                v-for="(item, index) in resourceList"
                :key="index"
                :label="item.resourceName + (item.ggxh ? ('【' + item.ggxh + '】') : '') + (item.jldw ? ('【' + item.jldw + '】') : '')"
                :value="item.ofrResourceId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input
                v-model="thingForm.name"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="描述" prop="remarks">
              <el-input
                v-model="thingForm.remarks"
                placeholder="请输入描述"
                style="width:97%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <Form :formList="thingFormList" :workDate="workDate" :gutter="20" :ruleForm="thingForm"/>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogThingVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitThingForm('thingForm')" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新增资源 -->
    <el-dialog v-dialog-drag
      title="新增资源"
      :visible.sync="dialogResourceVisible"
      append-to-body
      top="59px"
      class="res-dialog">
      <el-form
        :model="resourceForm"
        :rules="rulesReource"
        ref="resourceForm"
        class="demo-ruleForm"
        label-position="right"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="选择资源" prop="cbRestypeId">
              <el-select v-model="resourceForm.cbRestypeId" style="width:98%" filterable @change="changeRes">
                <el-option
                  v-for="item in cbResourceTypeList"
                  :label="item.restypeName"
                  :value="item.cbRestypeId"
                  :key="item.cbRestypeId"
                  v-if="item.isAdd == '0'"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称" prop="resourceName">
              <el-input
                v-model="resourceForm.resourceName"
                :placeholder="'请输入' + resData.restypeName + '名称'"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isPrivate == '0'">
            <el-form-item label="归属人" prop="userId">
              <el-select v-model="resourceForm.userId" placeholder="请选择归属人" style="width:97%" filterable>
                <el-option-group
                  v-for="group in userList"
                  :key="group.ofrResourceId"
                  :label="group.resourceName">
                  <el-option
                    v-for="item in group.ofrThingList"
                    :key="item.ofrThingId"
                    :label="item.name"
                    :value="item.ofrThingId">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isShowPrice == '0'">
            <el-form-item label="销售价" prop="rprice">
              <el-input
                v-model="resourceForm.rprice"
                placeholder="请输入销售价"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isShowPrice == '0'">
            <el-form-item label="成本价" prop="cprice">
              <el-input
                v-model="resourceForm.cprice"
                placeholder="请输入成本价"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="规格型号" prop="ggxh">
              <el-input
                v-model="resourceForm.ggxh"
                placeholder="请输入规格型号"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="单位" prop="jldw">
              <el-input
                v-model="resourceForm.jldw"
                placeholder="请输入单位"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="(resData.kind == '2' || resData.kind == '3')">
            <el-form-item label="双计系数" prop="sjxs">
              <el-input-number
                v-model="resourceForm.sjxs"
                placeholder="请输入双计系数"
                style="width: 97%"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="(resData.kind == '2' || resData.kind == '3')">
            <el-form-item label="双计单位" prop="sjdw">
              <el-input
                v-model="resourceForm.sjdw"
                placeholder="请输入双计单位"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <Form :formList="resourceFormList" :gutter="20" :ruleForm="resourceForm"/>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogResourceVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitResourceForm('resourceForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改资源对话框 -->
    <el-dialog v-dialog-drag
               title="修改资源"
               :visible.sync="editResourceDialog"
               :append-to-body="true"
    >
      <el-form
        :model="editRuleFormRes"
        :rules="editRules"
        ref="editRuleFormRes"
        class="demo-ruleFormRes"
        style="max-height: 50vh; overflow-y: auto;overflow-x: hidden"
        label-position="right"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称" prop="resourceName">
              <el-input
                v-model="editRuleFormRes.resourceName"
                :placeholder="'请输入' + resData.restypeName + '名称'"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isPrivate == '0'">
            <el-form-item label="归属人" prop="userId">
              <el-select v-model="editRuleFormRes.userId" placeholder="请选择归属人" style="width:97%" filterable>
                <el-option-group
                  v-for="group in userList"
                  :key="group.ofrResourceId"
                  :label="group.resourceName">
                  <el-option
                    v-for="item in group.ofrThingList"
                    :key="item.ofrThingId"
                    :label="item.name"
                    :value="item.ofrThingId">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isShowPrice == '0'">
            <el-form-item label="销售价" prop="rprice">
              <el-input
                v-model="editRuleFormRes.rprice"
                placeholder="请输入销售价"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isShowPrice == '0'">
            <el-form-item label="成本价" prop="cprice">
              <el-input
                v-model="editRuleFormRes.cprice"
                placeholder="请输入成本价"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isShowPrice == '0'">
            <el-form-item label="税率" prop="rslv">

              <el-select v-model="editRuleFormRes.rslv" placeholder="请选择税率" style="width:97%" clearable>
                <el-option
                  v-for="item in dropDown.invoiceVat"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="规格型号" prop="ggxh">
              <el-input
                v-model="editRuleFormRes.ggxh"
                placeholder="请输入规格型号"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="单位" prop="jldw">
              <el-input
                v-model="editRuleFormRes.jldw"
                placeholder="请输入单位"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="双计系数" prop="sjxs">
              <el-input
                type="number"
                v-model="editRuleFormRes.sjxs"
                placeholder="请输入双计系数"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="双计单位" prop="sjdw">
              <el-input
                v-model="editRuleFormRes.sjdw"
                placeholder="请输入双计单位"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <Form :formList="editFormList" :gutter="20" :ruleForm="editRuleFormRes"/>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editResourceDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitResEditForm('editRuleFormRes')">确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 多行编辑 -->
    <el-dialog v-dialog-drag
      :title="sel == 'vatgroup' ? '选择税率' : (sel == 'invoicetype' ? '选择票种' : (sel == 'cbowhId' ? '选择位置' : sel == 'cbowhTo' ? '选择位置2' : ''))"
      :visible.sync="dialogSelectVisible"
      append-to-body
      class="res-dialog"
      top="59px"
      width="25%">
      <el-radio-group v-model="select" v-if="sel == 'vatgroup'">
        <el-radio v-for="(item, index) in dropDown.invoiceVat" :key="index" :label="item.dictValue" style="margin-bottom:16px;">{{item.dictLabel}}</el-radio>
      </el-radio-group>
      <el-radio-group v-model="select" v-if="sel == 'invoicetype'">
        <el-radio v-for="(item, index) in dropDown.invoiceType" :key="index" :label="item.dictValue" style="margin-bottom:16px">{{item.dictLabel}}</el-radio>
      </el-radio-group>
      <el-tree
        v-if="sel == 'cbowhId' || sel == 'cbowhTo'"
        ref="treeList"
        :data="cbOwhData1"
        :props="{label: 'name', id: 'cbOwhId'}"
        node-key="cbOwhId"
        check-strictly
        highlight-current
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
        default-expand-all
        >
      </el-tree>
      <!-- <el-select v-model="select" filterable clearable style="width:100%" v-if="sel == 'cbowhId'">
        <el-option
        v-for="(item, index) in cbOwhData"
        :key="index"
        :label="item.name"
        :value="item.cbOwhId"
        ></el-option>
      </el-select> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSelectVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSelect">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入对话框 -->
    <el-dialog v-dialog-drag
      :title="`导入${ofoFlowWork.kindtypeName}`"
      :visible.sync="dialogVisible"
      width="30%"
      append-to-body
      top="59px"
      class="res-dialog"
      >
      <el-upload
        class="upload-demo"
        :auto-upload="false"
        drag
        action="#"
        multiple
        accept=".xlsx, .xls"
        :show-file-list="false"
        :on-change="handleChange">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="exportBtn">下载模板</el-link>
        </div>
      </el-upload>
      <span style="margin-top:10px;color:red;display:inline-block">注：黄色字体表示选中多条资源</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
      </span>
    </el-dialog>
    <!-- 活动核销列表对话框 -->
    <el-dialog v-dialog-drag
      :title="`活动核销-${ruleFormParent.dealName}`"
      :visible.sync="dialogCheckVisible"
      width="90%"
      append-to-body
      top="59px">
      <div style="display: flex">
        <div style="width:50%;height:300px">
          <el-table
            :data="copyCheckWorkListBefore"
            height="100%"
            style="width: 100%;overflow: auto"
            :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
            v-loading="loading"
            ref="tableCheck1"
            @row-click="rowClickCheck1"
            @selection-change="handleSelectionChange1"
            :row-key="'ofoWorkId'"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table
                  :data="props.row.ofoWorkResourceList"
                  style="width:97%; float:right"
                  default-expand-all
                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                >
                  <el-table-column
                    prop="ofrresourceName"
                    label="产品名称">
                  </el-table-column>
                  <el-table-column
                    prop="cbowhName"
                    label="位置">
                  </el-table-column>
                  <template v-if="!ofoFlowWork.beforeworkConfig || ofoFlowWork.beforeworkConfig.indexOf('1') != -1">
                    数量
                    <el-table-column
                      prop="quantity"
                      align="right"
                      label="数量">
                    </el-table-column>
                    剩余数量
                    <el-table-column
                      prop="openqty"
                      align="right"
                      label="剩余数量">
                      <template slot-scope="scope">
                        <strong style="font-size:18px">{{scope.row.openqty}}</strong>
                      </template>
                    </el-table-column>
                  </template>
                  <template v-if="!ofoFlowWork.beforeworkConfig || ofoFlowWork.beforeworkConfig.indexOf('3') != -1">
                    金额
                    <el-table-column
                      prop="total"
                      align="right"
                      label="金额（含税）">
                      <template slot-scope="scope">{{scope.row.total | comdify}}</template>
                    </el-table-column>
                    剩余金额
                    <el-table-column
                      prop="openqty"
                      align="right"
                      label="剩余金额">
                      <template slot-scope="scope">
                        <strong style="font-size:18px">{{scope.row.opentotal | comdify}}</strong>
                      </template>
                    </el-table-column>
                  </template>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称">
            </el-table-column>
            <!-- 数量 -->
            <el-table-column
              prop="code"
              label="编号">
            </el-table-column>
            <!-- 活动日期 -->
            <el-table-column
              prop="workDate"
              align="center"
              label="日期">
              <template slot-scope="scope">{{scope.row.workDate | filter_handleDate}}</template>
            </el-table-column>
            <!-- 订单金额 -->
            <el-table-column
              prop="total"
              align="right"
              label="订单金额">
              <template slot-scope="scope">{{scope.row.ptotal | comdify}}</template>
            </el-table-column>
            <!-- 金额 -->
            <el-table-column
              prop="total"
              align="right"
              label="未核销金额">
              <template slot-scope="scope">{{scope.row.openTotal | comdify}}</template>
            </el-table-column>
          </el-table>
        </div>
        <div style="width:50%;height:300px">
          <el-table
            :data="copyCheckWorkListAfter"
            height="100%"
            style="width: 100%;overflow: auto"
            :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
            v-loading="loading"
            ref="tableCheck2"
            @row-click="rowClickCheck2"
            @selection-change="handleSelectionChange2"
            :row-key="'ofoWorkId'"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table
                  :data="props.row.ofoWorkResourceList"
                  style="width:97%; float:right"
                  default-expand-all
                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                >
                  <el-table-column
                    prop="ofrresourceName"
                    label="产品名称">
                  </el-table-column>
                  <el-table-column
                    prop="cbowhName"
                    label="位置">
                  </el-table-column>
                  <template v-if="!ofoFlowWork.beforeworkConfig || ofoFlowWork.beforeworkConfig.indexOf('1') != -1">
                    数量
                    <el-table-column
                      prop="quantity"
                      align="right"
                      label="数量">
                    </el-table-column>
                    剩余数量
                    <el-table-column
                      prop="openqty"
                      align="right"
                      label="剩余数量">
                      <template slot-scope="scope">
                        <strong style="font-size:18px">{{scope.row.openqty}}</strong>
                      </template>
                    </el-table-column>
                  </template>
                  <template v-if="!ofoFlowWork.beforeworkConfig || ofoFlowWork.beforeworkConfig.indexOf('3') != -1">
                    金额
                    <el-table-column
                      prop="total"
                      align="right"
                      label="金额（含税）">
                      <template slot-scope="scope">{{scope.row.total | comdify}}</template>
                    </el-table-column>
                    剩余金额
                    <el-table-column
                      prop="openqty"
                      align="right"
                      label="剩余金额">
                      <template slot-scope="scope">
                        <strong style="font-size:18px">{{scope.row.opentotal | comdify}}</strong>
                      </template>
                    </el-table-column>
                  </template>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称">
            </el-table-column>
            <!-- 数量 -->
            <el-table-column
              prop="code"
              label="编号">
            </el-table-column>
            <!-- 活动日期 -->
            <el-table-column
              prop="workDate"
              align="center"
              label="日期">
              <template slot-scope="scope">{{scope.row.workDate | filter_handleDate}}</template>
            </el-table-column>
            <!-- 订单金额 -->
            <el-table-column
              prop="total"
              align="right"
              label="收款金额">
              <template slot-scope="scope">{{scope.row.ptotal | comdify}}</template>
            </el-table-column>
            <!-- 金额 -->
            <el-table-column
              prop="total"
              align="right"
              label="未核销金额">
              <template slot-scope="scope">{{scope.row.openTotal | comdify}}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div style="display:flex;overflow:hidden">
        <div style="width:50%;padding: 10px">
          <div style="display:flex;justify-content:space-between;margin-bottom:5px;align-items:center" v-for="(item, index) in handleSelectionList1" :key="index">
            <span>{{item.name}}</span>
            <div>
              <el-input size="mini" style="width: 150px;margin-right: 100px" v-model="item.rate" @input="calcCurrentOptotal(item,index)">
                <template slot="append">%</template>
              </el-input>
              <template v-if="item.checkType == '3'">-</template>
              <el-input-number size="mini" v-model="item.openTotal" controls-position="right" :max="controlTotal1[index]"></el-input-number>
            </div>

          </div>
        </div>
        <div style="width:50%;padding: 10px;border-left: 1px solid #ddd">
          <div style="display:flex;justify-content:space-between;margin-bottom:5px;align-items:center;height:28px" v-for="(item, index) in handleSelectionList2" :key="index">
            <span>{{item.name}}</span>
            <el-input-number size="mini" v-model="item.openTotal" controls-position="right" :max="controlTotal2[index]"></el-input-number>
          </div>
        </div>
      </div>
      <div style="display:flex;border-top: 1px solid #ddd">
        <div style="width:50%;padding: 10px">
          <div style="display:flex;justify-content:end;margin-bottom:5px">待核销金额：{{waitCheckTotal1 | comdify}}</div>
          <div style="display:flex;justify-content:end">剩余金额：{{remainCheckTotal | comdify}}</div>
        </div>
        <div style="width:50%;padding: 10px;border-left: 1px solid #ddd">
          <div style="display:flex;justify-content:end;margin-bottom:5px">待核销金额：{{waitCheckTotal2 | comdify}}</div>
          <div style="display:flex;justify-content:end;align-items:center;margin-bottom:5px">本次付款金额：<el-input v-model="payTotal" size="mini" style="width:150px" disabled></el-input></div>
          <div style="display:flex;justify-content:end;align-items:center">
            付款方式：
            <el-select v-if="dialogCheckVisible"
              v-model="resourceId"
              style="width: 200px"
              filterable
              clearable
              size="mini"
            >
              <el-option v-for="(item, index) in goodsList" :key="index" :label="item.resourceName" :value="item.ofrResourceId" ></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCheckVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmCheck">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看资源 -->
    <el-dialog v-dialog-drag
      title="查看详情"
      width="80%"
      :visible.sync="dialogResourceViewVisible"
      append-to-body>
      <div slot="title">
        <div style="display: flex;justify-content: space-between">
          <div>查看详情</div>
          <div>
            <el-button
              size="mini"
              style="margin-right: 30px;display: flex;flex-direction: column;padding-top: 2px;"
              @click.native.stop="editResource(ofrResource.ofrResourceId)"
              type="text"
              v-if="judgeButton('edit')"
            >编辑
            </el-button>
          </div>
        </div>
      </div>
      <el-descriptions :column="2">
        <el-descriptions-item label="描述">{{ofrResource.remarks}}</el-descriptions-item>
        <el-descriptions-item label="名称">{{ofrResource.resourceName}}</el-descriptions-item>
        <el-descriptions-item v-for="(item, index) in dimensionList" :key="index" :label="item.dimeName + '*'" :labelStyle="{'max-width': '100px'}">
          <template v-if="item.editType != '8'">{{item.dimeText}}</template>
          <template v-else>
            <fileList v-if="item.dimeText" :fileList="JSON.parse(item.dimeText)" />
          </template>
        </el-descriptions-item>
        <el-descriptions-item label="库存">
          <div style="display: flex;flex-direction: column;">
            <span v-for="item in owhResources" :key="item.cbowhId">{{ item.cbowhName }}：{{ item.quantity }}</span>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <div style="width: 97%;">
        <History v-if="showHistory" :kind="historyResData.kind" :ofr-resource-id="historyOfrResourceId"/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogResourceViewVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!--  查看内容  -->
    <el-dialog v-dialog-drag
               title="内容详情"
               :visible.sync="contentVisible"
               :append-to-body="true"
    >
      <div slot="title">
        <div style="display: flex;justify-content: space-between">
          <div>内容详情</div>
          <div>
            <el-button
              size="mini"
              style="margin-right: 30px;display: flex;flex-direction: column;padding-top: 2px;"
              @click.native.stop="editThing(contentRuleForm.ofrThingId)"
              type="text"
              v-if="judgeButton('edit')"
            >编辑
            </el-button>
          </div>
        </div>
      </div>
      <el-descriptions :column="2">
        <el-descriptions-item label="名称">{{contentRuleForm.name}}</el-descriptions-item>
        <el-descriptions-item label="代码">{{contentRuleForm.code}}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <DictTag :options="dropDown.documentstatus" :value="contentRuleForm.documentstatus"/>
        </el-descriptions-item>
        <el-descriptions-item label="描述">{{contentRuleForm.remarks}}</el-descriptions-item>
        <el-descriptions-item v-for="(item, index) in contentFormList" :key="index" :label="item.dimeName + '*'">{{item.dimeText}}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contentVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 编辑内容 -->
     <el-dialog v-dialog-drag
      title="编辑内容"
      :visible.sync="contentDialogFormVisible"
      :append-to-body="true"
    >
      <el-form
        :model="contentRuleForm"
        :rules="contentRules"
        ref="contentRuleFormRef"
        class="demo-ruleForm"
        style="max-height: 50vh; overflow-y: auto;overflow-x:hidden"
        label-position="right"
      >
        <el-row :gutter="20">
          <el-col :span="12" v-if="historyResData.kind == '1' && contentRuleForm.ofrThingId">
            <el-form-item label="名称" prop="name">
              <el-input
                v-model="contentRuleForm.name"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="historyResData.kind == '1' && contentRuleForm.ofrThingId">
            <el-form-item label="岗位" prop="ofrResourceId">
              <el-select
                v-model="contentRuleForm.ofrResourceId"
                placeholder="请选择岗位"
                style="width: 97%"
              >
                <el-option
                  v-for="(item, index) in postList"
                  :key="index"
                  :label="item.resourceName"
                  :value="item.ofrResourceId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="historyResData.kind != '1' || !contentRuleForm.ofrThingId">
            <el-form-item label="名称" prop="name" >
              <el-input
                v-model="contentRuleForm.name"
                placeholder="请输入名称"
                style="width:98%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="historyResData.kind == '2' || historyResData.kind == '3'">
            <el-form-item label="双计系数" prop="sjxs">
              <el-input
                type="number"
                v-model="contentRuleForm.sjxs"
                placeholder="请输入双计系数"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="historyResData.kind == '2' || historyResData.kind == '3'">
            <el-form-item label="双计单位" prop="sjdw">
              <el-input
                v-model="contentRuleForm.sjdw"
                placeholder="请输入双计单位"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <Form :formList="contentFormList" :gutter="20" :ruleForm="contentRuleForm"/>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contentDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitContentForm('contentRuleFormRef')">确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 切换bom -->
    <el-dialog v-dialog-drag
      title="选择资源"
      :visible.sync="dialogResVisible"
      :append-to-body="true"
      width="80%"
      top="59px"
      class="res-dialog"
    >
      <!-- <el-select v-model="ofrResourceIds" placeholder="请选择资源" filterable style="width: 100%" multiple size="small">
        <el-option-group
          v-for="(group, index) in resTreeList"
          :key="index"
          :label="group.name">
          <el-option
            v-for="item in resTreeList"
            :key="item.ofrResourceId"
            :label="item.remarks"
            :value="item.ofrResourceId">
          </el-option>
      </el-select> -->

      <el-input size="small" style="width:300px;margin-left:16px" v-model="mcsearch" @keydown.enter.native="searchChange" placeholder="输入名称搜索" clearable/>
      <el-input size="small" style="width:300px;margin-left:16px" v-model="ggsearch" @keydown.enter.native="searchChange" placeholder="输入规格型号搜索" clearable/>
      <el-button style="margin-left: 10px;" type="primary" @click="searchChange" size="mini">搜索</el-button>
      <el-button style="margin-left: 10px;" type="primary" @click="changeBom(null)" size="mini">重置</el-button>
      <el-table
        ref="restypeTable"
        :data="resList"
        tooltip-effect="dark"
        :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
        style="width: 100%;margin-top: 5px"
        @select="handleResSelect"
        @selection-change="handleResSelectionChange"
        @row-click="clickRowRes"
        size="small"
        :height="tableHeight"
        row-key="ofrResourceId"
        >

        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55">
        </el-table-column>
        <el-table-column
          label="资源种类"
          prop="restypeName"
          width="150">
        </el-table-column>
        <el-table-column
          label="描述"
          prop="remarks">
        </el-table-column>
        <el-table-column
          label="名称"
          prop="resourceName">
        </el-table-column>
        <el-table-column
          label="规格型号"
          prop="ggxh"
          width="100">
        </el-table-column>
        <el-table-column
          label="单位"
          prop="jldw"
          width="100">
        </el-table-column>
        <el-table-column
          label="库存"
          prop="ofrOwhResourceList">
          <template slot-scope="scope">
            <el-row :key="item.owhName" v-for="item in scope.row.ofrOwhResourceList">
              <el-col :span="12">{{item.owhName}}：</el-col>
              <el-col :span="12">{{item.resourceQuantity}}</el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
          align="right" width="240">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search1"
              size="mini"
              placeholder="输入名称搜索"
              clearable
              @input="searchChange"
              @keyup.enter.native="searchChange">
              <!-- <el-button slot="append" icon="el-icon-search" @click="searchChange"></el-button> -->
            </el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="pageinfo.pageNum"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pageinfo.pageSize"
        layout="->, total, sizes, prev, pager, next, jumper"
        :total="pageinfo.total"
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        style="margin-bottom: 3px"></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogResVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRes">确 定</el-button>
        <!-- <el-button v-if="ofoFlowWork.isCalcBom == '0' && this.pid" type="primary" @click="confirmBom">确 定</el-button>
        <el-button v-else type="primary" @click="submitRes">确 定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import url from '@/config/url'
import DictTag from '@/components/DictTag.vue'
import DimeTag from '@/components/DimeTag.vue'
import {mapState} from 'vuex'
import Form from '@/components/Form.vue'
import handleTree from '@/utils/handleTree'
import handleList from '@/utils/handleList'
import handleWorkConfigList from '@/utils/handleWorkConfigList'
import qs, { stringify } from 'qs'
import * as XLSX from 'xlsx'
import History from "@/views/resource/kind/history.vue";
import handleDutys from "@/utils/handleDutys";
import {parseTime} from "@/utils";
  export default {
    name: 'product',
    components: {
      History,
      DictTag,
      Form,
      DimeTag
    },
    props: {
      disabled: Boolean,
      ofoFlowWork: Object,
      workDate: '',
      ofoFlowDeal: Object,
      productsList: Array,
      thingsList: Array,
      // documentstatus: String,
      ofoWorkId: [Number, String],
      total: [Number, String],
      pageNum: [Number, String],
      pageSize: [Number, String],
      ctotal1: [Number, String],
      ctotalNovat1: [Number, String],
      ctotalVat1: [Number, String],
      ptotal1: [Number, String],
      ptotalNovat1: [Number, String],
      ptotalVat1: [Number, String],
      workConfig: Object,
      limit: {
        type: Object,
        default: ()=>({})
      },
      resLimit: {
        type: [Number, String],
        default: ''
      },
      resPreLimit: {
        type: [Number, String],
        default: ''
      },
      params: {
        type: Object,
        default: () => ({
          priceAccuracy: 2,
          quantityAccuracy: 8,
          bzhs: '1',
          deptName: null
        })
      },
      ruleFormParent: {
        type: Object,
        default: () => ({})
      },
      // index: {
      //   type: [Number, String],
      //   default: 0
      // },
      // cbOwhData: Array,
      // goodsList: Array
    },
    data() {
      return {
        currentChangeOfrResourceId: null,
        isTax: true, // 是否含税
        // productsList: [], // 产品列表
        cbOwhData: [],
        goodsList:[], // 货物或应税劳务、服务名称列表
        ofoWorkThingList: [], // 明细列表
        dialogTableVisible: false,
        goods: [],
        startDate: '',
        endDate: '',
        startCount: '',
        endCount: '',
        dialogCopyFromVisible: false, // 复制从对话框
        copyFromList: [], // 复制从列表
        comfirmCopyFromList: [], // 勾选的复制从列表
        ofrResourceNameQuery: null,
        dealNameQuery: null,
        workNameQuery: null,
        workCodeQuery: null,
        loading: true,
        search: '',
        search2: '',
        codeSearch: '',
        mcsearch: '',
        ggsearch: '',
        tableOption: [],
        searchCopyFrom: '',
        dialogFormVisible: false,
        ruleForm: {
          resourceName: '',
          remarks: ''
        },
        formList: [],
        rules: {
          resourceName: [{ required: true, message: "请输入名称", trigger: "submit" }],
          documentstatus: [ { required: true, message: "请选择状态", trigger: "submit" }],
        },
        isDisabled: false,
        dialogResourceVisible: false,
        resourceForm: {
          resourceName: '',
          remarks: '',
          documentstatus: '1',
          cbRestypeId: '',
          dataSourceConfig: [],
          userId: '',
          rprice: "",
          ggxh: "",
          jldw: ""
        },
        rulesReource: {
          resourceName: [{ required: true, message: "请输入资源名称", trigger: "change" }]
        },
        userList: [],
        editResourceDialog: false,
        editRuleFormRes: {},
        editFormList: [],
        editRules: {
          resourceName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          documentstatus: [{ required: true, message: '请选择状态', trigger: 'submit' }]
        },
        contentDialogFormVisible: false,
        contentVisible: false,
        contentRuleForm: {},
        contentFormList: [],
        contentRules: {
          name: [{ required: true, trigger: "blur" }]
        },
        postList: [],
        resourceFormList: [],
        cbResourceType: {},
        flag: true,
        selectedId: [],
        selectAllChildMap: new Map(),
        // pageNum: 1,
        // pageSize: 10,
        // total: 20
        select: '',
        dialogSelectVisible: false,
        // index: 0,
        isAll: true,
        sel: '',
        isAdd: '',
        cbResourceTypeList: [],
        ofrResourceId: '',
        ofrresourceName: '',
        isAddRes: false,
        currentUUID: null,
        editResIndex: 0,
        configValue: '',
        dialogVisible: false,
        tableData: [],
        isMultiRes: false,
        row: {},
        index: 0,
        isCheckQuantity: false,
        isCheckPrice: false,
        isCheckRemark: true,
        isName: false,
        isWorkDate: false,
        isPart: false,
        isRemarks: false,
        activeNames: [],
        cbussDimeTree: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        multipleList: [],
        dialogCheckVisible: false,
        copyCheckWorkListBefore: [],
        copyCheckWorkListAfter: [],
        handleSelectionList1: [],
        handleSelectionList2: [],
        checkBaseId: '',
        controlTotal1: [],
        controlTotal2: [],
        resourceId: '',
        cbRestypeId: '',
        resData: {},
        historyResData: {},
        btnMenu: JSON.parse(window.sessionStorage.getItem('btnMenu')),
        showHistory: false,
        historyOfrResourceId: null,
        multiplePageNum:1,
        multiplePageSize:10,
        isSameRes: true,
        dialogRefVisible: false,
        workList: [],
        showList: [],
        pageNumWork: 1,
        pageSizeWork: 10,
        totalWork: 0,
        refIds: '',
        resDimeList: [],
        dialogResourceViewVisible: false,
        ofrResource: {
          remarks: '',
          resourceName: ''
        },
        dimensionList: [],
        owhResources:[],
        isExpand: false,
        resList: [],
        resTreeList: [],
        pageinfo: {
          pageNum: 1,
          pageSize: 10,
          total: 0,
        },
        search1: '',
        dialogResVisible: false,
        tableHeight: window.innerHeight - 300,
        treeObj: {},
        selectBom: [],
        selectBomMultiple: false,
        ofrThingsList: [],
        dialogTableVisible2: false,
        search3: '',
        goods2: [],
        // thingsList: [],
        changeSelectThing: false,
        changeOfrthingId: '',
        thingIndex: 0,
        selectedIdThing: [],
        dialogThingVisible: false,
        thingForm: {
          name: '',
          remarks: '',
          documentstatus: '1',
          ofrResourceId: '',
          cbRestypeId: '',
          dataSourceConfig: []
        },
        thingUUID: '',
        rulesThing: {
          name: [{ required: true, message: "请输入内容名称", trigger: "change" }],
          ofrResourceId: [{ required: true, message: "请选择资源", trigger: "change" }]
        },
        cbResourceTypeList2: [],
        resourceList: [],
        thingFormList: [],
        ofrThingId: '',
        isExpand1: true,
        isFilter: true,
        isRepeat: true,
        isShowBomStock: false,
        pid: 0,
        bomRow: {},
        currentPageThing: [],
        pageThing: {
          pageNum: 1,
          pageSize: 10,
          total: 0
        },
        checkBoxValue: false,
        checkResShow: [],
        confirmResShow: [],
        allShow: true
      }
    },
    created () {
      this.getList();
      this.$http.get(url.getPostAndUserList).then(res => {
        if (res.data.code == 200) {
          this.userList = res.data.data
        }
      })
      this.productsList.forEach(item => {
        this.isTax = !item.isVat
      })
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 300;
        if(this.$refs.noEditTable) {
          this.checkResShow = this.$refs.noEditTable.columns.map(item => {
            return {
              label: item.label,
              value: true,
              property: item.property
            }
          }).filter(item => item.label && item.property)
          if(this.ofoFlowWork.costmanagetype != '9'){
            this.allShow = false
          }
          this.changeResShow()
          // console.log(JSON.parse(JSON.stringify(this.$refs.noEditTable.columns)));
        }
      })
      // this.checkResShow = [
      //   {label: this.cbowhName(1), value: true, property: 'cbowhName', isShow: this.ofoFlowWork.chooseOwh == '0'},
      //   {label: this.cbowhName(2), value: true, property: 'cbowhToName', isShow: this.ofoFlowWork.stockaccttype == '7'},
      // ]
      this.getOwhKind1Name()
    },
    methods: {
      handleDutys,
      getOwhKind1Name(){
        this.$http.get(url.getOwhKind1Name).then(res => {
          this.params.deptName = res.data.data.deptName
        })
      },
      tableRowClassName2({ row, index }) {
        if (row.openqty <= 0 && !this.isFilter) {
          return "hidden-row"
        }
        return ""
      },
      calcCurrentOptotal(item,index){
        if(item.rate){
          item.openTotal = (this.controlTotal1[index] * item.rate / 100).toFixed(2)
        }else{
          item.openTotal = this.controlTotal1[index]
        }
      },
      // 资源行字段显示隐藏
      changeResShow() {
        this.confirmResShow = this.checkResShow.filter(item => item.value).map(item => item.property)
        // console.log(this.confirmResShow);

      },
      changeShowBomStock (e) {
        if (e) {
          console.log('显示bom库存', this.productsList)
          this.getProductsStock()
        }
      },
      getProductsStock() {
        const ids = this.getAllOfrResourceIds()
        this.$http.post(url.queryOwhResources + ids,{}).then(res => {
          let list = []
          if (res.data.code === 200) {
            list = res.data.data
          }
          this.setProductsListStock(list)
        })
      },
      setProductsListStock(list) {
        let that = this
        function setStock(items) {
          for (const item of items) {
            const obj = list.find(item1 => item1.ofrresourceId === item.ofrresourceId)
            item.stock = null
            if (item.ofrresourceId && obj) {
              that.$set(item, 'stock', obj.quantity)
            } else {
              that.$set(item, 'stock', null)
            }
            if (item.children && item.children.length > 0) {
              setStock(item.children)
            }
          }
        }
        setStock(this.productsList)
      },
      getAllOfrResourceIds() {
        const result = []

        function traverse (items) {
          for (const item of items) {
            if (item.ofrresourceId) {
              result.push(item.ofrresourceId)
              if (item.children && item.children.length > 0) {
                traverse(item.children)
              }
            }
          }
        }

        traverse(this.productsList)
        return result
      },
      handleSizeChangeThing(val) {
        this.pageThing.pageSize = val
        this.pageThing.pageNum = 1
        this.currentPageThing = this.getCurrentPageThing(val, this.pageThing.pageNum)
      },
      handleCurrentChangeThing(val) {
        this.pageThing.pageNum = val
        this.currentPageThing = this.getCurrentPageThing(this.pageThing.pageSize, val)
      },
      searchChangeThing() {
        this.pageThing.pageNum = 1
        this.currentPageThing = this.getCurrentPageThing(this.pageThing.pageSize, 1)
      },
      getCurrentPageThing(size, current) {
        const tablePush = [];
        let array = []
        if(this.search3) {
          array = this.ofrThingsList.filter(data => !this.search3 || data.name.toLowerCase().includes(this.search3.toLowerCase()) || data.resourceName.toLowerCase().includes(this.search3.toLowerCase()))
        }else {
          array = JSON.parse(JSON.stringify(this.ofrThingsList))
        }
        if(this.search2) {
          array = array.filter(data => data.ggxh && data.ggxh.toLowerCase().includes(this.search2.toLowerCase()))
        }
        this.pageThing.total = array.length
        array.forEach((item, index) => {
          if (size * (current - 1) <= index && index <= size * current - 1) {
            tablePush.push(item);
          }
        });
        return tablePush;
      },
      // 新增BOM
      handleAddBom(row, index) {
        // console.log(JSON.parse(JSON.stringify(row)));
        // console.log(index);
        // this.goods = []
        // this.pid = row.bomId
        // this.dialogTableVisible = true
        this.bomRow = row
        this.selectBomMultiple = true
        this.dialogResVisible = true
        this.search1 = ''
        this.pid = row.bomId
        this.$nextTick(() => {
          this.$refs.restypeTable.clearSelection()
        })
        this.pageinfo.pageNum = 1
        this.resList = this.currentChangePage(this.pageinfo.pageSize, this.pageinfo.pageNum)
      },
      confirmBom() {

        if(this.goods.length) {
          this.goods.forEach(async (item, index) => {
            let obj = {
              cbowhId: this.corCbowh(item, 'Resource', item.cbRestypeId, 'id'),
              cbowhName: this.corCbowh(item, 'Resource', item.cbRestypeId, 'name'),
              quantity: this.ofoFlowWork.costmanagetype == '4' ? 1 : (this.isCheckQuantity ? this.handleCalc(item.availableQuantityList) : ''),
              price: (!this.ofoFlowWork.kindtype.includes(',') && this.cbResourceTypeList[0].isShowPrice == '0' && this.isCheckPrice) ? this.comdifyPrams(item.rprice) : '',
              total: '',
              vatgroup: (!this.ofoFlowWork.kindtype.includes(',') && this.cbResourceTypeList[0].isShowPrice == '0' && this.isCheckPrice) ? (item.rslv ? item.rslv : this.dropDown.invoiceVat[0].dictValue) : this.dropDown.invoiceVat[0].dictValue,
              totalVat: '',
              invoicetype: this.dropDown.invoiceType[0].dictValue,
              cost: '',
              costTotal: '',
              costTotalVat: '',
              beginValue: '',
              endValue: '',
              workConfigList1: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList1) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList1)) : [],
              workConfigList2: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList2) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList2)) : [],
              workConfigList3: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList3) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList3)) : [],
              workConfigList4: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList4) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList4)) : [],
              bomId: item.ofrResourceId + this.bomRow.bomId,
              name: item.resourceName,
              stock: null,
              rid: item.ofrResourceId,
              children: null,
              ofrresourceId: item.ofrResourceId,
              ofrresourceName: item.resourceName,
              pid: this.pid,
              ggxh: item.ggxh,
              jldw: item.jldw,
              cbRestypeId: item.cbRestypeId,
              cbowhTo: '',
              cbowhToName: ''
            }
            // this.index ++
            if(this.ofoFlowWork.costmanagetype == '9') {
              await this.$http.get(url.getOfrResource, {params: {ofrResourceId: item.ofrResourceId}}).then(res => {
                obj.dimensionList = this.handleFormList(res.data.data.dimensionList)
              })
            }
            // console.log(JSON.parse(JSON.stringify(obj)));

            // console.log(this.ofoFlowWork.isCalcBom);

           this.bomRow.children.push(obj)
            // console.log(JSON.parse(JSON.stringify(this.productsList)))
          })
        }else {
          this.$message.warning('请选择资源行');
        }
      },
      // 位置名称
      cbowhName(number) {
        if(number == 1) {
          return this.ofoFlowWork.stockaccttype == '7' ? '调出位置' : '位置'
        }else {
          return this.ofoFlowWork.stockaccttype == '7' ? '调入位置' : '位置2'
        }
      },
      // bom数量
      bomQuantity(row) {
        // console.log(JSON.parse(JSON.stringify(this.ofoFlowWork)));

        // console.log(row);
        // return 111
        if(this.ofoFlowWork.isCalcBom == '0') {
          let sum = 0
          // let data = JSON.parse(JSON.stringify(row.children))
          let data = row.children ? JSON.parse(JSON.stringify(row.children)) : []
          const flattenedArray = this.getOneArr(data);
          // console.log(JSON.parse(JSON.stringify(flattenedArray)));
          flattenedArray.forEach(item => {
            sum = Number(sum) + Number(item.quantity)
          })
          // return Number(sum).toFixed(this.params.quantityAccuracy)
          return Number(sum).toFixed(2)
        }else {
          return ''
        }

      },
      //指定列求和
      getSummaries(param) {
        // console.log(param);
        const { columns, data } = param;
        const sums = [];

        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          }

          // 只合计amount1和amount3，想合并哪些列就在这里指定
          if (column.property === "quantity" || column.property === "openqty") {
            let values = data.map((item) => Number(item[column.property]));
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return this.ofoFlowWork.costmanagetype == '7' ? this.handleTimeRange(prev + curr) : Number((Number(prev) + Number(curr)).toFixed(this.params.quantityAccuracy))
              } else {
                return this.ofoFlowWork.costmanagetype == '7' ? this.handleTimeRange(Number(prev)) : Number(prev);
              }
            }, 0);
          }
          if (column.property === "total" || column.property === "opentotal") {
            let values = data.map((item) => Number(this.delComdify(item[column.property])));
            sums[index] = values.reduce((prev, curr) => {
              // const value = Number(this.delComdify(curr));
              const value = Number(curr);
              // console.log(value);

              if (!isNaN(value)) {
                // return (Number(this.delComdify(prev)) + Number(this.delComdify(curr))).toFixed(2);
                return Number(Number(prev) + Number(curr)).toFixed(this.params.priceAccuracy);
              } else {
                // return (Number(this.delComdify(prev))).toFixed(2);
                return prev;
              }
            }, 0);
          }
        });
        return sums;
      },
      // 切换展开/收起状态
      changeExpand1() {
        this.isExpand1 = !this.isExpand1
        // console.log(123);
        if(this.disabled) {
          // console.log(this.$refs.noEditTable);
          this.productsList.forEach(item => {
            this.$nextTick(() => {
              this.$refs.noEditTable.toggleRowExpansion(item, this.isExpand1)
            })
          })
        }else {
          // console.log(this.$refs.multipleTable);

          this.$nextTick(() => {
            this.productsList.forEach(item => {
              this.$refs.multipleTable.toggleRowExpansion(item, this.isExpand1)
            })
          })
        }

      },
      // 新增内容
      addThing(row) {
        // console.log(JSON.parse(JSON.stringify(this.productsList)));
        const cbRestypeId = row?.cbRestypeId
        const ofrresourceId = row?.ofrresourceId
        this.thingUUID = row.uuid
        this.thingForm.name = ''
        this.thingForm.remarks = ''
        this.thingForm.ofrResourceId = ''
        this.thingForm.dataSourceConfig = []
        this.cbResourceTypeList2 = []
        // 传入了类型ID
        if(cbRestypeId && ofrresourceId){
          if (this.workDate) {
            this.thingForm.name = this.workDate.replaceAll('-', '')
          }else{
            this.thingForm.name = parseTime(new Date(),'{y}{m}{d}')
          }
          const currentCbRestype = this.cbResourceTypeList.find(item => item.cbRestypeId === cbRestypeId)
          if (currentCbRestype) {
            this.cbResourceTypeList2.push(currentCbRestype)
          }
        }else if(this.productsList && this.productsList.length > 0){
          let ids = this.productsList.map(item => item.cbRestypeId)
          this.cbResourceTypeList.forEach(item => {
            if(item.isAdd == '0' && ids.includes(item.cbRestypeId)) {
              this.cbResourceTypeList2.push(item)
            }
          })
        }else{
          this.cbResourceTypeList2 = JSON.parse(JSON.stringify(this.cbResourceTypeList))
        }
        if(this.cbResourceTypeList2 && this.cbResourceTypeList2.length > 0){
          this.thingForm.cbRestypeId = this.cbResourceTypeList2[0].cbRestypeId
          this.getCbussDimeList1(ofrresourceId)
        }else{
          this.resourceList = []
        }


        this.$nextTick(() => {
          // 清除表单校验效果
          if(this.$refs.thingForm) {
            this.$refs.thingForm.clearValidate();
          }
        })
        this.loading = false
        this.dialogThingVisible = true

      },

      getCbussDimeList1(ofrresourceId) {
        this.resourceList = []
        if (ofrresourceId) {
          const currentGood = this.goodsList.find(item => item.ofrResourceId === ofrresourceId)
          if (currentGood) {
            this.resourceList.push(currentGood)
          }
        }
        if (this.resourceList.length < 1) {
          this.goodsList.forEach(item => {
            if(item.cbRestypeId == this.thingForm.cbRestypeId) {
              this.resourceList.push(item)
            }
          })
        }
        let resourceList = JSON.parse(JSON.stringify(this.resourceList))
        if(this.productsList && this.productsList.length > 0) {
          this.resourceList = []
          let tempIds = []
          this.productsList.forEach(item => {
            if(!tempIds.includes(item.ofrresourceId)){

              let tempResource = resourceList.find(val => val.ofrResourceId == item.ofrresourceId)
              if(tempResource){
                this.resourceList.push(tempResource)
              }
              tempIds.push(item.ofrresourceId)
            }
          })
        }
        if(this.resourceList && this.resourceList.length > 0){
          this.thingForm.ofrResourceId = this.resourceList[0].ofrResourceId
          this.$http.get(url.getCbussDimeList, {params: {cbussId: this.thingForm.cbRestypeId, dimetype: '2'}}).then(res => {
            const handleList = this.handleFormList(res.data.data)
            if (handleList) {
              handleList.forEach(item => {
                if (item.dimeName === '生产日期') {
                  item.dimeValue = this.workDate || parseTime(new Date(), '{y}-{m}-{d}')
                }else if (item.dimeName === '保质期单位') {
                  if(item.options){
                    const options = JSON.parse(item.options)
                    item.dimeValue = options[0].optionValue + ''
                    item.dimeText = options[0].optionLabel
                  }
                }else{
                  if(item.dvalue){
                    item.dimeValue = item.dvalue
                    item.dimeText = item.dvalue
                  }
                }
              })
            }
            this.thingFormList = handleList
            this.thingForm.dataSourceConfig = this.thingFormList

          })
        }
      },
      // 提交内容
      submitThingForm(formName) {
        this.goods2 = []
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true
            let dimes = []
            if(this.thingFormList.length) {
              dimes = this.handleDimes(this.thingFormList)
            }
            delete this.thingForm.dataSourceConfig
            this.$http.post(url.addOfrThing, qs.stringify({
              ...this.thingForm,
              dimes: JSON.stringify(dimes)
            })).then(res => {
              this.loading = false
              if(res.data.code === 200) {
                this.$message.success(res.data.msg)
                this.ofrThingId = res.data.data
                this.dialogThingVisible = false
                this.$http.get(url.getResTypesAndList1 + this.ofoFlowWork.ofoFlowWorkId, {params: {cbRestypeIds: this.ofoFlowWork.kindtype}}).then(res => {
                  // this.goodsList = this.handleDimes(res.data.data.list, 'resourceNameDimes', 'resourceName')
                  this.goodsList = res.data.data.list

                  this.ofrThingsList = []
                  let index = 0
                  this.goodsList.forEach(item => {
                    item.name = item.resourceName.split(':')[0]
                  })
                  this.multipleList = JSON.parse(JSON.stringify(this.goodsList))
                  // this.isAdd = res.data.data.isAdd
                  this.ofrThingsList = []
                  this.goodsList.forEach(item => {
                    item.ofrThingList.forEach(el => {
                      let obj = el
                      for(let key in item) {
                        if(key == 'ofrThingList') {
                        }else if(key == 'name') {
                          obj[key] = el[key]
                        }else {
                          obj[key] = item[key]
                        }
                      }
                      this.ofrThingsList.push(obj)
                    })
                  })
                  let thingObj = this.ofrThingsList.find(item => item.ofrThingId == this.ofrThingId)
                  thingObj.uuid = this.thingUUID
                  this.goods2.push(thingObj)
                  this.isAddRes = true
                  this.confirm(thingObj.uuid)
                })
              }
            })
          }
        })
      },
      iconHide({ row }) {
        // console.log('row', row)
        if(this.ofoFlowWork.thingtype) {
          if(!this.thingsList.filter(item => item.ofrresourceId == row.ofrresourceId).length) {
            this.$nextTick(() => {
              // console.log(this.$refs);

              this.disabled ? this.$refs.noEditTable.toggleRowExpansion(row, false) : this.$refs.multipleTable.toggleRowExpansion(row, false)
            })
            return 'icon-no'
          }else {
            this.$nextTick(() => {
              this.disabled ? this.$refs.noEditTable.toggleRowExpansion(row, true) : this.$refs.multipleTable.toggleRowExpansion(row, true)
            })
          }
        }else {
          // this.$nextTick(() => {
          //   this.disabled ? this.$refs.noEditTable.toggleRowExpansion(row, true) : this.$refs.multipleTable.toggleRowExpansion(row, true)
          // })
          // return 'icon-no'
        }
      },
      //点击行触发，选中或不选中复选框
      handleRowClick(row, column, event) {
        this.$refs.tableMultiple2.toggleRowSelection(row);
      },
      handleSelectionChange(rows) {
        console.log('明细多选改变选中状态')
        if(this.isAddRes) {
          this.goods2 = rows
        }else {
          if(rows.length >= 2) {
            this.$refs.tableMultiple2.toggleRowSelection(rows[0], false);
            this.goods2 = [rows[1]]
          }else {
            this.goods2 = rows
          }
        }
      },
      generateUUIDWithoutDash() {
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = Math.random() * 16 | 0;
          const v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      },
      // 确定多选
      async confirm(_uuid) {
        if(this.goods2.length) {
          this.dialogTableVisible2 = false
          if(this.isAddRes) { // 新增资源行
            if(!this.isRepeat) {
              let ids = this.thingsList.map(item => item.ofrthingId)
              this.goods2 = this.goods2.filter(item => !ids.includes(item.ofrThingId))
            }
            this.goods2.forEach(item => {
              this.goodsList.forEach(val => {
                val.ofrThingList.forEach(el => {
                  if(item.ofrThingId == el.ofrThingId) {
                    this.thingsList.push({
                      // cbowhId: item.ofrOwhThingList && item.ofrOwhThingList.length ? (item.ofrOwhThingList.find(val => val.thingQuantity) || item.ofrOwhThingList[0]).owhId : this.corCbowh(item.cbRestypeId, 'id'),
                      // cbowhName: item.ofrOwhThingList && item.ofrOwhThingList.length ? (item.ofrOwhThingList.find(val => val.thingQuantity) || item.ofrOwhThingList[0]).owhName : this.corCbowh(item.cbRestypeId, 'name'),
                      cbowhId: this.corCbowh(item, 'Thing', item.cbRestypeId, 'id'),
                      cbowhName: this.corCbowh(item, 'Thing', item.cbRestypeId, 'name'),
                      ofrresourceId: val.ofrResourceId,
                      ofrresourceName: val.resourceName,
                      ofrthingId: el.ofrThingId,
                      ofrthingName: el.name,
                      quantity: this.ofoFlowWork.costmanagetype == '4' ? 1 : '',
                      price: '',
                      total: '',
                      vatgroup: this.dropDown.invoiceVat[0].dictValue,
                      totalVat: '',
                      invoicetype: this.dropDown.invoiceType[0].dictValue,
                      cost: '',
                      costTotal: '',
                      costTotalVat: '',
                      beginValue: '',
                      endValue: '',
                      workConfigList1: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList1) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList1)) : [],
                      workConfigList2: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList2) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList2)) : [],
                      workConfigList3: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList3) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList3)) : [],
                      workConfigList4: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList4) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList4)) : [],
                      cbowhTo: '',
                      cbowhToName: '',
                      bzdw: val.sjdw,
                      bzsl: '',
                      bzxs: val.sjxs,
                      addFlag: 'Y'
                    })
                  }
                })
              })
            })


          }else { // 修改资源行名称
            if (this.goods2[0].ofrResourceId != this.currentChangeOfrResourceId) {
              this.$message.warning('请选择相同资源下的内容')
              return
            }
            if(this.currentUUID){
              let editThing = this.thingsList.filter(item => item.uuid === this.currentUUID)[this.editResIndex]
                editThing.ofrresourceId = this.goods2[0].ofrResourceId
                editThing.ofrresourceName = this.goods2[0].resourceName
                editThing.ofrthingId = this.goods2[0].ofrThingId
                editThing.ofrthingName = this.goods2[0].name
                this.currentUUID = null
            }else{
              this.thingsList.filter(item => item.ofrresourceId === this.goods2[0].ofrResourceId)[this.editResIndex].ofrresourceId = this.goods2[0].ofrResourceId
              this.thingsList.filter(item => item.ofrresourceId === this.goods2[0].ofrResourceId)[this.editResIndex].ofrresourceName = this.goods2[0].resourceName
              this.thingsList.filter(item => item.ofrresourceId === this.goods2[0].ofrResourceId)[this.editResIndex].ofrthingId = this.goods2[0].ofrThingId
              this.thingsList.filter(item => item.ofrresourceId === this.goods2[0].ofrResourceId)[this.editResIndex].ofrthingName = this.goods2[0].name
            }
          }

          if(this.isAddRes) {
            let addList = this.thingsList.filter(item => item.addFlag === 'Y')
            if (addList && addList.length > 0 && this.selectedId && this.selectedId.length === 1) {
              let tempOfrResourceIds = new Set()
              tempOfrResourceIds.add(this.selectedId[0].ofrresourceId)
              addList.forEach(item => tempOfrResourceIds.add(item.ofrresourceId))
              if(tempOfrResourceIds.size === 1) {
                _uuid = this.selectedId[0].uuid
              }
            }

            this.thingsList.forEach(el => {
              this.goods = []
              if (_uuid) {
                if(!el.uuid){
                  el.uuid = _uuid
                }
              }else{
                let rObj = this.productsList.find(val => val.ofrresourceId == el.ofrresourceId)
                if(el.addFlag === 'Y'){
                  if(!rObj) {
                    let item = this.multipleList.find(val => val.ofrResourceId == el.ofrresourceId)
                    const uuid = this.generateUUIDWithoutDash()
                    let currentItem = JSON.parse(JSON.stringify(item))
                    if(!el.uuid) {
                      el.uuid = uuid
                    }
                    currentItem.uuid = uuid
                    this.goods.push(currentItem)

                    this.isAddRes = true
                    this.confirmMultiple()
                  }else {
                    if(!el.uuid) {el.uuid = rObj.uuid}
                  }
                }
              }
              el.addFlag = null
            })
          }
        }else {
          this.$message.warning('请选择内容行');
        }
      },
      // 点击明细多选
      selectThingMore(isEdit, row, index) {
        console.log('点击明细多选')
        this.dialogTableVisible2 = true
        this.search2 = ''
        if(this.$refs.tableMultiple2) {
          this.$refs.tableMultiple2.clearSelection()
        }
        if(isEdit) {
          this.isAddRes = false
          this.currentChangeOfrResourceId = row.ofrresourceId
          this.editResIndex = index
          this.currentUUID = row.uuid
          let id = this.ofrThingsList.findIndex(item => item.ofrThingId == row.ofrthingId) / this.pageThing.pageSize
          this.pageThing.pageNum = Math.floor(id + 1)
          this.currentPageThing = this.getCurrentPageThing(this.pageThing.pageSize, this.pageThing.pageNum)
          this.currentPageThing.forEach(item => {
            if(item.ofrThingId == row.ofrthingId) {
              this.$nextTick(() => {
                this.$refs.tableMultiple2.toggleRowSelection(item, true)
              })
            }
          })
        }else {
          this.isAddRes = true
          this.currentUUID = null
            this.pageThing.pageNum = 1
          this.currentPageThing = this.getCurrentPageThing(this.pageThing.pageSize, this.pageThing.pageNum)
        }
      },
      changeBom(row) {
        // console.log(JSON.parse(JSON.stringify(row)));
        if(row){
          this.treeObj = row
          this.dialogResVisible = true
        }
        this.ggsearch = ''
        this.mcsearch = ''
        this.pid = 0
        let array = this.treeObj.xpjIds ? JSON.parse(JSON.stringify(this.resTreeList)).filter(item => this.treeObj.xpjIds.split(',').includes(String(item.ofrResourceId))) : JSON.parse(JSON.stringify(this.resTreeList))

        let index = array.findIndex(item => item.ofrResourceId == this.treeObj.ofrresourceId) < 0 ? 0 : (array.findIndex(item => item.ofrResourceId == this.treeObj.ofrresourceId) / this.pageinfo.pageSize)
        // console.log(index);

        this.pageinfo.pageNum = Math.floor(index + 1)
        this.resList = this.currentChangePage(this.pageinfo.pageSize, this.pageinfo.pageNum)
        this.$nextTick(() => {
          this.$refs.restypeTable.clearSelection()
        })
        this.resList.forEach(item => {
          if(item.ofrResourceId == this.treeObj.ofrresourceId) {
            this.$nextTick(() => {
              this.$refs.restypeTable.toggleRowSelection(item, true)
            })
          }
        })
      },
      handleResSelectionChange(selection) {
        // this.ofrResourceIds = JSON.parse(JSON.stringify(selection)).map(item => item.ofrResourceId)
      },
      handleResSelect(selection, row){
        // this.selectBom = JSON.parse(JSON.stringify(row))
        // 清除 所有勾选项 不可多选
        if(!this.selectBomMultiple){
          this.$refs.restypeTable.clearSelection()
        }
        // 当表格数据都没有被勾选的时候 就返回
        // 主要用于将当前勾选的表格状态清除
        // if(selection.length == 0) return
        this.$refs.restypeTable.toggleRowSelection(row, true);
      },
      clickRowRes(row, column, event) {
        // this.selectBom = JSON.parse(JSON.stringify(row))
        // 清除 所有勾选项 不可多选
        if(!this.selectBomMultiple){
          this.$refs.restypeTable.clearSelection()
        }
        this.$refs.restypeTable.toggleRowSelection(row)
      },
      searchChange() {
        this.pageinfo.pageNum = 1
        this.resList = this.currentChangePage(this.pageinfo.pageSize, 1)
      },
      handleSizeChange1(val) {
        this.pageinfo.pageSize = val
        this.pageinfo.pageNum = 1
        this.resList = this.currentChangePage(val, this.pageinfo.pageNum)
      },
      handleCurrentChange1(val) {
        this.pageinfo.pageNum = val
        this.resList = this.currentChangePage(this.pageinfo.pageSize, val)
      },
      currentChangePage(size, current) {
        const tablePush = [];
        var array = []
        if(this.ggsearch || this.mcsearch) {
          array = this.resTreeList.filter(item => {
            if(this.mcsearch && this.ggsearch){
              return item.remarks.indexOf(this.mcsearch) >= 0 && item.ggxh.indexOf(this.ggsearch) >= 0
            }
            if(this.mcsearch){
              return item.remarks.toLowerCase().indexOf(this.mcsearch.toLowerCase()) >= 0
            }
            if(this.ggsearch){
              return item.ggxh && item.ggxh.toLowerCase().indexOf(this.ggsearch.toLowerCase()) >= 0
            }
            return true
          })
          // array = this.resTreeList.filter(data => !this.search1 || data.remarks.toLowerCase().includes(this.search1.toLowerCase()))
        }else {
          array = this.treeObj.xpjIds ? JSON.parse(JSON.stringify(this.resTreeList)).filter(item => this.treeObj.xpjIds.split(',').includes(String(item.ofrResourceId))) : JSON.parse(JSON.stringify(this.resTreeList))
          // array = JSON.parse(JSON.stringify(this.resTreeList))
          // array = arr
        }
        // console.log(JSON.parse(JSON.stringify(array)));

        this.pageinfo.total = array.length
        // console.log(array.findIndex(item => item.ofrResourceId == this.treeObj.ofrresourceId));
        // let index = array.findIndex(item => item.ofrResourceId == this.treeObj.ofrresourceId) < 0 ? 0 : (array.findIndex(item => item.ofrResourceId == this.treeObj.ofrresourceId) / this.pageinfo.pageSize)
        // // console.log(index);

        // this.pageinfo.pageNum = Math.floor(index + 1)

        array.forEach((item, index) => {
          if (size * (current - 1) <= index && index <= size * current - 1) {
            tablePush.push(item);
          }
        });
        return tablePush;
      },
      async submitRes() {
        this.selectBomMultiple = false

        const selectedRows = this.$refs.restypeTable.selection
        this.selectBom = JSON.parse(JSON.stringify(selectedRows))
        this.$refs.restypeTable.clearSelection()
        if(this.selectBom && this.selectBom.length > 0) {
          if(this.pid) { // 新增BOM
            for (let i = 0; i < this.selectBom.length; i++) {
              let item = this.selectBom[i]
              let obj = {
                cbowhId: this.corCbowh(item, 'Resource', item.cbRestypeId, 'id'),
                cbowhName: this.corCbowh(item, 'Resource', item.cbRestypeId, 'name'),
                quantity: this.ofoFlowWork.costmanagetype == '4' ? 1 : (this.isCheckQuantity ? this.handleCalc(item.availableQuantityList) : ''),
                price: (!this.ofoFlowWork.kindtype.includes(',') && this.cbResourceTypeList[0].isShowPrice == '0' && this.isCheckPrice) ? this.comdifyPrams(item.rprice) : '',
                total: '',
                vatgroup: (!this.ofoFlowWork.kindtype.includes(',') && this.cbResourceTypeList[0].isShowPrice == '0' && this.isCheckPrice) ? (item.rslv ? item.rslv : this.dropDown.invoiceVat[0].dictValue) : this.dropDown.invoiceVat[0].dictValue,
                totalVat: '',
                invoicetype: this.dropDown.invoiceType[0].dictValue,
                cost: '',
                costTotal: '',
                costTotalVat: '',
                beginValue: '',
                endValue: '',
                workConfigList1: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList1) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList1)) : [],
                workConfigList2: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList2) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList2)) : [],
                workConfigList3: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList3) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList3)) : [],
                workConfigList4: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList4) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList4)) : [],
                bomId: item.ofrResourceId + String(this.bomRow.bomId),
                name: item.resourceName,
                stock: null,
                rid: this.bomRow.rid,
                children: null,
                ofrresourceId: item.ofrResourceId,
                ofrresourceName: item.resourceName,
                pid: this.pid,
                ggxh: item.ggxh,
                jldw: item.jldw,
                cbRestypeId: item.cbRestypeId,
                cbowhTo: '',
                cbowhToName: '',
                bzdw: item.sjdw,
                bzsl: '',
                bzxs: item.sjxs
              }
              // this.index ++
              if(this.ofoFlowWork.costmanagetype == '9') {
                await this.$http.get(url.getOfrResource, {params: {ofrResourceId: item.ofrResourceId}}).then(res => {
                  obj.dimensionList = this.handleFormList(res.data.data.dimensionList)
                })
              }
              this.bomRow.children ? this.bomRow.children.push(obj) : this.bomRow.children = [obj]
            }
          }else { // 切换BOM
            this.treeObj.ofrresourceName = this.treeObj.name = this.selectBom[0].resourceName
            this.treeObj.ofrResourceId = this.treeObj.ofrresourceId = this.selectBom[0].ofrResourceId
            this.treeObj.ggxh = this.selectBom[0].ggxh
            this.treeObj.jldw = this.selectBom[0].jldw
            this.treeObj.bzdw = this.selectBom[0].sjdw
            this.treeObj.bzsl = ''
            this.treeObj.bzxs = this.selectBom[0].sjxs
          }
        }
        this.dialogResVisible = false
      },
      // 切换展开/收起状态
      changeExpand() {
        this.isExpand = !this.isExpand
        this.$nextTick(() => {
          this.copyFromList.forEach(item => {
            this.$refs.tables.toggleRowExpansion(item, this.isExpand)
          })
        })

      },
      handleResourceView(row) {
        this.ofrResource = {
          remarks: '',
          resourceName: ''
        }
        this.dimensionList = []
        this.owhResources = []
        this.dialogResourceViewVisible = true
        this.historyResData = {}
        this.historyOfrResourceId = row.ofrresourceId
        this.showHistory = false
        this.$http.get(url.getOfrResource, {params: {ofrResourceId: row.ofrresourceId,needOfOwhData:true}}).then(res => {
          // console.log(res.data.data);
          this.ofrResource = res.data.data.ofrResource
          this.dimensionList = this.handleFormList(res.data.data.dimensionList)
          this.owhResources = res.data.data.owhResources || []
          this.historyResData = res.data.data.cbResourceType
          this.showHistory = this.historyResData.cfflowworkIds && this.btnMenu.some(item => item.perms === `${this.transferKind(this.historyResData.kind)}:his`) && this.handleDutys(this.ofoFlowWork.dutys, 'hisType') && this.handleDutys(this.ofoFlowDeal.dutys, 'hisType')
        })
      },
      transferKind(kind){
        switch(kind) {
          case '1':
            return 'rl'
          case '2':
            return 'wl';
          case '3':
            return 'cp';
          case '4':
            return 'wd';
          case '5':
            return 'fw';
          case '6':
            return 'gl';
          case '7':
            return 'hb';
        }
        return 'unkown'
      },
      format(percentage) {
        return percentage === 100 ? '' : `${percentage}%`;
      },
      multipleChooseSearch(){

        this.changeCbResourceType(this.cbRestypeId)

      },
       resetSearch(){
        this.search = null
        this.search2 = null
        this.codeSearch = null
        if(this.cbussDimeTree && this.cbussDimeTree.length > 0){
          for (let i = 0; i < this.cbussDimeTree.length; i++) {
            this.cbussDimeTree[i].value = null
            this.$nextTick(() => {
              const treeRef = this.$refs[`tree${i + 1}`]
              if (treeRef && treeRef[0] && treeRef[0].setCurrentKey) {
                treeRef[0].setCurrentKey(null)
              }
            });
          }
        }
        this.getResList()
      },
      // 当前页改变
      handleCurrentChangeMultiple(page) {
        // console.log('handleCurrentChange',page)
        this.multiplePageNum = page;
      },

      // 每页条数改变
      handleSizeChangeMultiple(val) {
        // console.log('handleSizeChange', val)
        this.multiplePageSize = val;
      },
      handleSelectionChange1(value) {
        this.handleSelectionList1 = JSON.parse(JSON.stringify(value)).map(item => {
          return {
            ...item,
            rate: 100,
            openTotal: this.handleSelectionList1.find(val => val.ofoWorkId == item.ofoWorkId) ? this.handleSelectionList1.find(val => val.ofoWorkId == item.ofoWorkId).openTotal : item.openTotal
          }
        })
        // console.log(JSON.parse(JSON.stringify(this.handleSelectionList1)));
        // // this.handleSelectionList1 = JSON.parse(JSON.stringify(value))
        this.controlTotal1 = value.map(item => item.openTotal)
      },
      rowClickCheck1(row) {
        this.$refs.tableCheck1.toggleRowSelection(row);
        // this.handleSelectCheck1(this.handleSelectionList1, row)
      },
      // handleSelectCheck1(selection, row) {
      //   // this.bill_id = row.id;
      //   // 清除 所有勾选项
      //   this.$refs.tableCheck1.clearSelection()
      //   // 当表格数据都没有被勾选的时候 就返回
      //   // 主要用于将当前勾选的表格状态清除
      //   if(selection.length == 0) return
      //   this.$refs.tableCheck1.toggleRowSelection(row, true);
      // },
      handleSelectionChange2(value) {
        this.handleSelectionList2 = JSON.parse(JSON.stringify(value)).map(item => {
          return {
            ...item,
            openTotal: this.handleSelectionList2.find(val => val.ofoWorkId == item.ofoWorkId) ? this.handleSelectionList2.find(val => val.ofoWorkId == item.ofoWorkId).openTotal : item.openTotal
          }
        })
        // // this.handleSelectionList1 = JSON.parse(JSON.stringify(value))
        this.controlTotal2 = value.map(item => item.openTotal)
      },
      rowClickCheck2(row) {
        this.$refs.tableCheck2.toggleRowSelection(row);
        // this.handleSelectCheck2(this.handleSelectionList2, row)
      },
      // handleSelectCheck2(selection, row) {
      //   // this.bill_id = row.id;
      //   // 清除 所有勾选项
      //   this.$refs.tableCheck2.clearSelection()
      //   // 当表格数据都没有被勾选的时候 就返回
      //   // 主要用于将当前勾选的表格状态清除
      //   if(selection.length == 0) return
      //   this.$refs.tableCheck2.toggleRowSelection(row, true);
      // },
      getCopyCheckWorkList() {
        // console.log(this.ruleFormParent);
        // console.log(this.ofoFlowWork);
        // this.handleSelectionList1 = []
        // this.handleSelectionList2 = []
        this.goods = []
        if(!this.ruleFormParent.dealId) {
          this.$message.error(`请先选择${this.ofoFlowDeal.restype1Name}`)
          return
        }
        this.loading = true
        this.dialogCheckVisible = true
        if (!this.resourceId) {
          this.resourceId = this.goodsList && this.goodsList.length > 0 ? this.goodsList[0].ofrResourceId : null
        }
        this.$http.get(url.getCopyCheckWorkList, {params: {
          dealId: this.ruleFormParent.dealId,
          ofoflowworkId: this.ofoFlowWork.ofoFlowWorkId
        }}).then(res => {
          this.loading = false
          if(res.data.code == 200) {
            this.copyCheckWorkListBefore = res.data.data.before
            // this.copyCheckWorkListBefore[2].checkType = '3'
            this.copyCheckWorkListAfter = res.data.data.after
            // console.log(JSON.parse(JSON.stringify(this.copyCheckWorkListBefore)));
            // let obj = this.copyCheckWorkListBefore.find(item => item.ofoWorkId == this.checkBaseId)
            // this.$nextTick(() => {
            //   obj ? this.$refs.tableCheck1.toggleRowSelection(obj, true) : ''
            //   obj ? this.handleSelectionList1 = [obj] : ''
            // })
          }
        })
      },
      // 确认核销
      async confirmCheck() {
        // console.log(JSON.parse(JSON.stringify(this.handleSelectionList1)));
        // if(this.payTotal < 0) {
        //   this.$message.error('本次付款金额不能为负数');
        // }else
        if (!this.resourceId) {
          this.$message.error('请选择本次付款方式');
        }else {
          let index = this.goodsList.findIndex(item => item.ofrResourceId == this.resourceId)
          index = index < 0 ? 0 : index
          // this.checkBaseId = this.handleSelectionList1[0].ofoWorkId
          if(!this.productsList.length) {
            this.goods.push(this.goodsList[index])
            this.isAddRes = true
            await this.confirmMultiple()
          }
          this.productsList[0].total = this.comdify(this.payTotal)
          this.dialogCheckVisible = false
        }

        if(this.handleSelectionList1 && this.handleSelectionList1.length > 0){
          const workIds = this.handleSelectionList1.map(item => item.ofoWorkId).join(',')
          this.$http.get(url.getWorkSimpleListByIds, {params: {ids: workIds}}).then(res => {

            this.$emit('getChooseWorkCheckList', res.data.data)
          })
        }

      },
      handleChange1(val) {
        // console.log(val);
      },
      handleNodeClick1(e, index) {
        this.cbussDimeTree[index].value = e.value
        // this.pageNum = 1
        // console.log(111111);
        // console.log(JSON.parse(JSON.stringify(this.cbussDimeTree)));

        this.getResList()
      },
      getResList() {

        if(this.cbRestypeId == -1){

          this.goodsList = JSON.parse(JSON.stringify(this.multipleList))
          if(this.search || this.search2 || this.codeSearch){
            if(this.search){
              this.goodsList = this.goodsList.filter(data => data.resourceName.toLowerCase().includes(this.search.toLowerCase()))
            }
            if(this.search2){
              this.goodsList = this.goodsList.filter(data => data.ggxh && data.ggxh.toLowerCase().includes(this.search2.toLowerCase()))
            }
            if(this.codeSearch){
              this.goodsList = this.goodsList.filter(data => data.resourceNumber && data.resourceNumber.toLowerCase().includes(this.codeSearch.toLowerCase()))
            }
          }
          return
        }
        let cbussDimeList = this.cbussDimeTree.filter(item => item.value).map(item => {
          return {
            cbdId: item.cbdId,
            editType: item.editType,
            resourceType: item.resourceType,
            value: item.value,
            endValue: '',
          }
        })
        // 获取资源列表
        this.$http.post(url.OfrResourceList,  {
          cbRestypeId: this.cbRestypeId,
          pageNum: 1,
          pageSize: 2000,
          cbussDimeList
          // : cbussDimeList.length ? JSON.stringify(cbussDimeList) : ''
        }).then(res => {
          if(res.data.code == 200) {
            // this.resourceList = res.data.data.list
            // this.totalReource = res.data.data.total
            // this.loadingResource = false
            this.goodsList = res.data.data.list.map(item => {
              return this.multipleList.find(val => val.ofrResourceId == item.ofrResourceId)
            }).filter(val => val != undefined)
            if(this.search || this.search2){
              if(this.search){
                this.goodsList = this.goodsList.filter(data => data.resourceName.toLowerCase().includes(this.search.toLowerCase()))
              }
              if(this.search2){
                this.goodsList = this.goodsList.filter(data => data.ggxh && data.ggxh.toLowerCase().includes(this.search2.toLowerCase()))
              }
            }

            // console.log(JSON.parse(JSON.stringify(this.goodsList)));
          }
        })
      },
      handleCalc(list) {
        // console.log(JSON.parse(JSON.stringify(list)));
        // if(list.length && list.every(item => item.showValue)) {
        if(list && list.length) {
          let arr = []
          let length = list.length
          for(let i = 0; i < (length - 1); i++) {
            arr.push(list[i].brackets && list[i].brackets.includes('(') ? list[i].brackets : '', list[i].showValue, list[i].brackets && list[i].brackets.includes(')') ? list[i].brackets : '', this.handleCalcu(list[i].calcu))
          }
          arr.push(list[length - 1].brackets && list[length - 1].brackets.includes('(') ? list[length - 1].brackets : '', list[length - 1].showValue, list[length - 1].brackets && list[length - 1].brackets.includes(')') ? list[length - 1].brackets : '')

          // if(showType == '1') {
          //   return eval(arr.join('')).toFixed(4)
          // }else if(showType == '2') {
          //   return eval(arr.join('')).toFixed(2)
          // }else if(showType == '3') {
          //   return (eval(arr.join('')) * 100).toFixed(0) + '%'
          // }else {
            return eval(arr.join(''))
          // }
        }else {
          return ''
        }
      },
      configComdify(n, index, rowId) {
        if(n == 0) return 0;
        if(!n) return '';
        n = Number(n).toFixed(2)
        let res01 = n.split(".")[0];
        let res02 = n.split(".")[1];
        this.productsList[rowId].workConfigList4[index].configValue = `${res01}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + `.${res02}`;
      },
      configDelComdify(n, index, rowId) {
        // let obj = JSON.parse(JSON.stringify(item))
        if(n == 0) return 0;
        if(!n) return '';
        let numS = n;
        numS = numS.toString();
        this.productsList[rowId].workConfigList4[index].configValue = numS.replace(/,/gi, '');
      },
      calcStock(arr, type) {
        if(arr.length) {
          return arr.reduce((prev, cur, index, arr) => {
            return prev + cur[type]
          }, 0)
        }else {
          return ''
        }
      },
      handleChange(file, fileList) {
        const loading = this.$loading({
          lock: true,
          text: '导入中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
        let that = this
        let reader = new FileReader()
        reader.readAsArrayBuffer(file.raw)
        reader.onload = function () {
          let buffer = reader.result
          let bytes = new Uint8Array(buffer)
          let length = bytes.byteLength
          let binary = ''
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i])
          }
          let wb = XLSX.read(binary, {
            type: 'binary',
            cellDates: true
          })
          let outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
          let da = [...outdata];
          // console.log(JSON.parse(JSON.stringify(da)));
          // 这里是把表格里面的名称改成表格里面的字段
          da.map((item, index) => {
            let newItem = {}
            that.tableData.forEach(val => {
              for(let key in item) {
                if(key == val.label) {
                  if(val.prop == 'vatgroup') {
                    // console.log(item[key]);
                    newItem[val.prop] = item[key].toFixed(2)
                  }else if(val.prop == 'invoicetype') {
                    that.dropDown.invoiceType.forEach(el => {
                      if(el.dictLabel == item[key]) {
                        newItem[val.prop] = el.dictValue + ''
                      }
                    })
                  }else if(val.prop == 'price' || val.prop == 'total') {
                    newItem[val.prop] = that.comdify(item[key] + '')
                  }else if(val.prop == 'resDime') {

                  }else if(((that.ofoFlowWork.costmanagetype == '7') && (val.prop == 'beginValue' || val.prop == 'endValue'))) {
                    newItem[val.prop] = that.parseTime(new Date(item[key]).getTime() + 43000, '{y}-{m}-{d} {h}:{i}')
                  }else {
                    newItem[val.prop] = item[key] + ''
                  }
                  break
                }else {
                  newItem[val.prop] = ''
                }
              }
            })
            // 初始化资源行配置
            newItem.workConfigList1 = (that.ofoFlowWork.checkConfig && that.workConfig.workConfigList1) ? JSON.parse(JSON.stringify(that.workConfig.workConfigList1)) : []
            newItem.workConfigList2 = (that.ofoFlowWork.checkConfig && that.workConfig.workConfigList2) ? JSON.parse(JSON.stringify(that.workConfig.workConfigList2)) : []
            newItem.workConfigList3 = (that.ofoFlowWork.checkConfig && that.workConfig.workConfigList3) ? JSON.parse(JSON.stringify(that.workConfig.workConfigList3)) : []
            newItem.workConfigList4 = (that.ofoFlowWork.checkConfig && that.workConfig.workConfigList4) ? JSON.parse(JSON.stringify(that.workConfig.workConfigList4)) : []
            for(let key1 in newItem) {
              if(key1 == 'workConfigList1' || key1 == 'workConfigList2' || key1 == 'workConfigList3' || key1 == 'workConfigList4') {
                newItem[key1].forEach(val => {
                  for(let key in item) {
                    if(val.name == key) {
                      val.configValue = item[key]
                      break
                    }
                  }
                })
                if(key1 == 'workConfigList1' || key1 == 'workConfigList2' || key1 == 'workConfigList3') {
                  let result = newItem[key1].some((item => {
                    return item.configValue
                  }))
                  if(result) { // 填了资源行，计算资源行
                    that.computeSl(newItem, undefined, key1)
                  }else { // 没有资源行，计算金额税额
                    that.compute1(newItem)
                  }
                }else {
                  // console.log(JSON.parse(JSON.stringify(newItem[key1])));
                  newItem[key1].forEach(val => {
                    if(val.showType == '1') {
                      val.configValue *= 100
                    }else if(val.showType == '2') {
                      let obj = JSON.parse(val.options).find(item => item.dictLabel == val.configValue)
                      val.configValue = obj ? String(obj.dictValue) : ''
                    }else if(val.showType == '4') {
                      val.configValue = that.parseTime(new Date(val.configValue).getTime() + 43000, '{y}-{m}-{d}')
                    }else if(val.showType == '5') {
                      val.configValue = that.comdify(val.configValue)
                    }
                  })
                }

              }
            }
            // 初始化资源名称和id
            newItem.ofrresourceId = ''
            that.goodsList.forEach(val => {
              let ggxh_1 = val.ggxh == null ? "":val.ggxh.trim()
              let ggxh_2 = newItem.ggxh == null ? "":newItem.ggxh.trim()
              let jldw_1 = val.jldw == null ? "":val.jldw.trim()
              let jldw_2 = newItem.jldw == null ? "":newItem.jldw.trim()
              if(ggxh_1 == ggxh_2 && jldw_1 == jldw_2 && (val.name.trim() == newItem.ofrresourceName.trim() || val.resourceName.trim() == newItem.ofrresourceName.trim())) {
                if(!newItem.ofrresourceId) { // 只找到一条资源
                  newItem.ofrresourceId = val.ofrResourceId + ''
                }else { // 找到多条资源
                  newItem.ofrresourceId = newItem.ofrresourceId + ',' + val.ofrResourceId
                }
              }
            })
            if(newItem.ofrresourceId.includes(',')) { // 找到多条资源
              newItem.isMultiRes = newItem.ofrresourceId.split(',').length
            }else if(!newItem.ofrresourceId) { // 一条资源都没有
              that.$http.post(url.addOfrResource, qs.stringify({
                cbRestypeId: that.cbResourceTypeList[0].cbRestypeId,
                documentstatus: '1',
                resourceName: newItem.ofrresourceName,
                ggxh:newItem.ggxh,jldw:newItem.jldw
              })).then(res => {
                if(res.data.code === 200) {
                  newItem.ofrresourceId = res.data.data
                  that.$http.get(url.getResTypesAndList, {params:
                    {
                      cbRestypeIds: that.ofoFlowWork.kindtype,
                    }
                  }).then(res => {
                    if(res.data.code == 200) {
                      that.goodsList = res.data.data.list
                      that.goodsList.forEach(item => {
                        if(item.ofrResourceId == that.ofrResourceId) {
                          that.ofrresourceName = item.resourceName
                        }
                        item.name = item.resourceName.split(':')[0]
                      })
                      that.multipleList = JSON.parse(JSON.stringify(that.goodsList))
                    }
                  })
                }
              })
            }else { // 只找到一条资源
              newItem.isMultiRes = 1
            }
            // 初始化位置
            newItem.cbowhId = (that.ofoFlowWork.chooseOwh == '0' && that.cbOwhData.length) ? that.cbOwhData[0].cbOwhId : ''
            newItem.cbowhName = (that.ofoFlowWork.chooseOwh == '0' && that.cbOwhData.length) ? that.cbOwhData[0].name : ''
            // 初始化成本
            newItem.cost = ''
            newItem.costTotal = ''
            newItem.costTotalVat = ''
            if(newItem.beginValue && newItem.endValue) {
              if(that.ofoFlowWork.costmanagetype == '7') {
                that.handleChangeSj1(newItem)
              }else if(that.ofoFlowWork.costmanagetype == '8' || that.ofoFlowWork.costmanagetype == '11') {
                that.handleCount1(newItem)
              }
            }
            newItem.bomId = -that.index - 1
            newItem.stock = null
            that.index ++
            // newItem.beginValue = ''
            // newItem.endValue = ''
            // console.log(JSON.parse(JSON.stringify(newItem)));
            that.productsList.push(newItem)
          })
          // console.log(JSON.parse(JSON.stringify(that.productsList)));
          loading.close()
          that.dialogVisible = false
        }
      },
      // 导入按钮
      async importBtn() {
        this.dialogVisible = true
        this.tableData = []
        let dime = null
        let newDime = []
        let thingIndex = null
        // await this.$http.get(url.getImportResTypeList, {
        //   params: {
        //     kind: this.cbResourceTypeList[0].kind,
        //     restypeName: this.cbResourceTypeList[0].restypeName
        //   },
        // }).then(res => {
        //   dime = res.data.data.list[0].dime
        //   thingIndex = dime.indexOf('内容名称') - 2
        //   dime = dime.slice(6, thingIndex).split(', ')
        //   dime.forEach(item => {
        //     newDime.push({
        //       label: item,
        //       prop: 'resDime'
        //     })
        //   })
        // })
        this.$refs.multipleTable.$children.forEach(item => {
          if(item.prop != undefined && item.prop != 'cbowhId' && item.prop != 'cost' && item.prop != 'costTotal' && item.prop != 'costTotalVat') {
            this.tableData.push({
              label: item.label,
              prop: item.prop
            })
          }
        })
        this.tableData.splice(1, 0, ...newDime)
      },
      // 导出按钮
      async exportBtn() {
        let arr = this.tableData.map(obj => {return obj.label})
        let workSheet = XLSX.utils.aoa_to_sheet([arr]);
        workSheet["!cols"] = []
        for(var i = 0; i < arr.length; i ++){
          workSheet["!cols"][i] = {wpx: 80}
        }
        let bookNew = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(bookNew, workSheet, this.ofoFlowWork.kindtypeName) // 工作簿名称
        let name = this.ofoFlowWork.kindtypeName + '.xlsx'
        XLSX.writeFile(bookNew, name) // 保存的文件名
      },
      handleNodeClick(data, node, component) {
        this.select = data.cbOwhId
      },
      changeVatgroup(isThing, type, sel, value, row, ofrresourceId) {
        // console.log(ofrthingId);
        // props.row.ofrresourceId

        this.dialogSelectVisible = true
        this.sel = sel
        this.changeSelectThing = isThing
        this.changeOfrthingId = ofrresourceId
        if(type == 'all') {
          this.select = ''
          if(this.sel == 'cbowhId' || this.sel == 'cbowhTo') {
            this.$nextTick(function () {
              this.$refs.treeList.setCurrentKey(null);
            });
          }
          this.isAll = true
        }else {
          this.select = value
          if(this.sel == 'cbowhId' || this.sel == 'cbowhTo') {
            this.$nextTick(function () {
              this.$refs.treeList.setCurrentKey(value);
            });
          }
          // this.index = id
          this.row = row
          this.isAll = false
        }
      },
      submitSelect() {
        if(this.select) {
          if(this.isAll) {
            if(this.changeSelectThing) {
              if(this.thingsList.length) {
                this.changeSelect(this.thingsList.filter(item => item.ofrresourceId == this.changeOfrthingId))
              }
            }else {
              if(this.productsList.length) {
                this.changeSelect(this.productsList)
                if(this.ofoFlowWork.costmanagetype === '11'){
                  for (let i = 0; i < this.productsList.length; i++) {
                    const tempGood = this.goodsList.find((item => item.ofrResourceId == this.productsList[i].ofrresourceId))?.ofrOwhResourceList?.find(item => item.owhId === this.select);
                    this.$set(this.productsList[i], 'beginValue', tempGood?.resourceQuantity || 0)
                    this.$set(this.productsList[i], 'price', tempGood?.cost || 0)
                    this.handleCount1(this.productsList[i])
                  }
                }
              }
            }

          }else {
            this.row[this.sel] = this.select
            if(this.sel == 'vatgroup') {
              this.compute4(this.row)
            }else if(this.sel == 'cbowhId') {
              this.row.cbowhName = this.changeCbowh(this.select)

              if(this.ofoFlowWork.costmanagetype === '11'){
                const tempGood = this.goodsList.find((item => item.ofrResourceId === this.row.ofrresourceId))?.ofrOwhResourceList?.find(item => item.owhId === this.select)
                this.$set(this.row, 'beginValue', tempGood?.resourceQuantity || 0)
                this.$set(this.row, 'price', tempGood?.cost || 0)
                this.handleCount1(this.row)
              }
            }else if(this.sel == 'cbowhTo') {
              this.row.cbowhToName = this.changeCbowh(this.select)
            }
          }
        }
        this.dialogSelectVisible = false
      },
      changeSelect(treeList) {
        treeList.forEach(row => {
          row[this.sel] = this.select
          if(this.sel == 'vatgroup') {
            this.compute4(row)
          }else if(this.sel == 'cbowhId') {
            row.cbowhName = this.changeCbowh(row.cbowhId)

          }else if(this.sel == 'cbowhTo') {
            this.$set(row,'cbowhToName',this.changeCbowh(row.cbowhTo))
            // console.log(row.cbowhToName);
          }

          if(row.children) {
            this.changeSelect(row.children)
          }
        })
      },
      changeCbowh(e) {
        let name = ''
        this.cbOwhData.forEach(item => {
          if(item.cbOwhId == e) {
            name = item.name
          }
        })
        return name
      },
      handleSizeChange(val) {
        this.$emit('getWorkResList', {ofoWorkId: this.ofoWorkId, pageNum: 1,pageSize: val})
      },
      handleCurrentChange(val) {
        this.$emit('getWorkResList', {ofoWorkId: this.ofoWorkId, pageNum: val, pageSize: this.pageSize})
      },
      tableRowClassName({row, rowIndex}) {
        // if (row.ofoWorkId == this.ruleForm.ofoWorkId) {
          return 'success-row';
        // }
        // return '';
      },
      tableTreeRowStyle({row, rowIndex}) {
        // console.log(JSON.parse(JSON.stringify(row)));
        let color = 230 + row.level * 4
        return this.ofoFlowWork.isCalcBom == '0' ? {
          background: `rgb(${color},${color},${color})`
        } : {}
      },
      // 新增资源
      addResource() {
        this.resourceForm.resourceName = ''
        this.resourceForm.remarks = ''
        this.resourceForm.dataSourceConfig = []
        this.dialogResourceVisible = true
        this.cbResourceTypeList.some(item => {
          if(item.isAdd == '0') {
            this.resourceForm.cbRestypeId = item.cbRestypeId
            this.resData = item
            this.getCbussDimeList()
            return true
          }
        })
        this.$nextTick(() => {
          // 清除表单校验效果
          this.$refs.resourceForm.clearValidate();
        })
        // 获取资源维度列表

      },
      changeRes() {
        this.getCbussDimeList()
      },
      getCbussDimeList() {
        this.$http.get(url.getCbussDimeList, {params: {cbussId: this.resourceForm.cbRestypeId, dimetype: '1'}}).then(res => {
          if(res.data.code == 200) {
            this.resourceFormList = this.handleFormList(res.data.data)
            this.resourceFormList.forEach(item => {
              if(item.dvalue){
                item.dimeValue = item.dvalue
                item.dimeText = item.dvalue
              }
            })
            this.resourceForm.dataSourceConfig = this.resourceFormList
          }
        })
      },
      // 提交资源
      submitResourceForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isDisabled = true
            let dimes = []
            if(this.resourceFormList.length) {
              dimes = this.handleDimes(this.resourceFormList)
            }
            delete this.resourceForm.dataSourceConfig
            // 新增产品
            this.$http.post(url.addOfrResource, qs.stringify({
              ...this.resourceForm,
              dimes: JSON.stringify(dimes)
            })).then(res => {
              this.isDisabled = false
              if(res.data.code === 200) {
                this.$message.success(res.data.msg)
                this.dialogResourceVisible = false
                this.ofrResourceId = res.data.data
                this.$http.get(url.getResTypesAndList, {params:
                  {
                    cbRestypeIds: this.ofoFlowWork.kindtype,
                  }
                }).then(res => {
                  if(res.data.code == 200) {
                    this.goodsList = res.data.data.list
                    this.goodsList.forEach(item => {
                      if(item.ofrResourceId == this.ofrResourceId) {
                        this.ofrresourceName = item.resourceName
                      }
                      item.name = item.resourceName.split(':')[0]
                    })
                    this.multipleList = JSON.parse(JSON.stringify(this.goodsList))
                    this.productsList.push({
                      // cbowhId: this.corCbowh(this.resourceForm.cbRestypeId, 'id'),
                      // cbowhName: this.corCbowh(this.resourceForm.cbRestypeId, 'name'),
                      cbowhId: this.corCbowh({}, 'Resource', this.resourceForm.cbRestypeId, 'id'),
                      cbowhName: this.corCbowh({}, 'Resource', this.resourceForm.cbRestypeId, 'name'),
                      ofrresourceId: this.ofrResourceId,
                      ofrresourceName: this.ofrresourceName,
                      quantity: this.ofoFlowWork.costmanagetype == '4' ? 1 : '',
                      price: '',
                      total: '',
                      vatgroup: this.dropDown.invoiceVat[0].dictValue,
                      totalVat: '',
                      invoicetype: this.dropDown.invoiceType[0].dictValue,
                      cost: '',
                      costTotal: '',
                      costTotalVat: '',
                      beginValue: '',
                      endValue: '',
                      workConfigList1: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList1) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList1)) : [],
                      workConfigList2: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList2) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList2)) : [],
                      workConfigList3: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList3) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList3)) : [],
                      workConfigList4: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList4) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList4)) : [],
                      bomId: -1 - this.index,
                      stock: null,
                      name: this.ofrresourceName,
                      rid: this.ofrResourceId,
                      children: null,
                      pid: null,
                      ggxh: this.resourceForm.ggxh,
                      jldw: this.resourceForm.jldw,
                      bzxs: this.resourceForm.sjxs,
                      bzdw: this.resourceForm.sjdw,
                      bzsl: null,
                    })
                    this.index ++
                  }
                })
              }
            })
          }
        })
      },
      // 点击复制从按钮
      async copyFromAdd() {
        this.isName = window.sessionStorage.getItem('isName') === 'Y'
        this.loading = true
        let ofoflowworkId = this.ofoFlowWork.ofoFlowWorkId
        this.dialogCopyFromVisible = true
        this.comfirmCopyFromList = []
        await this.$http.get(url.getWorkFromList, {params: {ofoflowworkId, "ofrResourceName": this.ofrResourceNameQuery,"dealName":this.dealNameQuery,dealId: this.ruleFormParent.dealId,"workCode":this.workCodeQuery,"workName":this.workNameQuery}}).then(res => {
          this.loading = false
          if(res.data.code == 200) {
            this.copyFromList = res.data.data
            this.copyFromList.forEach((item, index) => {
              item.childIdList = []
              // item.ofoWorkResourceList = this.handleDimes(item.ofoWorkResourceList, 'ofrresourceName', 'ofrresourceName')
              if(item.ofoWorkResourceList.length) {
                item.ofoWorkResourceList.forEach(val => {
              // val.ggxh = 'gggf'
                  val.parentId = item.ofoWorkId
                  item.childIdList.push(val.ofoWorkResourceId)
                })
              }
              item.ofoWorkResourceList = this.$handleTree(item.ofoWorkResourceList, 'bomId', 'pid')
            })
          }
          console.log('复制从列表数据', this.copyFromList)
        })
        // this.copyFromList.forEach((item, index) => {
        //   this.$refs['tableCopyFrom' + index].clearSelection()
        // })
      },
      // 点击行折叠展开
      cellClick(row, column, event) {
        this.$refs.tables.toggleRowExpansion(row)
      },
      selectFather(selection, row) {
        const isCheck = selection.includes(row)
        this.copyFromList.forEach((item, index) => {
          if (item.ofoWorkId === row.ofoWorkId) {
            this.$refs.tables.toggleRowExpansion(item, true)
            const tempList = row.ofoWorkResourceList
            this.$nextTick(() => {
              if (tempList.length !== 0) {
                tempList.forEach((childItem) => {
                  this.selectAllChildMap.set(index, item)
                  this.$refs['tableCopyFrom' + index].toggleRowSelection(childItem, isCheck)
                  if(childItem.children) {
                    this.setSelect(childItem.children, index, isCheck)
                  }
                })
              }
            })
          }
        })
        if (isCheck) {
          this.validIs(row.ofoWorkResourceList)
        } else {
          this.cleanIs(null, row)
        }
      },
      selectAllFather(selection) {
        this.copyFromList.forEach(async (item, index) => {
          await this.$refs['tables'].toggleRowExpansion(item, true)
          if (selection.length !== 0) {
            this.selectFather([item], item)
            this.selectAllChild(item.ofoWorkResourceList, index)
          } else {
            // console.log(item);
            this.cleanIs(null, item)
          }
          this.$refs['tableCopyFrom' + index].clearSelection()
        })
        //
      },
      expandChange(row, expandedRows) {
        // console.log(row);
        // console.log(expandedRows);
        const expandedRowsIds = expandedRows.map(m => m.ofoWorkId)
        this.$nextTick(() => {
          const ids = this.comfirmCopyFromList.map(f => f.ofoWorkResourceId)
          this.copyFromList.forEach((item, index) => {
            if(item.ofoWorkId == row.ofoWorkId && expandedRowsIds.includes(row.ofoWorkId)) {
              row.ofoWorkResourceList.forEach(val => {
                if(ids.includes(val.ofoWorkResourceId)) {
                  this.$refs['tableCopyFrom' + index].toggleRowSelection(val, true)
                  if(val.children) {
                    this.setSelect(val.children, index, true)
                  }
                }
              })
            }
          })
        })

      },
      selectChild(selection, row, index) {
        const ids = this.comfirmCopyFromList.map(f => f.ofoWorkResourceId)
        ids.includes(row.ofoWorkResourceId) ?
        this.comfirmCopyFromList.splice(this.comfirmCopyFromList.findIndex(item => item.ofoWorkResourceId == row.ofoWorkResourceId), 1) :
        this.comfirmCopyFromList.push(row)
        if(row.children) {
          this.setSelect(row.children, index, !ids.includes(row.ofoWorkResourceId))
        }
        const isCheck = this.$refs['tableCopyFrom' + index].selection.length > 0
        // this.getOneArr(JSON.parse(JSON.stringify(this.copyFromList))).forEach((item, index) => {
        //   if (item.ofoWorkId === row.parentId) {
        //     this.selectAllChildMap.set(index, item)
        //     console.log(this.selectAllChildMap);
        //     this.$refs.tables.toggleRowSelection(item, isCheck)
        //   }
        // })
        this.copyFromList.forEach((item, index) => {
          if (item.ofoWorkId === row.parentId) {
            this.selectAllChildMap.set(index, item)
            // console.log(this.selectAllChildMap);
            this.$refs.tables.toggleRowSelection(item, isCheck)
          }
        })
        // console.log(this.comfirmCopyFromList.map(f => f.ofrresourceName));
      },
      setSelect(list, index, isCheck) {
        list.forEach(item => {
          this.$refs['tableCopyFrom' + index].toggleRowSelection(item, isCheck)
          const ids = this.comfirmCopyFromList.map(f => f.ofoWorkResourceId)
          if(isCheck) {
            ids.includes(item.ofoWorkResourceId) ? true : this.comfirmCopyFromList.push(item)
          }else {
            ids.includes(item.ofoWorkResourceId) ? this.comfirmCopyFromList.splice(this.comfirmCopyFromList.findIndex(val => val.ofoWorkResourceId == item.ofoWorkResourceId), 1) : true
          }
          if(item.children) {
            this.setSelect(item.children, index, isCheck)
          }
        })
      },
      selectAllChild(selection, clickIndex) {
        let a = selection.map(item => item.ofoWorkResourceId)
        let b = this.copyFromList[clickIndex].ofoWorkResourceList.map(item => item.ofoWorkResourceId)
        let isCheck = b.every(item => a.includes(item))
        this.copyFromList[clickIndex].ofoWorkResourceList.forEach(item => {
          if(item.children) {
            this.setSelect(item.children, clickIndex, isCheck)
          }else {
            this.$refs['tableCopyFrom' + clickIndex].toggleRowSelection(item, isCheck)
          }
        })
        if (selection.length > 0) {
          const fatherRow = this.copyFromList.find(item => {
            return item.ofoWorkId === selection[0].parentId
          })
          this.selectAllChildMap.set(clickIndex, fatherRow)
          this.$refs.tables.toggleRowSelection(this.selectAllChildMap.get(clickIndex), true)
          // 非空时候 检验明细是否存在
          this.validIs(selection)
        } else {
          this.cleanIs(clickIndex)
          this.$refs.tables.toggleRowSelection(this.selectAllChildMap.get(clickIndex), false)
          this.selectAllChildMap.delete(clickIndex)
        }
      },
      //一级勾选框和子级头部勾选框检验
      validIs (selection) {
        // 非空时候 检验明细是否存在
        if (this.comfirmCopyFromList.length === 0) {
          this.comfirmCopyFromList.push(...selection)
        } else {
          let ids = this.comfirmCopyFromList.map(f => f.ofoWorkResourceId)
          selection.forEach(f => {
            if (ids.indexOf(f.ofoWorkResourceId) !== -1) {
              delete this.comfirmCopyFromList[ids.indexOf(f.ofoWorkResourceId)]
            }
          })
          this.comfirmCopyFromList = this.comfirmCopyFromList.filter(f => f.ofoWorkResourceId)
          ids = this.comfirmCopyFromList.map(f => f.ofoWorkResourceId)
          this.comfirmCopyFromList.push(...selection)
        }
      },
      //一级勾选框和子级头部勾选清空方法
      cleanIs (clickIndex, fatherRow) {
        const childIdList = clickIndex || clickIndex === 0 ? this.copyFromList[clickIndex].childIdList : fatherRow.childIdList
        let ids = this.comfirmCopyFromList.map(f => f.ofoWorkResourceId)
        childIdList.forEach(f => {
          if (ids.indexOf(f) !== -1) {
            delete this.comfirmCopyFromList[ids.indexOf(f)]
          }
        })
        this.comfirmCopyFromList = this.comfirmCopyFromList.filter(f => f.ofoWorkResourceId)
        ids = this.comfirmCopyFromList.map(f => f.ofoWorkResourceId)
      },
      // 勾选复制从列表
      handleCopyFromSelect(val, row) {
        let index = this.comfirmCopyFromList.findIndex(item => item.ofoWorkResourceId == row.ofoWorkResourceId)
        // let index = this.comfirmCopyFromList.findIndex(item => item == row.total)
        if (index == -1) {
          this.comfirmCopyFromList.push(row)
          // this.comfirmCopyFromList.push(row.total)
        }else {
          this.comfirmCopyFromList.splice(index, 1)
        }
      },
      handleCopyFromSelectAll(val, selectedTable) {
        selectedTable.forEach(el => {
          let index = this.comfirmCopyFromList.findIndex(item => item.ofoWorkResourceId == el.ofoWorkResourceId)
          // let index = this.comfirmCopyFromList.findIndex(item => item == el.total)
          if(val.length) {
            if (index == -1) {
              this.comfirmCopyFromList.push(el)
              // this.comfirmCopyFromList.push(el.total)
            }
          }else {
            if(index != -1) {
              this.comfirmCopyFromList.splice(index, 1)
            }
          }
        })
      },
      handleCopyFromRowClick(row, column, event, index) {
        this.$refs['tableCopyFrom' + index].toggleRowSelection(row)
        this.selectChild([row], row, index)
      },
      getRowKeyCopyFrom(row) {
        return row.ofoWorkResourceId
      },
      getRowKey(row) {
        // console.log(JSON.parse(JSON.stringify(row)));
        return row.ofoWorkResourceId ? row.ofoWorkResourceId : row.bomId
      },
      changeIsName(e){
        window.sessionStorage.setItem('isName', e ? 'Y': 'N')
      },
      // 确认复制从
      async confirmCopyFrom() {
        // console.log(JSON.parse(JSON.stringify(this.ofoFlowWork)));
        console.log(JSON.parse(JSON.stringify(this.comfirmCopyFromList)));
        if(this.ofoFlowWork.beforecopy == '3') { // bom物料
          this.comfirmCopyFromList = this.comfirmCopyFromList.filter(val => {
            return !val.children
          })
          if(this.comfirmCopyFromList && this.comfirmCopyFromList.length > 0){
            this.comfirmCopyFromList.forEach(item => {
              item.rid = item.ofrresourceId
            })
          }
          // console.log(JSON.parse(JSON.stringify(this.comfirmCopyFromList)));
        }else if(this.ofoFlowWork.beforecopy == '2') { // bom产品
          this.comfirmCopyFromList.forEach(item => {
            // console.log(!item.pid);
            item.children = []
          })
          this.comfirmCopyFromList = this.comfirmCopyFromList.filter(val => {
            return !val.pid
          })
        }else {
          this.comfirmCopyFromList = this.comfirmCopyFromList.filter(val => {
            return !val.pid
          })
        }
        this.dialogCopyFromVisible = false
        let obj = {}
        let thingsList = []
        this.copyFromList.forEach(item => {
          if(item.ofoWorkResourceList.length) {
            this.getOneArr(JSON.parse(JSON.stringify(item.ofoWorkResourceList))).forEach(val => {
              if(val.ofoWorkResourceId == this.comfirmCopyFromList[0].ofoWorkResourceId) {
                obj = item
              }
            })
          }
        })
        this.comfirmCopyFromList = handleList(this.comfirmCopyFromList, {ofoDealId: '1'}, '1', this.ofoFlowWork, this.cbOwhData, 'foWorkResourceId', this.params)
        this.comfirmCopyFromList = handleWorkConfigList(this.ofoFlowWork.checkConfig, this.comfirmCopyFromList, this.workConfig)
        this.comfirmCopyFromList.forEach(item => {
          // 生产和基础 税率为 0
          if(this.ofoFlowDeal.dealtype === '3' || this.ofoFlowDeal.dealtype === '4'){
            item.vatgroup = '0.00'
            item.totalVat = 0
          }else{
            // 税率
            let currentSlv = (this.ofoFlowDeal.dealtype === '1') ? this.params.xxs : (this.ofoFlowDeal.dealtype === '2' ? this.params.jxs : this.dropDown.invoiceVat[0].dictValue)  // 1 销售 2 采购
            if(!currentSlv){
              currentSlv = this.dropDown.invoiceVat[0].dictValue
            }
            item.vatgroup = item.vatgroup && item.vatgroup != 0 ? item.vatgroup : currentSlv
          }
          item.uuid = this.generateUUIDWithoutDash()
          item.price = !item.price || item.price == 0 ? null : item.price
          if(this.ofoFlowWork.thingtype) {
            if(item.ofoWorkThingList.length) {
              item.ofoWorkThingList.forEach(val => {
                val.uuid = item.uuid
                thingsList.push(val)
              })
              thingsList = handleList(thingsList, {ofoDealId: '1'}, '1', this.ofoFlowWork, this.cbOwhData, 'foWorkThingId', this.params)

              thingsList = handleWorkConfigList(this.ofoFlowWork.checkConfig, thingsList, this.workConfig)
            }else {
              console.log('内容自动筛选')
              // 自动带入内容
              if(this.ofoFlowWork.nrzddr === '0'){
                let obj = this.multipleList.find(val => val.ofrResourceId == item.ofrresourceId)
                let quantity = 0
                if(obj && obj.ofrThingList.length) {
                  for(let i = 0; i < obj.ofrThingList.length; i ++) {
                    // if(obj.ofrThingList[i].ofrOwhThingList.length) {
                    let owhThing = obj.ofrThingList[i].ofrOwhThingList.find(val => val.owhId == item.cbowhId)
                    // }
                    if(owhThing && owhThing.thingQuantity > 0) {
                      quantity = owhThing.thingQuantity + quantity
                      if(quantity <= item.openqty) {
                        thingsList.push({
                          cbRestypeId: obj.ofrThingList[i].cbRestypeId,
                          // cbowhId: obj.ofrThingList[0].ofrOwhThingList &&  obj.ofrThingList[0].ofrOwhThingList.length ? ( obj.ofrThingList[0].ofrOwhThingList.find(val => val.thingQuantity) ||  obj.ofrThingList[0].ofrOwhThingList[0]).owhId : this.corCbowh(obj.ofrThingList[0].cbRestypeId, 'id'),
                          // cbowhName:  obj.ofrThingList[0].ofrOwhThingList &&  obj.ofrThingList[0].ofrOwhThingList.length ? ( obj.ofrThingList[0].ofrOwhThingList.find(val => val.thingQuantity) ||  obj.ofrThingList[0].ofrOwhThingList[0]).owhName : this.corCbowh(obj.ofrThingList[0].cbRestypeId,
                          // 'name'),
                          cbowhId: this.corCbowh(obj.ofrThingList[i], 'Thing', obj.ofrThingList[i].cbRestypeId, 'id'),
                          cbowhName: this.corCbowh(obj.ofrThingList[i], 'Thing', obj.ofrThingList[i].cbRestypeId, 'name'),
                          cbowhTo: '',
                          cbowhToName: '',
                          bzxs: item.bzxs,
                          bzdw: item.bzdw,
                          bzsl: item.bzsl,
                          ofrresourceId: item.ofrresourceId,
                          ofrresourceName: item.ofrresourceName,
                          ofrthingId: obj.ofrThingList[i].ofrThingId,
                          ofrthingName: obj.ofrThingList[i].name,
                          quantity: owhThing.thingQuantity,
                          // openqty: owhThing.thingQuantity,
                          price: item.price,
                          total: this.computeThingRelation({ quantity: owhThing.thingQuantity, price: item.price, vatgroup: item.vatgroup }, 'total'),
                          totalVat: this.computeThingRelation({ quantity: owhThing.thingQuantity, price: item.price, vatgroup: item.vatgroup }, 'totalVat'),
                          // opentotal: owhThing.thingQuantity * item.price,
                          vatgroup: item.vatgroup,
                          invoicetype: item.invoicetype,
                          cost: item.cost,
                          // costTotal: item.costTotal,
                          costTotal: this.computeThingRelation({ quantity: owhThing.thingQuantity, price: item.price, vatgroup: item.vatgroup, cost: item.cost }, 'costTotal'),
                          costTotalVat: this.computeThingRelation({ quantity: owhThing.thingQuantity, price: item.price, vatgroup: item.vatgroup, cost: item.cost }, 'costTotalVat'),
                          // costTotalVat: item.costTotalVat,
                          beginValue: '',
                          endValue: '',
                          uuid: item.uuid,
                          workConfigList1: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList1) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList1)) : [],
                          workConfigList2: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList2) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList2)) : [],
                          workConfigList3: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList3) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList3)) : [],
                          workConfigList4: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList4) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList4)) : [],
                        })
                      }else {
                        if(item.openqty - (quantity - owhThing.thingQuantity) <= 0){
                          break
                        }
                        thingsList.push({
                          cbRestypeId: obj.ofrThingList[i].cbRestypeId,
                          // cbowhId: obj.ofrThingList[0].ofrOwhThingList &&  obj.ofrThingList[0].ofrOwhThingList.length ? ( obj.ofrThingList[0].ofrOwhThingList.find(val => val.thingQuantity) ||  obj.ofrThingList[0].ofrOwhThingList[0]).owhId : this.corCbowh(obj.ofrThingList[0].cbRestypeId, 'id'),
                          // cbowhName:  obj.ofrThingList[0].ofrOwhThingList &&  obj.ofrThingList[0].ofrOwhThingList.length ? ( obj.ofrThingList[0].ofrOwhThingList.find(val => val.thingQuantity) ||  obj.ofrThingList[0].ofrOwhThingList[0]).owhName : this.corCbowh(obj.ofrThingList[0].cbRestypeId,
                          // 'name'),
                          cbowhId: this.corCbowh(obj.ofrThingList[i], 'Thing', obj.ofrThingList[i].cbRestypeId, 'id'),
                          cbowhName: this.corCbowh(obj.ofrThingList[i], 'Thing', obj.ofrThingList[i].cbRestypeId, 'name'),
                          cbowhTo: '',
                          cbowhToName: '',
                          bzxs: item.bzxs,
                          bzdw: item.bzdw,
                          bzsl: item.bzsl,
                          ofrresourceId: item.ofrresourceId,
                          ofrresourceName: item.ofrresourceName,
                          ofrthingId: obj.ofrThingList[i].ofrThingId,
                          ofrthingName: obj.ofrThingList[i].name,
                          quantity: item.openqty - (quantity - owhThing.thingQuantity),
                          // openqty: owhThing.thingQuantity,
                          price: item.price,
                          total: this.computeThingRelation({ quantity: (item.openqty - (quantity - owhThing.thingQuantity)), price: item.price, vatgroup: item.vatgroup }, 'total'),
                          totalVat: this.computeThingRelation({ quantity: item.openqty - (quantity - owhThing.thingQuantity), price: item.price, vatgroup: item.vatgroup }, 'totalVat'),
                          // opentotal: owhThing.thingQuantity * item.price,
                          vatgroup: item.vatgroup,
                          invoicetype: item.invoicetype,
                          cost: item.cost,
                          costTotal: this.computeThingRelation({ quantity: item.openqty - (quantity - owhThing.thingQuantity), price: item.price, vatgroup: item.vatgroup, cost: item.cost }, 'costTotal'),
                          costTotalVat: this.computeThingRelation({ quantity: item.openqty - (quantity - owhThing.thingQuantity), price: item.price, vatgroup: item.vatgroup, cost: item.cost }, 'costTotalVat'),
                          beginValue: '',
                          endValue: '',
                          uuid: item.uuid,
                          workConfigList1: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList1) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList1)) : [],
                          workConfigList2: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList2) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList2)) : [],
                          workConfigList3: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList3) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList3)) : [],
                          workConfigList4: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList4) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList4)) : [],
                          ofrOwhThingList: JSON.parse(JSON.stringify(obj.ofrThingList[i].ofrOwhThingList))
                        })
                        break;
                      }

                    }
                  }

                  if(quantity < item.openqty) {
                    let index = thingsList.findIndex(val => val.uuid === item.uuid)
                    if(index < 0){

                      thingsList.push({
                        cbRestypeId: obj.ofrThingList[0].cbRestypeId,
                        // cbowhId: obj.ofrThingList[0].ofrOwhThingList &&  obj.ofrThingList[0].ofrOwhThingList.length ? ( obj.ofrThingList[0].ofrOwhThingList.find(val => val.thingQuantity) ||  obj.ofrThingList[0].ofrOwhThingList[0]).owhId : this.corCbowh(obj.ofrThingList[0].cbRestypeId, 'id'),
                        // cbowhName:  obj.ofrThingList[0].ofrOwhThingList &&  obj.ofrThingList[0].ofrOwhThingList.length ? ( obj.ofrThingList[0].ofrOwhThingList.find(val => val.thingQuantity) ||  obj.ofrThingList[0].ofrOwhThingList[0]).owhName : this.corCbowh(obj.ofrThingList[0].cbRestypeId,
                        // 'name'),
                        cbowhId: this.corCbowh(obj.ofrThingList[0], 'Thing', obj.ofrThingList[0].cbRestypeId, 'id'),
                        cbowhName: this.corCbowh(obj.ofrThingList[0], 'Thing', obj.ofrThingList[0].cbRestypeId, 'name'),
                        cbowhTo: '',
                        cbowhToName: '',
                        bzxs: item.bzxs,
                        bzdw: item.bzdw,
                        bzsl: item.bzsl,
                        ofrresourceId: item.ofrresourceId,
                        ofrresourceName: item.ofrresourceName,
                        ofrthingId: obj.ofrThingList[0].ofrThingId,
                        ofrthingName: obj.ofrThingList[0].name,
                        quantity: item.openqty,
                        price: item.price,
                        total: this.computeThingRelation({ quantity: item.openqty, price: item.price, vatgroup: item.vatgroup }, 'total'),
                        totalVat: this.computeThingRelation({ quantity: item.openqty, price: item.price, vatgroup: item.vatgroup }, 'totalVat'),
                        vatgroup: item.vatgroup,
                        invoicetype: item.invoicetype,
                        cost: item.cost,
                        // costTotal: item.costTotal,
                        // costTotalVat: item.costTotalVat,
                        costTotal: this.computeThingRelation({ quantity: item.openqty, price: item.price, vatgroup: item.vatgroup, cost: item.cost }, 'costTotal'),
                        costTotalVat: this.computeThingRelation({ quantity: item.openqty, price: item.price, vatgroup: item.vatgroup, cost: item.cost }, 'costTotalVat'),
                        beginValue: '',
                        endValue: '',
                        uuid: item.uuid,
                        workConfigList1: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList1) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList1)) : [],
                        workConfigList2: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList2) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList2)) : [],
                        workConfigList3: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList3) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList3)) : [],
                        workConfigList4: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList4) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList4)) : [],
                      })
                    }else{
                      thingsList[index].quantity = item.openqty - quantity + thingsList[index].quantity
                      thingsList[index].total = this.computeThingRelation({ quantity: thingsList[index].quantity, price: item.price, vatgroup: item.vatgroup }, 'total')
                      thingsList[index].totalVat = this.computeThingRelation({ quantity: thingsList[index].quantity, price: item.price, vatgroup: item.vatgroup }, 'totalVat')
                      thingsList[index].costTotal = this.computeThingRelation({ quantity: thingsList[index].quantity, price: item.price, vatgroup: item.vatgroup, cost: item.cost }, 'costTotal')
                      thingsList[index].costTotalVat = this.computeThingRelation({ quantity: thingsList[index].quantity, price: item.price, vatgroup: item.vatgroup, cost: item.cost }, 'costTotalVat')
                    }
                  }
                }
              }
            }
          }else {
            thingsList = []
          }

        })
        Promise.all(
          this.comfirmCopyFromList.map((item) => {
            return new Promise((resolve, reject) => {
              setTimeout(async () => {
                item.bomId = -1 - this.index
                item.stock = null
                this.index ++
                item.pid = null
                item.remark = this.isCheckRemark ? item.remark : ''
                if(this.ofoFlowWork.isCalcBom == '0') {
                  await this.$http.get(url.bomResource + item.ofrresourceId).then(res => {
                    let data = res.data.data.map(val => {
                      let uuid = this.generateUUIDWithoutDash()
                      return {
                        ...item,
                        ...val,
                        ofrresourceId: val.ofrResourceId,
                        ofrresourceName: val.name,
                        pid: val.pid === 0 ? item.bomId : (val.pid + '' + item.bomId),
                        bomId: val.bomId + '' + item.bomId,
                        bzsl: null,
                        bzdw: val.sjdw,
                        bzxs: val.sjxs,
                        quantity: val.quantity,
                        price: val.price,
                        oldQuantity: val.quantity,
                        total: '',
                        uuid: uuid,
                        workConfigList1: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList1) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList1)) : [],
                        workConfigList2: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList2) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList2)) : [],
                        workConfigList3: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList3) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList3)) : [],
                        workConfigList4: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList4) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList4)) : [],
                        baseOfoWorkId: '',
                        baseOfoWorkResourceId: ''
                      }
                    })
                    let tree = this.$handleTree(data, 'bomId', 'pid')
                    item.children = tree;
                  })
                }
                this.compute1(item)
                resolve( this.comfirmCopyFromList)
              },500)
            })
          })
        ).then((result) => {
          if(this.isSameRes) {
            this.comfirmCopyFromList = this.comfirmCopyFromList.filter(item => this.multipleList.find(val => val.ofrResourceId == item.ofrresourceId))
          }
          this.$emit('copyFromConfirm', {productsList: JSON.parse(JSON.stringify(this.comfirmCopyFromList)), obj, thingsList, isName: this.isName, isPart: this.isPart,isRemarks: this.isRemarks, isWorkDate: this.isWorkDate })
        })
      },
      // 多选
      selectMore(isEdit, row, index) {
        this.pid = 0
        this.multiplePageNum = 1
        this.cbRestypeId = "-1"
        this.cbussDimeTree = []
        // if(row.bomId < 0) {
        this.dialogTableVisible = true
        if(this.goods.length) {
          this.$refs.tableMultiple?.clearSelection()
        }
        this.goodsList = JSON.parse(JSON.stringify(this.multipleList))
        this.cbussDimeTree.forEach((item, index) => {
          item.value = ''
          this.$nextTick(() => {
            this.$refs['tree' + (index + 1)][0].setCurrentKey(null);
          })

        })
        if(isEdit) {
          this.isAddRes = false
          this.editResIndex = this.ofoFlowWork.isCalcBom == '0' ? this.productsList.findIndex(item => item.ofrresourceId == row.ofrresourceId) : index
          let resIndex = this.goodsList.findIndex(item => item.ofrResourceId == row.ofrresourceId)
          this.multiplePageNum = Math.floor(resIndex / this.multiplePageSize) + 1
          this.goodsList.forEach(item => {
            if(row.isMultiRes > 1) {
              this.isMultiRes = true
              row.ofrresourceId.split(',').forEach(val => {
                if(item.ofrResourceId == val) {
                  this.$nextTick(() => {
                    this.$refs.tableMultiple.toggleRowSelection(item, true)
                  })
                }
              })
            }else {
              this.isMultiRes = false
              if(item.ofrResourceId == row.ofrresourceId) {
                this.$nextTick(() => {
                  // this.cbRestypeId = item.cbRestypeId
                  // this.getCbussDimeListSearch()
                  this.$refs.tableMultiple.toggleRowSelection(item, true)
                })
              }

            }

          })
        }else {
          this.isAddRes = true
          this.multiplePageNum = 1
          // this.cbRestypeId = this.cbResourceTypeList[0].cbRestypeId
          // this.getCbussDimeListSearch()
        }
        // }
      },
      // 拿资源维度列表
      async getCbussDimeListSearch() {
        this.cbussDimeTree = []
        this.activeNames = []
        this.$http.get(url.getCbussDimeList, {params: {cbussId: this.cbRestypeId, dimetype: '1'}}).then(res => {
          if(res.data.code == 200) {
            let resDimeList = res.data.data.filter(item => item.isQuery == '0')
            resDimeList.forEach(item => {
              if(item.editType == '3' || item.editType == '6' || item.editType == '7') {
                item.children = JSON.parse(item.options).map(val => {
                  return {
                    label: val.optionLabel,
                    value: val.optionValue
                  }
                })
                item.label = item.dimeName
                this.cbussDimeTree.push(item)
              }
            })
            // if(this.cbussDimeTree.length === 0){
            //   this.$refs.querytree.style.width = 0
            // }
            this.cbussDimeTree.forEach((item, index) => {
              this.activeNames.push(index + 1)
            })
            // console.log(this.cbussDimeTree);
            // if(this.cbussDimeTree.length === 0){
            //   this.$nextTick(() => {
            //   // console.log(this.$refs.querytree);
            //     this.$refs.querytree.style.width = 0
            //   })
            // }else {

            //   this.$nextTick(() => {
            //   // console.log(this.$refs.querytree);
            //     this.$refs.querytree.style.width = '180px'
            //   })

            // }
          }
        })
      },
      async changeCbResourceType(e) {
        this.multiplePageNum = 1
        this.goodsList = []
        // this.search = null
        if(e && e != -1){
          await this.getCbussDimeListSearch()
        }else{
          this.cbussDimeTree = []
        }

        this.getResList()

      },
      getBomResource(item, obj) {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            let data = []
            this.$http.get(url.bomResource + item.ofrResourceId).then(res => {
              // console.log(data1);
              data = res.data.data.map(val => {
                return {
                  ...obj,
                  ...val,
                  ofrresourceId: val.ofrResourceId,
                  ofrresourceName: val.name,
                  bzsl: null,
                  bzdw: val.sjdw,
                  bzxs: val.sjxs,
                  pid: val.pid === 0 ? (-1 - this.productsList.length) : val.pid,
                  quantity: val.lossRate ? val.quantity * (1 + val.lossRate / 100) : val.quantity,
                  price: val.price,
                  oldQuantity: val.lossRate ? val.quantity * (1 + val.lossRate / 100) : val.quantity
                }
              })
              let tree = this.$handleTree(data, 'bomId', 'pid')
              obj.children = tree;
              this.productsList.push(obj)
            })
            resolve();
          }, 1000);
        });

      },
      // 对应位置
      corCbowh(list, type, cbRestypeId, key){
        if(this.ofoFlowWork.chooseOwh == '0' && this.cbOwhData.length) {
          let owhId = list[`ofrOwh${type}List`] && list[`ofrOwh${type}List`].length ? (list[`ofrOwh${type}List`].find(val => val[`${type.toLowerCase()}Quantity`]) || list[`ofrOwh${type}List`][0]).owhId : (this.cbOwhData.find(item => item.cbRestypeId == cbRestypeId) ? this.cbOwhData.find(item => item.cbRestypeId == cbRestypeId).cbOwhId : this.cbOwhData[0].cbOwhId)

          let owhName = list[`ofrOwh${type}List`] && list[`ofrOwh${type}List`].length ? (list[`ofrOwh${type}List`].find(val => val[`${type.toLowerCase()}Quantity`]) || list[`ofrOwh${type}List`][0]).owhName : (this.cbOwhData.find(item => item.cbRestypeId == cbRestypeId) ? this.cbOwhData.find(item => item.cbRestypeId == cbRestypeId).name : this.cbOwhData[0].name)

          let index = this.cbOwhData.findIndex(val => val.cbOwhId == owhId)

          if(index < 0) {
            return key == 'name' ? this.cbOwhData[0].name : this.cbOwhData[0].cbOwhId
          }else {
            return key == 'name' ? owhName : owhId
          }
          // let obj = this.cbOwhData.find(item => item.cbRestypeId == cbRestypeId) ? this.cbOwhData.find(item => item.cbRestypeId == cbRestypeId) : this.cbOwhData[0]
          // return key == 'name' ? obj.name : obj.cbOwhId
        }else {
          return ''
        }
      },
      // 确定多选
      async confirmMultiple() {
        console.log(JSON.parse(JSON.stringify(this.goods)));

        if(this.goods.length) {
          if(this.isAddRes) {
            if(!this.isRepeat) {
              let ids = this.productsList.map(item => item.ofrresourceId)
              this.goods = this.goods.filter(item => !ids.includes(item.ofrResourceId))
            }
            this.goods.forEach(async (item, index) => {
              if(!item.uuid){
                item.uuid = this.generateUUIDWithoutDash()
              }
              let currentCbResourceType = this.cbResourceTypeList.find(typeitem => typeitem.cbRestypeId === item.cbRestypeId)
              // 交易类型为销售 带入销售价 其他带入成本价
              let dealtype = this.ofoFlowDeal.dealtype
              console.log(this.ofoFlowDeal)
              let currentprice = (currentCbResourceType && currentCbResourceType.isShowPrice == '0' && this.isCheckPrice) ? (dealtype === '1' ? this.comdifyPrams(item.rprice) : this.comdifyPrams(item.cprice)) : ''
              // 税率
              let currentSlv = (this.ofoFlowDeal.dealtype === '1') ? this.params.xxs : (this.ofoFlowDeal.dealtype === '2' ? this.params.jxs : '')  // 1 销售 2 采购
              if(!currentSlv){
                currentSlv = this.dropDown.invoiceVat[0].dictValue
              }
              let vatgroup = (currentCbResourceType && currentCbResourceType.isShowPrice == '0' && this.isCheckPrice) ? (item.rslv ? item.rslv : currentSlv) : currentSlv
              // 生产和基础 税率为 0
              if(this.ofoFlowDeal.dealtype === '3' || this.ofoFlowDeal.dealtype === '4') {
                vatgroup = this.dropDown.invoiceVat[0].dictValue
              }
              let obj = {
                cbowhId: this.corCbowh(item, 'Resource', item.cbRestypeId, 'id'),
                cbowhName: this.corCbowh(item, 'Resource', item.cbRestypeId, 'name'),
                // cbowhId: item.ofrOwhResourceList && item.ofrOwhResourceList.length ? (item.ofrOwhResourceList.find(val => val.resourceQuantity) || item.ofrOwhResourceList[0]).owhId : this.corCbowh(item.cbRestypeId, 'id'),
                // cbowhName: item.ofrOwhResourceList && item.ofrOwhResourceList.length ? (item.ofrOwhResourceList.find(val => val.resourceQuantity) || item.ofrOwhResourceList[0]).owhName : this.corCbowh(item.cbRestypeId, 'name'),
                quantity: this.ofoFlowWork.costmanagetype == '4' ? 1 : (this.isCheckQuantity ? this.handleCalc(item.availableQuantityList) : ''),
                price: currentprice,
                total: '',
                vatgroup: vatgroup,
                totalVat: '',
                invoicetype: this.dropDown.invoiceType[0].dictValue,
                cost: '',
                costTotal: '',
                costTotalVat: '',
                beginValue: '',
                endValue: '',
                workConfigList1: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList1) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList1)) : [],
                workConfigList2: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList2) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList2)) : [],
                workConfigList3: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList3) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList3)) : [],
                workConfigList4: (this.ofoFlowWork.checkConfig && this.workConfig.workConfigList4) ? JSON.parse(JSON.stringify(this.workConfig.workConfigList4)) : [],
                bomId: -1 - this.index,
                stock: null,
                name: item.resourceName,
                rid: item.ofrResourceId,
                children: null,
                ofrresourceId: item.ofrResourceId,
                ofrresourceName: item.resourceName,
                pid: null,
                ggxh: item.ggxh,
                jldw: item.jldw,
                cbRestypeId: item.cbRestypeId,
                cbowhTo: '',
                cbowhToName: '',
                bzsl: null,
                bzdw: item.sjdw,
                bzxs: item.sjxs,
                uuid: item.uuid
              }
              if(this.ofoFlowWork.costmanagetype === '11'){
                if(obj.cbowhId && obj.cbowhId > 0){
                  var owhResource = item.ofrOwhResourceList?.find(item => item.owhId === obj.cbowhId);
                  obj.beginValue = owhResource?.resourceQuantity || 0
                  obj.price = owhResource?.cost || 0
                }else{
                  obj.beginValue = item.ofrOwhResourceList?.reduce((sum, item) => sum + item.resourceQuantity, 0) || 0;
                  obj.price = 0
                }
                this.handleCount1(obj)
              }
              this.index ++
              if(this.ofoFlowWork.costmanagetype == '9') {
                await this.$http.get(url.getOfrResource, {params: {ofrResourceId: item.ofrResourceId}}).then(res => {
                  obj.dimensionList = this.handleFormList(res.data.data.dimensionList)
                })
              }
              // console.log(JSON.parse(JSON.stringify(obj)));

              // console.log(this.ofoFlowWork.isCalcBom);
              if(this.ofoFlowWork.isCalcBom == '0') {
                const res = await this.$http.get(url.bomResource + item.ofrResourceId)
                // console.log(index);
                let data = res.data.data.map(val => {
                  return {
                    ...obj,
                    ...val,
                    ofrresourceId: val.ofrResourceId,
                    bzsl: null,
                    bzdw: val.sjdw,
                    bzxs: val.sjxs,
                    ofrresourceName: val.name,
                    pid: val.pid === 0 ? obj.bomId : (val.pid + '' + obj.bomId),
                    bomId: val.bomId + '' + obj.bomId,
                    stock: null,
                    quantity: val.lossRate ? val.quantity * (1 + val.lossRate / 100) : val.quantity,
                    price: this.comdifyPrams(val.price),
                    oldQuantity: val.lossRate ? val.quantity * (1 + val.lossRate / 100) : val.quantity
                  }
                })
                // console.log(JSON.parse(JSON.stringify(data)))
                let tree = this.$handleTree(data, 'bomId', 'pid')
                // obj.bomId = -1 - this.productsList.length - index

                // console.log(JSON.parse(JSON.stringify(tree)))
                obj.children = tree;
              }
              this.productsList.push(obj)
              // console.log(JSON.parse(JSON.stringify(this.productsList)))
            })
            // console.log(JSON.parse(JSON.stringify(this.productsList)));
            this.dialogTableVisible = false
          }else {
            if(this.goods.length != 1) {
              this.$message.error('请选择一个资源');
            }else {
              const uuid = this.productsList[this.editResIndex].uuid
              if (uuid && this.thingsList.find(item => item.uuid === uuid)){
                this.$message.error('有内容的资源无法更改！');
                return
              }

              this.productsList[this.editResIndex] = {
                ...this.productsList[this.editResIndex],
                ofrresourceId: this.goods[0].ofrResourceId,
                ofrResourceId: this.goods[0].ofrResourceId,
                ofrresourceName: this.goods[0].resourceName,
                rid: this.goods[0].ofrResourceId,
                name: this.goods[0].resourceName,
                ggxh: this.goods[0].ggxh,
                jldw: this.goods[0].jldw,
                children: null,
                pid: null,
                isMultiRes: 1
              }
              if(this.ofoFlowWork.isCalcBom == '0') {
                const res = await this.$http.get(url.bomResource + this.goods[0].ofrResourceId)
                // console.log(index);
                let data = res.data.data.map(val => {
                  return {
                    ...this.productsList[this.editResIndex],
                    ...val,
                    ofrresourceId: val.ofrResourceId,
                    bzsl: null,
                    bzdw: val.sjdw,
                    bzxs: val.sjxs,
                    ofrresourceName: val.name,
                    pid: val.pid === 0 ? this.productsList[this.editResIndex].bomId : val.pid,
                    quantity: val.quantity,
                    price: val.price,
                    oldQuantity: val.quantity
                  }
                })
                let tree = this.$handleTree(data, 'bomId', 'pid')
                // obj.bomId = -1 - this.productsList.length - index
                this.productsList[this.editResIndex].children = tree;
              }
              this.$set(this.productsList, this.editResIndex, this.productsList[this.editResIndex])
              this.dialogTableVisible = false
              // this.productsList[this.editResIndex].isMultiRes = 1
            }

          }
        }else {
          this.$message.warning('请选择资源行');
        }
      },
      // 删除已选
      async deleteMore() {
          this.selectedId.forEach(async row => {
            await this.handleDelete(row)
          })
          this.selectedIdThing.forEach(row => {
            if(row.uuid){
              this.thingsList.splice(this.thingsList.findIndex(item => item.uuid === row.uuid && item.ofrthingId == row.ofrthingId), 1)
            }else{
              this.thingsList.splice(this.thingsList.findIndex(item => item.ofrthingId == row.ofrthingId), 1)
            }
          })
      },
      // 减行
      handleDelete(row, index) {
        if(row.bomId < 0) {
          this.productsList.splice(this.productsList.findIndex(item => item.bomId == row.bomId), 1)
        }else if(row.bomId == null) {
          this.productsList.splice(this.productsList.findIndex(item => item.ofoWorkResourceId == row.ofoWorkResourceId), 1)
        }else {
          this.deleteChildren(this.productsList.find(item => (item.rid == row.rid || item.ofrresourceId == row.rid) && item.bomId == String(row.pid).substring(String(row.pid).lastIndexOf('-'))).children, row.bomId)
        }
        if(row.uuid){
          const newList = this.thingsList.filter(item => item.uuid !== row.uuid)
          this.thingsList.length = 0
          if (newList && newList.length > 0){
            this.thingsList.push(...newList)
          }else{
            this.thingsList = []
          }
        }else{
          let id1 = []
          this.thingsList.forEach((el, id) => {
            if(el.ofrresourceId == row.ofrresourceId) {
              id1.push(id)
            }
          })
          id1.sort((a, b) => b - a)
          // console.log(id1.sort((a, b) => b - a));
          id1.forEach(item => {
            this.thingsList.splice(item, 1)
          })
        }
      },
      handleDeleteThing(row, index) {
        if (row.uuid) {
          this.removeThingByIndex(index, row.uuid)
        }else {
          this.thingsList.splice(this.thingsList.findIndex(item.ofrthingId == row.ofrthingId), 1)
        }
      },
      removeThingByIndex (index, uuid) {
        let count = 0
        let targetIndex = -1

        // 找到第 index 个 b===2 的数据在原数组中的位置
        for (let i = 0; i < this.thingsList.length; i++) {
          if (this.thingsList[i].uuid === uuid) {
            if (count === index) {
              targetIndex = i
              break
            }
            count++
          }
        }

        // 删除该数据
        if (targetIndex !== -1) {
          this.thingsList.splice(targetIndex, 1)
        }
      },
      deleteChildren(treeList, bomId) {
        // console.log('--------------------');

        // console.log(treeList);
        // console.log(bomId);

        if (!treeList || !treeList.length) {
          return
        }
        for (let i = 0; i < treeList.length; i++) {
          if (treeList[i].bomId === bomId) {
            treeList.splice(i, 1);
            break;
          }
          this.deleteChildren(treeList[i].children, bomId)
        }
      },
      handleRowSelect(row, column, event) {
        this.$refs.multipleTable.toggleRowSelection(row);
      },
      // 表格的选中框事件
      handleRowChange(rows) {
        // console.log(JSON.parse(JSON.stringify(rows)));
        this.selectedId = JSON.parse(JSON.stringify(rows))
        // console.log(this.productsList);
        // if(rows.length) {
        //   let selectedId = []
        //   rows.forEach(item => {
        //     selectedId.push(item.index)
        //   })
        //   this.selectedId = selectedId
        // }else {
        //   this.selectedId = []
        // }
        // console.log(this.selectedId);
      },
      // 表格的选中框事件
      handleRowChangeThing(rows) {
        this.selectedIdThing = JSON.parse(JSON.stringify(rows))
      },
      getRowKeyMultiple(row) {
        return row.ofrResourceId
      },
      // 表格的选中框事件
      handleMultipleSelectionChange(rows) {
        if(this.isAddRes || this.isMultiRes) {
          this.goods = rows
        }else {
          if(rows.length >= 2) {
            this.$refs.tableMultiple.toggleRowSelection(rows[0], false);
            this.goods = [rows[1]]
          }else {
            this.isMultiRes = false
            this.goods = rows
          }
        }
      },
      //点击行触发，选中或不选中复选框
      handleMultipleRowClick(row, column, event) {
        this.$refs.tableMultiple.toggleRowSelection(row);
        // console.log("this.selecTestContent", this.selectTestContent);
      },
      // 计算税额
      computeTax(row) {
        if(this.isTax) {
          // 税额
          row.totalVat = this.comdify(this.delComdify(row.total) / (1 + Number(row.vatgroup)) * row.vatgroup)
        }else {
          row.totalVat = this.comdify(this.delComdify(row.total) * row.vatgroup)
        }
      },
      // 计算成本税额
      computeCostTax(row) {
        if(this.isTax) {
          // 税额
          row.costTotalVat = this.comdify(this.delComdify(row.costTotal) / (1 + Number(row.vatgroup)) * row.vatgroup)
        }else {
          row.costTotalVat = this.comdify(this.delComdify(row.costTotal) * row.vatgroup)
        }
      },
      // 添加千分位
      comdify(n) {
        if(n == 0)return 0;
        if(!n) return '';
        n = Number(n).toFixed(2)
        let res01 = n.split(".")[0];
        let res02 = n.split(".")[1];
        return `${res01}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + `.${res02}`;
      },
      // 添加千分位
      comdifyPrams(n) {
        if(n == 0) return 0;
        if(!n) return '';
        n = Number(n).toFixed(this.params.priceAccuracy)
        // console.log(n);
        let res01 = n.split(".")[0];
        let res02 = n.split(".")[1];
        // console.log(`${res01}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + `.${res02}`);
        return `${res01}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + `.${res02}`;
      },
      // 添加千分位
      comdifyPrams1(n) {
        if(!n) return '';
        n = Number(n).toFixed(this.params.quantityAccuracy)
        // console.log(n);
        let res01 = n.split(".")[0];
        let res02 = n.split(".")[1];
        // console.log(`${res01}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + `.${res02}`);
        return `${res01}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + `.${res02}`;
      },
      // 去掉千分位
      delComdify(n) {
        if(n == 0) return 0;
        if(!n) return '';
        let numS = n;
        numS = numS.toString();
        numS = numS.replace(/,/gi, '');
        return numS;
      },
      // 处理只能输入数字
      handlePrice(n) {
        return n.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3')
      },
      // 处理只能输入数字
      handlePriceParams(n) {
        return n.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(new RegExp('^(\\-)*(\\d+)\\.(\\d{'+this.params.priceAccuracy+'}).*$'), '$1$2.$3')
      },
      // 处理计算符
      handleCalcu(calcu) {
        if(calcu == '1') {
          return '+'
        }else if(calcu == '2') {
          return '-'
        }else if(calcu == '3') {
          return '*'
        }else if(calcu == '4') {
          return '/'
        }else {
          return ''
        }
      },
      submitConfigValue(item, index, prop) {
        this.$nextTick(() => {
          this.$refs[`popover${item.ofoFlowWorkConfigId}`][1].showPopper = false
        })
        this.productsList.forEach(val => {
          val[prop][index].configValue = this.configValue
          if(prop != 'workConfigList4') {
            this.computeSl(val, index, prop)
          }
        })
      },
      // 输入数量
      computeSl(row, index, prop) {
        if(prop == 'workConfigList1' && index) {
          row.workConfigList1[index].configValue = row.workConfigList1[index].configValue.replace(/[^\d.\-]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(new RegExp('^(\\-)*(\\d+)\\.(\\d{'+this.params.quantityAccuracy+'}).*$'), '$1$2.$3')
        }
        // console.log(JSON.parse(JSON.stringify(row[prop])));
        let length = row[prop].length
        if(length > 1) {
          let arr = []
          for(let i = 0; i < (length - 1); i++) {
            // if(row[prop][i].showType != '2') {
              arr.push(row[prop][i].brackets && row[prop][i].brackets.includes('(') ? row[prop][i].brackets : '', row[prop][i].configValue ? (row[prop][i].showType == '1' ? (row[prop][i].configValue / 100) : row[prop][i].configValue) : 0, row[prop][i].brackets && row[prop][i].brackets.includes(')') ? row[prop][i].brackets : '', this.handleCalcu(row[prop][i].calcu))
            // }
          }
          // if(row[prop][length - 1].showType != '2') {
            arr.push(row[prop][length - 1].brackets && row[prop][length - 1].brackets.includes('(') ? row[prop][length - 1].brackets : '', row[prop][length - 1].configValue ? (row[prop][length - 1].showType == '1' ? (row[prop][length - 1].configValue / 100) : row[prop][length - 1].configValue) : 0, row[prop][length - 1].brackets && row[prop][length - 1].brackets.includes(')') ? row[prop][length - 1].brackets : '')
          // }
          // console.log(arr.join(''));
          let total = eval(arr.join('')).toFixed(4)
          if(prop == 'workConfigList1') {
            row.quantity = total
            if(row.price || row.total) {
              if(!row.price) {
                row.price = this.comdifyPrams(this.delComdify(row.total) / row.quantity)
              }else {
                // 金额
                row.total = this.comdify(row.quantity * this.delComdify(row.price))
                this.computeTax(row)
              }
            }
            if(row.cost || row.total) {
              if(!row.cost) {
                row.cost = this.comdifyPrams(this.delComdify(row.costTotal) / row.quantity)
              }else {
                // 金额
                row.costTotal = this.comdify(row.quantity * this.delComdify(row.cost))
                this.computeCostTax(row)
              }
            }
          }else if(prop == 'workConfigList2') {
            row.price = total
            if(row.quantity || row.total) {
              if(!row.quantity) {
                row.quantity = (this.delComdify(row.total) / row.price).toFixed(this.params.quantityAccuracy)
              }else {
                // 金额
                row.total = this.comdify(row.quantity * row.price)
                this.computeTax(row)
              }
            }
          }else {
            row.total = total
            if(row.quantity || row.price) {
              if(row.quantity) {
                row.price = this.comdifyPrams(row.total / row.quantity)
              }else {
                row.quantity = (row.total / this.delComdify(row.price)).toFixed(this.params.quantityAccuracy)
              }
            }
            this.computeTax(row)
          }
        }
      },
      changeChildrenQuantity(row, quantity) {
        row.children.forEach(item => {
          if (!item.oldQuantity){
            item.oldQuantity = item.quantity
          }
          item.quantity = (item.oldQuantity * quantity) ? String(item.oldQuantity * quantity) : item.quantity
          this.compute1(item)
          if(item.children) {
            this.changeChildrenQuantity(item, quantity)
          }
        })
      },
      // 输入数量
      compute1(row) {
        row.quantityChange = row.quantityFocus
        row.quantity = String(row.quantity).replace(/[^\d.\-]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(new RegExp('^(\\-)*(\\d+)\\.(\\d{'+this.params.quantityAccuracy+'}).*$'), '$1$2.$3')
        if(!row.quantity) {
          row.total = ''
          row.totalVat = ''
          row.costTotal = ''
          row.costTotalVat = ''
          row.bzsl = ''
        }else {
          if(row.bomId < 0 && row.children) {
            this.changeChildrenQuantity(row, row.quantity)
          }
          if(row.price || row.total) {
            if(!row.price) {
              row.price = this.comdifyPrams(this.delComdify(row.total) / row.quantity)
            }else {
              // 金额
              row.total = this.comdify(row.quantity * this.delComdify(row.price))
              this.computeTax(row)
            }
          }
          if(row.cost || row.total) {
            if(!row.cost) {
              row.cost = this.comdifyPrams(this.delComdify(row.costTotal) / row.quantity)
            }else {
              // 金额
              row.costTotal = this.comdify(row.quantity * this.delComdify(row.cost))
              this.computeCostTax(row)
            }
          }
          if(row.bzxs){
            row.bzsl = (row.quantity / row.bzxs).toFixed(this.params.quantityAccuracy)
          }
        }
      },
      // 计算内容的total 和 cost相关
      computeThingRelation (obj, type) {
        if(!type) return ''
        const { quantity, price, vatgroup, cost } = obj
        // 计算总金额
        if(type === 'total') {
            return (quantity * price).toFixed(2)
        }
        const tempvat = vatgroup ? Number(vatgroup) : 0
        // 总税额
        if(type === 'totalVat') {
          return (quantity * price * tempvat / (1 + tempvat)).toFixed(2)
        }
        if(!cost) return ''
        //计算合计成本
        if(type === 'costTotal') {
          return (quantity * cost).toFixed(2)
        }
        // 合计成本税额
        if(type === 'costTotalVat') {
          return (quantity * cost * tempvat / (1 + tempvat)).toFixed(2)
        }
        return ''
      },
      handleBzxsInput(row){
        const quantity = String(row.quantity).replace(/[^\d.\-]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(new RegExp('^(\\-)*(\\d+)\\.(\\d{'+this.params.quantityAccuracy+'}).*$'), '$1$2.$3')
        if(quantity && row.bzxs){
          row.bzsl = (quantity / row.bzxs).toFixed(this.params.quantityAccuracy)
        }else{
          row.bzsl = ''
        }
      },
      handleBzslInput(row){
        // const quantity = String(row.quantity).replace(/[^\d.\-]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(new RegExp('^(\\-)*(\\d+)\\.(\\d{'+this.params.quantityAccuracy+'}).*$'), '$1$2.$3')
        if(row.bzsl && row.bzxs){
          row.quantity = (row.bzsl * row.bzxs).toFixed(this.params.quantityAccuracy)
        }else{
          row.quantity = ''
        }
      },
      // 输入单价
      compute2(row) {
        // console.log(el);
        row.price = this.handlePriceParams(row.price)
        // row.price = this.comdify(row.price)
        if(!row.price) {
          row.total = ''
          row.totalVat = ''
        }else {
          if(row.quantity || row.total) {
            if(!row.quantity) {
              row.quantity = (this.delComdify(row.total) / row.price).toFixed(this.params.quantityAccuracy)
            }else {
              // 金额
              row.total = this.comdify(row.quantity * row.price)
              this.computeTax(row)
            }
          }
        }
      },
      compute22(row) {
        row.price = this.comdifyPrams(row.price)
      },
      compute222(row) {
        row.price = this.delComdify(row.price)
      },
      // 输入金额
      compute3(row) {
        row.total = this.handlePrice(row.total)
        if(!row.total) {
          row.price = ''
          row.totalVat = ''
        }else {
          if(row.quantity || row.price) {
            if(row.quantity) {
              row.price = this.comdifyPrams(row.total / row.quantity)
            }else {
              row.quantity = (row.total / this.delComdify(row.price)).toFixed(this.params.quantityAccuracy)
            }
          }
          this.computeTax(row)
        }
      },
      compute33(row) {
        row.total = this.comdify(row.total)
      },
      compute333(row) {
        row.total = this.delComdify(row.total)
      },
      // 输入税率
      compute4(row) {
        if(!row.total) {
          row.total = this.comdify(row.quantity * this.delComdify(row.price))
        }
        if(!row.costTotal) {
          row.costTotal = this.comdify(row.quantity * this.delComdify(row.cost))
        }
        this.computeTax(row)
        this.computeCostTax(row)
      },
      // 输入成本单价
      compute5(row) {
        row.cost = this.handlePriceParams(row.cost)
        if(!row.cost) {
          row.costTotal = ''
          row.totalVat = ''
        }else {
          if(row.quantity || row.costTotal) {
            if(!row.quantity) {
              row.quantity = (this.delComdify(row.costTotal) / row.cost).toFixed(this.params.quantityAccuracy)
            }else {
              // 金额
              row.costTotal = this.comdify(row.quantity * row.cost)
              this.computeCostTax(row)
            }
          }
        }
      },
      compute55(row) {
        row.cost = this.comdifyPrams(row.cost)
      },
      compute555(row) {
        row.cost = this.delComdify(row.cost)
      },
      // 输入成本金额
      compute6(row) {
        row.costTotal = this.handlePrice(row.costTotal)
        if(!row.costTotal) {
          row.cost = ''
          row.costTotalVat = ''
        }else {
          if(row.quantity || row.cost) {
            if(row.quantity) {
              row.cost = this.comdifyPrams(row.costTotal / row.quantity)
            }else {
              row.quantity = (row.costTotal / this.delComdify(row.cost)).toFixed(this.params.quantityAccuracy)
            }
          }
          this.computeCostTax(row)
        }
      },
      compute66(row) {
        row.costTotal = this.comdify(row.costTotal)
      },
      compute666(row) {
        row.costTotal = this.delComdify(row.costTotal)
      },
      // 计算时间
      handleChangeSj1(row) {
        if (this.ofoFlowWork.costmanagetype === '10') {
          return
        }
        this.startDate = new Date(row.beginValue)
        // console.log(this.startDate);
        if(row.endValue) {
          this.endDate = new Date(row.endValue)
          row.quantity = this.endDate - this.startDate
          // console.log(this.endDate - this.startDate);
        }
      },
      handleChangeSj2(row) {
        console.log('handleChangeSj2')
        if (this.ofoFlowWork.costmanagetype === '10') {
          return
        }
        this.endDate = new Date(row.endValue)
        // console.log(this.endDate);
        if(row.beginValue) {
          this.startDate = new Date(row.beginValue)
          row.quantity = this.endDate - this.startDate

        }
      },
      // 计算数量
      handleCount1(row) {
        // this.startCount = row.beginValue
        if((row.endValue || row.endValue == 0) && (row.beginValue || row.beginValue == 0)) {
          row.quantity = row.endValue - row.beginValue
        }else{
          row.quantity = null
        }
        if(this.ofoFlowWork.costmanagetype === '11'){
          row.total = ((row.quantity || 0) * row.price).toFixed(2)
          row.cost = row.price
          row.costTotal = row.total
        }
      },
      handleCount2(row) {
        // this.endCount = row.endValue
        if((row.endValue || row.endValue == 0) && (row.beginValue || row.beginValue == 0)) {
          row.quantity = row.endValue - row.beginValue
        }else{
          row.quantity = null
        }
        if(this.ofoFlowWork.costmanagetype === '11'){
          row.total = ((row.quantity || 0) * row.price).toFixed(2)
          row.cost = row.price
          row.costTotal = row.total
        }
      },
      // 获取表格下拉列表
      async getList() {
        // 如果活动不是对象管理，获取仓库以及服务名称
        // if((this.documentstatus == '0' || this.documentstatus == '1' || this.documentstatus == '1') && this.flag) {
        // if(this.flag) {
        //   this.flag = false
        // 获取bom资源列表
        if(this.ofoFlowWork.isCalcBom == '0') {
          this.resTreeList = []
          this.$http.get(url.resTypeResource + '?kind=2').then(res => {
            // console.log(res);
            if(res.data.code == 200) {
              res.data.data.filter(item => item.resourceList).forEach(item => {
                item.resourceList.forEach((val, index) => {
                  this.resTreeList.push({
                    restypeName: item.name,
                    ...val,
                  })
                })
              })

              // this.resList = JSON.parse(JSON.stringify(this.resTreeList))

              // this.pageinfo.total = this.resTreeList.length
            }
          })
        }
          if(this.ofoFlowWork.kindtype && this.ofoFlowWork.workkindmanagetype != '0') {
            // 获取仓库列表
            if(this.ofoFlowWork.chooseOwh == '0') {
              await this.$http.get(url.getCbOwhByCbResType, {params: {cbRestypeIds: this.ofoFlowWork.kindtype}}).then(res => {
                if(res.data.code == 200) {
                  this.cbOwhData = res.data.data
                  this.cbOwhData1 = handleTree(res.data.data, 'cbOwhId', 'pid')
                }
              })
            }
            // // 获取货物或应税劳务、服务名称列表
            // this.$http.get(url.getResTypeAndList, {params: {cbRestypeId: this.ofoFlowWork.kindtype}}).then(res => {
            //   this.cbResourceType = res.data.data.cbResourceType
            //   this.goodsList = res.data.data.list
            // })


            // 获取货物或应税劳务、服务名称列表
            this.$http.get(url.getResTypesAndList1 + this.ofoFlowWork.ofoFlowWorkId, {params: {cbRestypeIds: this.ofoFlowWork.kindtype}}).then(res => {
              if(res.data.code == 200) {
                this.cbResourceTypeList = res.data.data.cbResourceTypeList
                this.isCheckPrice = (this.cbResourceTypeList.length == 1 && this.cbResourceTypeList[0].isShowPrice == '0') ? true : false
                this.goodsList = res.data.data.list
                this.goodsList.forEach(item => {
                  item.name = item.resourceName.split(':')[0]
                })
                this.multipleList = JSON.parse(JSON.stringify(this.goodsList))
                this.isAdd = res.data.data.isAdd
                this.ofrThingsList = []
                this.goodsList.forEach(item => {
                  item.ofrThingList.forEach(el => {
                    let obj = el
                    for(let key in item) {
                      if(key == 'ofrThingList') {
                      }else if(key == 'name') {
                        obj[key] = el[key]
                      }else {
                        obj[key] = item[key]
                      }
                    }
                    this.ofrThingsList.push(obj)
                  })
                })
                if(!this.disabled && (this.cbResourceTypeList.find(arr => arr.kind == '1'))) {
                  let index = this.ofrThingsList.findIndex(val => val.ofrThingId == JSON.parse(sessionStorage.getItem('loginUser')).bussId)
                  this.goods2.push(this.ofrThingsList[index])
                  this.isAddRes = true
                  this.confirm()
                }
              }
            })
            if(!this.ofoFlowWork.kindtype.includes(',')) {
              this.$http.get(url.getCbussDimeList, {params: {cbussId: this.ofoFlowWork.kindtype, dimetype: '1'}}).then(res => {
                if(res.data.code == 200) {
                  let resDimeList = res.data.data.filter(item => item.isQuery == '0')
                  this.resDimeList = res.data.data
                  resDimeList.forEach(item => {
                    if(item.editType == '3' || item.editType == '6' || item.editType == '7') {
                      item.children = JSON.parse(item.options).map(val => {
                        return {
                          label: val.optionLabel,
                          value: val.optionValue
                        }
                      })
                      item.label = item.dimeName
                      this.cbussDimeTree.push(item)
                    }
                  })
                  // if(this.cbussDimeTree.length === 0){
                  //   this.$refs.querytree.style.width = 0
                  // }
                  this.cbussDimeTree.forEach((item, index) => {
                    this.activeNames.push(index + 1)
                  })
                  // console.log(this.cbussDimeTree);
                  // if(this.cbussDimeTree.length === 0){
                  //   this.$nextTick(() => {
                  //   // console.log(this.$refs.querytree);
                  //     this.$refs.querytree.style.width = 0
                  //   })
                  // }else {

                  //   this.$nextTick(() => {
                  //   // console.log(this.$refs.querytree);
                  //     this.$refs.querytree.style.width = '180px'
                  //   })

                  // }
                }
              })
            }
          }
        // }
        // 设置税率
        if(!this.dropDown.invoiceVat) {
          this.$http.get(url.getDataList, {params: {type: 'buss_invoice_vat'}}).then(res => {
            // console.log(res);
            // this.invoiceVat = res.data.data
            this.$store.commit('setInvoiceVat', res.data.data)
          })
        }
        // 设置发票类型
        if(!this.dropDown.invoiceType) {
          this.$http.get(url.getDataList, {params: {type: 'buss_invoice_type'}}).then(res => {
            // console.log(res);
            // this.invoiceVat = res.data.data
            this.$store.commit('setInvoiceType', res.data.data)
          })
        }
      },
      getOneArr (data) {
        let newData = []
        const callback = (item) => {
          newData.push(item);
          (item.children || (item.children = [])).map(v => {
            callback(v)
          })
          delete item.children
        }
        data.map(v => callback(v))
        return newData
      },
      judgeButton () {
        return this.btnMenu.some(item => item.perms === `${this.transferKind(this.historyResData.kind)}:edit`)
      },
      // 编辑资源
      editResource(id) {
        if (this.$refs.editRuleFormRes) {
          this.$nextTick(() => {
            // 清除表单校验效果
            this.$refs.editRuleFormRes.clearValidate()
          })
        }
        this.resData = {}
        this.editFormList = {}
        this.editFormList = []
        this.editResourceDialog = true
        this.$http.get(url.getOfrResource, { params: { ofrResourceId: id } }).then(res => {
          console.log(res.data.data);
          const data = res.data.data.ofrResource
          for (const key in data) {
            this.$set(this.editRuleFormRes, key, data[key])
          }
          this.resData = this.historyResData
          this.editFormList = this.handleFormList(res.data.data.dimensionList)
          this.editRuleFormRes.dataSourceConfig = this.editFormList
        })
      },
      editThing(id){
        if(this.$refs.contentRuleFormRef) {
          this.$nextTick(() => {
            // 清除表单校验效果
            this.$refs.contentRuleFormRef.clearValidate();
          })
        }
        this.$http.get(url.getOfrResourceList, {params: {
          cbRestypeId: this.historyResData.cbRestypeId,
          pageNum: 1,
          pageSize: 1000
        }}).then(res => {
          if(res.data.code == 200) {
            this.postList = res.data.data.list
          }
        })
        this.contentDialogFormVisible = true
        this.$http.get(url.getOfrThing, {params: {ofrThingId: id}}).then(res => {
          if(res.data.code === 200) {
            this.contentRuleForm = res.data.data.ofrThing
            this.contentFormList = res.data.data.dimensionList
            this.contentRuleForm.dataSourceConfig = this.contentFormList
          }
        })
      },
      submitContentForm(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isLoading = true
            let dimes = []
            if(this.contentFormList.length != 0) {
              dimes = this.handleDimes(this.contentFormList)
            }

            this.$http.post(url.editOfrThing, qs.stringify({...this.contentRuleForm, dimes: JSON.stringify(dimes)})).then(res => {
                this.isLoading = false
                if(res.data.code === 200) {
                  this.$message.success(res.data.msg)
                  this.contentDialogFormVisible = false
                  this.handleThingView({ ofrthingId: this.contentRuleForm.ofrThingId, ofrresourceId: this.contentRuleForm.ofrResourceId }, true)
                }
              })
          } else {
            return false;
          }
        });
      },
      // 更新表格里的内容描述
      handleThingTableNames(id, remarks) {
        this.thingsList.filter(item => item.ofrthingId === id)?.forEach(item => {
          item.ofrthingName = remarks
        })
      },
      // 提交修改资源
      submitResEditForm(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const dimes = this.handleDimes(this.editFormList)
            delete this.editRuleFormRes.dataSourceConfig
            this.$http.post(url.editOfrResource, qs.stringify({
              ...this.editRuleFormRes,
              documentstatus: this.editRuleFormRes.documentstatus ? this.editRuleFormRes.documentstatus : '1',
              dimes: JSON.stringify(dimes)
            })).then(res => {
              if (res.data.code === 200) {
                this.$message.success(res.data.msg)
                this.editResourceDialog = false
                this.handleResourceView({ofrresourceId: this.editRuleFormRes.ofrResourceId})
              }
            })
          } else {
            return false
          }
        })
      },
      /** 查看内容
       * @param row
       * @param isChange 是否修改后查看的*
       */
      handleThingView (row, isChange) {
        console.log(row)
        this.contentVisible = true
        this.$http.get(url.getOfrResource, {params: {ofrResourceId: row.ofrresourceId,needOfOwhData:false}}).then(res => {
          this.historyResData = res.data.data.cbResourceType
        })
        this.$http.get(url.getOfrThing, {params: {ofrThingId: row.ofrthingId}}).then(res => {
          if(res.data.code === 200) {
            // console.log(res.data);
            this.contentRuleForm = res.data.data.ofrThing
            this.contentFormList = res.data.data.dimensionList
            this.contentRuleForm.dataSourceConfig = this.contentFormList
            if(isChange) {
              this.handleThingTableNames(row.ofrthingId, this.contentRuleForm.remarks)
            }
          }
        })
      }
    },
    computed: {
      //当前页数据
      currentPageData() {
        // console.log("currentPageData")
        const start = (this.multiplePageNum - 1) * this.multiplePageSize;
        const end = this.multiplePageNum * this.multiplePageSize;
        return this.goodsList.slice(start, end);
      },
      ...mapState({
        dropDown: state => state.dropDown.dropDown
      }),
      // 未核销金额
      waitCheckTotal1() {
        return this.handleSelectionList1.reduce((sum, e) => sum + Number((e.checkType == '3' ? (-e.openTotal) : e.openTotal) || 0), 0).toFixed(2)
      },
      // 未核销金额
      waitCheckTotal2() {
        return this.handleSelectionList2.reduce((sum, e) => sum + Number(e.openTotal || 0), 0).toFixed(2)
      },
      // 剩余金额
      remainCheckTotal() {
        return eval(this.controlTotal1.join("+")) - this.handleSelectionList1.reduce((sum, e) => sum + Number(e.openTotal || 0), 0).toFixed(2)
      },
      // 本次付款金额
      payTotal() {
        return (this.waitCheckTotal1 - this.waitCheckTotal2).toFixed(2)
      },
      // 税额合计
      ptotalVat() {
        if(this.ofoFlowWork.kindtype && this.ofoFlowWork.workkindmanagetype != '0') {
          let total = 0
          let data = JSON.parse(JSON.stringify(this.productsList))
          const flattenedArray = this.getOneArr(data);
          flattenedArray.forEach(item => {
            total += Number(this.delComdify(item.totalVat))
          })
          return total.toFixed(2)
        }
      },
      // 成本税额合计
      ctotalVat() {
        if(this.ofoFlowWork.kindtype && this.ofoFlowWork.workkindmanagetype != '0') {
          let costTotal = 0
          let data = JSON.parse(JSON.stringify(this.productsList))
          const flattenedArray = this.getOneArr(data);
          flattenedArray.forEach(item => {
            costTotal += Number(this.delComdify(item.costTotalVat))
          })
          return costTotal.toFixed(2)
        }
      },
      // 金额合计
      ptotalNovat() {
        if(this.ofoFlowWork.kindtype && this.ofoFlowWork.workkindmanagetype != '0') {
          let total = 0
          let data = JSON.parse(JSON.stringify(this.productsList))
          const flattenedArray = this.getOneArr(data);
          if(this.isTax) {
            flattenedArray.forEach(item => {
              total = total + Number(this.delComdify(item.total)) - Number(this.delComdify(item.totalVat))
            })
          }else {
            flattenedArray.forEach(item => {
              total += Number(this.delComdify(item.total))
            })
          }
          return total.toFixed(2)
        }
      },
      // 成本金额合计
      ctotalNovat() {
        if(this.ofoFlowWork.kindtype && this.ofoFlowWork.workkindmanagetype != '0') {
          let costTotal = 0
          let data = JSON.parse(JSON.stringify(this.productsList))
          const flattenedArray = this.getOneArr(data);
          if(this.isTax) {
            flattenedArray.forEach(item => {
              costTotal = costTotal + Number(this.delComdify(item.costTotal)) - Number(this.delComdify(item.costTotalVat))
            })
          }else {
            flattenedArray.forEach(item => {
              costTotal += Number(this.delComdify(item.costTotal))
            })
          }
          return costTotal.toFixed(2)
        }
      },
      // 价税合计
      ptotal() {
        if(this.ofoFlowWork.kindtype && this.ofoFlowWork.workkindmanagetype != '0') {
          let total = 0
          let data = JSON.parse(JSON.stringify(this.productsList))
          const flattenedArray = this.getOneArr(data);
          if(this.isTax) {
            flattenedArray.forEach(item => {
              total = total + Number(this.delComdify(item.total))
            })
          }else {
            flattenedArray.forEach(item => {
              total = total + Number(this.delComdify(item.total)) + Number(this.delComdify(item.totalVat))
            })
          }
          return total.toFixed(2)
        }
      },
      // 成本价税合计
      ctotal() {
        if(this.ofoFlowWork.kindtype && this.ofoFlowWork.workkindmanagetype != '0') {
          let costTotal = 0
          let data = JSON.parse(JSON.stringify(this.productsList))
          const flattenedArray = this.getOneArr(data);
          if(this.isTax) {
            flattenedArray.forEach(item => {
              costTotal = costTotal + Number(this.delComdify(item.costTotal))
            })
          }else {
            flattenedArray.forEach(item => {
              costTotal = costTotal + Number(this.delComdify(item.costTotal)) + Number(this.delComdify(item.costTotalVat))
            })
          }
          return costTotal.toFixed(2)
        }
      },
      // 税额合计
      ptotalVat2() {
        if(this.ofoFlowWork.thingtype && this.ofoFlowWork.workkindmanagetype != '0') {
          let total = 0
          this.thingsList.forEach(item => {
            total += Number(this.delComdify(item.totalVat))
          })
          return total.toFixed(2)
        }
      },
      // 成本税额合计
      ctotalVat2() {
        if(this.ofoFlowWork.thingtype && this.ofoFlowWork.workkindmanagetype != '0') {
          let costTotal = 0
          this.thingsList.forEach(item => {
            costTotal += Number(this.delComdify(item.costTotalVat))
          })
          return costTotal.toFixed(2)
        }
      },
      // 金额合计
      ptotalNovat2() {
        if(this.ofoFlowWork.thingtype && this.ofoFlowWork.workkindmanagetype != '0') {
          let total = 0
          if(this.isTax) {
            this.thingsList.forEach(item => {
              total = total + Number(this.delComdify(item.total)) - Number(this.delComdify(item.totalVat))
            })
          }else {
            this.thingsList.forEach(item => {
              total += Number(this.delComdify(item.total))
            })
          }
          return total.toFixed(2)
        }
      },
      // 成本金额合计
      ctotalNovat2() {
        if(this.ofoFlowWork.thingtype && this.ofoFlowWork.workkindmanagetype != '0') {
          let costTotal = 0
          if(this.isTax) {
            this.thingsList.forEach(item => {
              costTotal = costTotal + Number(this.delComdify(item.costTotal)) - Number(this.delComdify(item.costTotalVat))
            })
          }else {
            this.thingsList.forEach(item => {
              costTotal += Number(this.delComdify(item.costTotal))
            })
          }
          return costTotal.toFixed(2)
        }
      },
      // 价税合计
      ptotal2() {
        if(this.ofoFlowWork.thingtype && this.ofoFlowWork.workkindmanagetype != '0') {
          let total = 0
          if(this.isTax) {
            this.thingsList.forEach(item => {
              total = total + Number(this.delComdify(item.total))
            })
          }else {
            this.thingsList.forEach(item => {
              total = total + Number(this.delComdify(item.total)) + Number(this.delComdify(item.totalVat))
            })
          }
          return total.toFixed(2)
        }
      },
      // 成本价税合计
      ctotal2() {
        if(this.ofoFlowWork.thingtype && this.ofoFlowWork.workkindmanagetype != '0') {
          let costTotal = 0
          if(this.isTax) {
            this.thingsList.forEach(item => {
              costTotal = costTotal + Number(this.delComdify(item.costTotal))
            })
          }else {
            this.thingsList.forEach(item => {
              costTotal = costTotal + Number(this.delComdify(item.costTotal)) + Number(this.delComdify(item.costTotalVat))
            })
          }
          return costTotal.toFixed(2)
        }
      }
    },
    watch: {
      'isTax': {
        handler(newValue, oldValue) {
          if(oldValue) { // 含税 -> 不含税
            this.productsList.forEach(item => {
              // console.log(item.total);
              let oldMoneyTax = this.delComdify(item.total)
              let oldMoneyCostTax = this.delComdify(item.costTotal)
              item.total = this.comdify(oldMoneyTax - this.delComdify(item.totalVat))
              item.costTotal = this.comdify(oldMoneyCostTax - this.delComdify(item.costTotalVat))
              if(item.quantity) {
                item.price = this.comdify(this.delComdify(item.total) / item.quantity)
                item.cost = this.comdify(this.delComdify(item.costTotal) / item.quantity)
              }

            })
          }else { // 不含税 -> 含税
            this.productsList.forEach(item => {
              // console.log(item.total);
              let oldMoneyTax = this.delComdify(item.total)
              let oldMoneyCostTax = this.delComdify(item.costTotal)
              item.total = this.comdify(Number(oldMoneyTax) + Number(this.delComdify(item.totalVat)))
              item.costTotal = this.comdify(Number(oldMoneyCostTax) + Number(this.delComdify(item.costTotalVat)))
              if(item.quantity) {
                item.price = this.comdify(this.delComdify(item.total) / item.quantity)
                item.cost = this.comdify(this.delComdify(item.costTotal) / item.quantity)
              }
            })
          }
        },
        deep: true
      },
      'productsList': {
        handler(newValue, oldValue) {
          // console.log('新');
          // console.log(JSON.parse(JSON.stringify(newValue)));
          // console.log('旧');
          // console.log(JSON.parse(JSON.stringify(oldValue)));
          let list = []
          // let data = []
          // newValue.forEach(item => {
          //   data.push(item)
          // })
          // let data = Object.assign([], this.productsList)
          let data = JSON.parse(JSON.stringify(newValue))
          const flattenedArray = this.getOneArr(data);
          // console.log('=============');

          // console.log(JSON.parse(JSON.stringify(flattenedArray)));
          flattenedArray.forEach((item, index) => {
            let obj = {}
            obj.cbowhId = item.cbowhId
            obj.cbowhName = item.cbowhName
            obj.cbowhTo = item.cbowhTo
            obj.cbowhToName = item.cbowhToName
            obj.bzxs = item.bzxs
            obj.bzdw = item.bzdw
            obj.bzsl = item.bzsl
            obj.ofrresourceId = item.ofrresourceId
            obj.ofrresourceName = item.ofrresourceName
            obj.quantity = item.quantity
            obj.cost = ''
            // 交易类型为基础
            obj.vatgroup = (this.ofoFlowDeal.dealtype == '4' || this.ofoFlowDeal.dealtype == '3') ? '0' : item.vatgroup
            obj.invoicetype = (this.ofoFlowDeal.dealtype == '4') ? '0' : item.invoicetype
            obj.totalVat = (this.ofoFlowDeal.dealtype == '4' || this.ofoFlowDeal.dealtype == '3') ? '0' : this.delComdify(item.totalVat)
            obj.isVat = '0'
            // obj.cost = item.cost
            // obj.costTotal = item.costTotal
            obj.costTotalVat = this.delComdify(item.costTotalVat)
            obj.beginValue = item.beginValue
            obj.endValue = item.endValue
            obj.beginValue = item.beginValue
            obj.endValue = item.endValue
            obj.baseOfoWorkResourceId = item.baseOfoWorkResourceId
            obj.ofoWorkResourceId = item.ofoWorkResourceId
            obj.baseOfoWorkId = item.baseOfoWorkId
            obj.remark = item.remark
            obj.configValueList = [...item.workConfigList1, ...item.workConfigList2, ...item.workConfigList3, ...item.workConfigList4],
            obj.bomId = item.bomId
            obj.stock = null
            obj.pid = item.pid
            obj.rid = item.rid
            obj.name = item.name
            obj.ggxh = item.ggxh
            obj.jldw = item.jldw
            obj.cbRestypeId = item.cbRestypeId
            obj.uuid = item.uuid
            obj.dimensionList = item.dimensionList ? this.handleDimes(item.dimensionList, true) : []
            if(!this.isTax) {
              let oldMoneyTax = this.delComdify(item.total)
              obj.total = Number(oldMoneyTax) + Number(this.delComdify(item.totalVat))
              let oldMoneyCostTax = this.delComdify(item.costTotal)
              obj.costTotal = Number(oldMoneyCostTax) + Number(this.delComdify(item.costTotalVat))
              if(item.quantity) {
                obj.price = (obj.total / item.quantity).toFixed(this.params.priceAccuracy)
                obj.cost = (obj.costTotal / item.quantity).toFixed(this.params.priceAccuracy)
              }
            }else {
              obj.price = this.delComdify(item.price)
              obj.total = this.delComdify(item.total)
              obj.cost = this.delComdify(item.cost)
              obj.costTotal = this.delComdify(item.costTotal)
            }
            list.push(obj)
          })
          // console.log(list);
          let ptotalObj = {
            ptotal: this.ptotal,
            ptotalNovat: this.ptotalNovat,
            ptotalVat: this.ptotalVat
          }
          let ctotalObj = {
            ctotal: this.ctotal,
            ctotalNovat: this.ctotalNovat,
            ctotalVat: this.ctotalVat
          }
          // this.productsList = list
          let productsList = [list, ptotalObj, ctotalObj]
          // console.log(JSON.parse(JSON.stringify(list)));

          this.$emit('sendProductsList', productsList)
        },
        deep: true
      },
      'thingsList': {
        handler(newValue, oldValue) {
          console.log(newValue);
          let list2 = []
          if(this.thingsList) {
            this.thingsList.forEach(item => {
              this.goodsList.forEach(val => {
                val.ofrThingList.forEach(el => {
                  if(el.ofrThingId == item.ofrthingId) {
                    item.ofrresourceId = val.ofrResourceId
                  }
                })
              })
              let obj = {}
              obj.cbowhId = item.cbowhId
              obj.cbowhName = item.cbowhName
              obj.cbowhTo = item.cbowhTo
              obj.cbowhToName = item.cbowhToName
              obj.bzxs = item.bzxs
              obj.bzdw = item.bzdw
              obj.bzsl = item.bzsl
              obj.ofrresourceId = item.ofrresourceId
              obj.ofrresourceName = item.ofrresourceName
              obj.ofrthingName = item.ofrthingName
              obj.ofrthingId = item.ofrthingId
              obj.quantity = item.quantity
              obj.cost = ''
              obj.vatgroup = (this.ofoFlowDeal.dealtype == '4' || this.ofoFlowDeal.dealtype == '3') ? '0' : item.vatgroup
              obj.invoicetype = (this.ofoFlowDeal.dealtype == '4') ? '0' : item.invoicetype
              obj.totalVat = (this.ofoFlowDeal.dealtype == '4' || this.ofoFlowDeal.dealtype == '3') ? '0' : this.delComdify(item.totalVat)
              obj.isVat = '0'
              // obj.cost = item.cost
              // obj.costTotal = item.costTotal
              obj.costTotalVat = this.delComdify(item.costTotalVat)
              obj.beginValue = item.beginValue
              obj.endValue = item.endValue
              obj.beginValue = item.beginValue
              obj.endValue = item.endValue
              obj.ofoWorkThingId = item.ofoWorkThingId
              obj.baseOfoWorkThingId = item.baseOfoWorkThingId
              obj.baseOfoWorkId = item.baseOfoWorkId
              obj.remark = item.remark
              obj.configValueList = [...item.workConfigList1, ...item.workConfigList2, ...item.workConfigList3, ...item.workConfigList4]
              if(!this.isTax) {
                let oldMoneyTax = this.delComdify(item.total)
                obj.total = Number(oldMoneyTax) + Number(this.delComdify(item.totalVat))
                let oldMoneyCostTax = this.delComdify(item.costTotal)
                obj.costTotal = Number(oldMoneyCostTax) + Number(this.delComdify(item.costTotalVat))
                if(item.quantity) {
                  obj.price = (obj.total / item.quantity).toFixed(this.params.priceAccuracy)
                  obj.cost = (obj.costTotal / item.quantity).toFixed(this.params.priceAccuracy)
                }
              }else {
                obj.price = this.delComdify(item.price)
                obj.total = this.delComdify(item.total)
                obj.cost = this.delComdify(item.cost)
                obj.costTotal = this.delComdify(item.costTotal)
              }
              obj.cbowhName = this.changeCbowh(item.cbowhId)
              obj.uuid = item.uuid
              list2.push(obj)
            })
          }
          let ptotalObj = {
            ptotal: this.ptotal2,
            ptotalNovat: this.ptotalNovat2,
            ptotalVat: this.ptotalVat2
          }
          let ctotalObj = {
            ctotal: this.ctotal2,
            ctotalNovat: this.ctotalNovat2,
            ctotalVat: this.ctotalVat2
          }
          let thingsList = [list2, ptotalObj, ctotalObj]
          this.$emit('sendThingsList', thingsList)
        },
        deep: true
      },
      'disabled': {
        handler(newValue, oldValue) {
          // console.log(newValue);
          if(newValue) {
            this.allShow = true
            this.$nextTick(() => {
              if(this.$refs.noEditTable) {
                this.checkResShow = this.$refs.noEditTable.columns.map(item => {
                  return {
                    label: item.label,
                    value: true,
                    property: item.property
                  }
                }).filter(item => item.label && item.property)
                this.changeResShow()
                this.allShow = false
                // console.log(JSON.parse(JSON.stringify(this.$refs.noEditTable.columns)));
              }
            })
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
::v-deep .icon-no .el-table__expand-icon {
  display: none;
}
.mutiple-contain {
  display: flex;
  .mutiple-left {
    //overflow: auto;
    /* flex-shrink: 0; */
    /* max-height: calc(100vh - 100px); */
    /* background: pink; */
    margin-right: 10px;
    ::v-deep .el-collapse-item__content {
      padding-bottom: 8px;
    }
    ::v-deep .el-collapse-item__header {
      height: 30px;
      line-height: 30px;
    }
  }
  .mutiple-right {
    //flex: 1;
    overflow: auto;
    width: 100%;
  }
}
::v-deep .el-dialog {
  margin: 0 auto;
  /* max-height: calc(100% - 72px); */
  max-height: calc(100% - 72px);
}
::v-deep .el-dialog__body {
  padding: 10px 0 10px 20px;
  /* max-height: calc(100vh - 206px); */
  max-height: calc(100vh - 208px);
  overflow: auto;
}

  ::v-deep .el-table .success-row {
    background: #ecf5ff;
  }
.res-dialog {
  ::v-deep .el-dialog {
    margin: 0 auto;
    max-height: calc(100% - 72px);
    height: auto;
  }
  ::v-deep .el-dialog__body {
    padding: 10px 20px 10px 20px;
    max-height: calc(100vh - 206px);
    height: auto;
    overflow: auto;
  }
}
.right-input {
  ::v-deep .el-input__inner {
    text-align: right;
  }
}
.vatgroup {
  /* color: red; */
  cursor: pointer;
}
.vatgroup:hover {
  color: rgb(32, 160, 255);
}
::v-deep .el-table--border td {
  border-right: 0;
}
.container {
  display: flex;
  justify-content: flex-end; /* 整体靠右 */
  margin-top: 5px;
}
.amount-grid {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  width: 250px;
  text-align: right;
}
.label {
  text-align: right;
}
::v-deep .el-table .hidden-row {
  display: none !important;
}
.input-change {
  ::v-deep .el-input__wrapper {
    border: 1px solid #67c23a !important;
    box-shadow: none !important;
  }
}
::v-deep .el-table .el-table__cell {
  padding: 5px 0 !important;
}
</style>
